/* Kaatje&Mup Agenda — weergave (stap 3). Nog geen verkoop. */
(function () {
  var MAAND = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var MAAND_VOL = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var DAG = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var DAG_KORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var TYPE_EMOJI = { voorstelling: '🎭', knutselcafe: '✂️', zandkaarsen: '🕯️' };
  var TYPE_LABEL = { voorstelling: 'Voorstelling', knutselcafe: 'Knutselcafé', zandkaarsen: 'Zandkaarsen maken' };
  var DAG_MS = 86400000;

  function ic(path) {
    return '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }
  var IC = {
    cal: ic('<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>'),
    groot: ic('<path d="M15 3h6v6M21 3l-7 7M9 21H3v-6M3 21l7-7"/>'),
    klein: ic('<path d="M20 4l-7 7M14 10h6M13 11V5M4 20l7-7M10 14H4M11 13v6"/>'),
    pin: ic('<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>'),
    clock: ic('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
    ticket: ic('<path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 4 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-4Z"/>'),
    check: ic('<path d="M20 6 9 17l-5-5"/>'),
    lock: ic('<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>'),
    ext: ic('<path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>'),
    chev: ic('<path d="m6 9 6 6 6-6"/>'),
    phone: ic('<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/>'),
    globe: ic('<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>'),
    x: ic('<path d="M18 6 6 18M6 6l12 12"/>'),
    share: ic('<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/>'),
    wa: ic('<path d="M21 11.5a8.4 8.4 0 0 1-12.3 7.4L3 21l2.2-5.6A8.4 8.4 0 1 1 21 11.5Z"/>'),
    mail: ic('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>'),
    link: ic('<path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/>'),
    download: ic('<path d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16"/>'),
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>',
    flame: ic('<path d="M12 3c1 3 4 4 4 7.5A4 4 0 0 1 8 11c0-1.4.5-2.4 1-3 .3 1 .8 1.5 1.5 1.7C10 8 10.5 5.5 12 3z"/>'),
    tag: ic('<path d="M4 4h7l9 9-7 7-9-9z"/><circle cx="8" cy="8" r="1.2" fill="currentColor" stroke="none"/>'),
    fb: '<svg class="ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 22v-8h2.7l.4-3H13V9.1c0-.9.3-1.5 1.6-1.5H16V5c-.3 0-1.2-.1-2.3-.1-2.3 0-3.8 1.4-3.8 3.9V11H7.5v3H10v8z"/></svg>',
    xlogo: '<svg class="ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.53 3H20.5l-6.48 7.4L21.7 21h-5.98l-4.68-6.12L5.7 21H2.72l6.93-7.92L2.3 3h6.13l4.23 5.6z"/></svg>',
    masks: ic('<path d="M4 5h10v4.5a5 5 0 0 1-10 0z"/><circle cx="7.5" cy="8" r="0.7" fill="currentColor" stroke="none"/><circle cx="10.5" cy="8" r="0.7" fill="currentColor" stroke="none"/><path d="M7.4 10.6a2.6 2.6 0 0 0 3.2 0"/><path d="M15 8.5h4a1 1 0 0 1 1 1v3a5 5 0 0 1-6 4.9"/>'),
    scissors: ic('<circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.12 15.88"/><path d="M14.47 14.48 20 20"/><path d="M8.12 8.12 12 12"/>'),
    palette: ic('<path d="M12 3a9 9 0 1 0 0 18 2 2 0 0 0 2-2 2 2 0 0 1 2-2h1a4 4 0 0 0 4-4 9 9 0 0 0-9-9z"/><circle cx="7.5" cy="10.5" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="7.5" r="1" fill="currentColor" stroke="none"/><circle cx="16" cy="10.5" r="1" fill="currentColor" stroke="none"/>'),
    ig: ic('<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>'),
    cart: ic('<circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><path d="M2.5 4H5l2.2 11.2a1.2 1.2 0 0 0 1.2 1h8.3a1.2 1.2 0 0 0 1.2-.95L20.5 8H6"/>'),
    usercheck: ic('<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="m16 11 2 2 4-4"/>'),
    user: ic('<circle cx="12" cy="8" r="4"/><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>'),
    gift: ic('<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C9 3 11 5 12 8c1-3 3-5 4.5-5a2.5 2.5 0 0 1 0 5"/>')
  };

  // Heeft een locatie geen logo, dan zetten we haar naam als tekstlogo op dezelfde plek, zodat de kolom
  // niet leeg blijft (14-10-2026, Carolien: "ik mis de logo's bij ikc duinterpen" en "Wil je het woord
  // ICK Duinterpen hier een soort logo tekst van maken en die rechts in de kolom zetten waar eigenlijk
  // het logo hoort te staan"). Zij koos de eenvoudige vorm: alleen de naam, over twee regels gebroken
  // op de eerste spatie, zodat "IKC Duinterpen" netjes onder elkaar staat.
  function tekstLogo(naam) {
    naam = String(naam || '').trim();
    if (!naam) return '';
    var ruimte = naam.indexOf(' ');
    var tekst = ruimte > 0 ? esc(naam.slice(0, ruimte)) + '<br>' + esc(naam.slice(ruimte + 1)) : esc(naam);
    return '<span class="kmtekstlogo">' + tekst + '</span>';
  }

  // De knop Heb jij een plek voor ons opent het venster met de tekst van Boek ons (14-10-2026, C954).
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-km-locatie]');
    var ov = document.querySelector('[data-km-locatie-ov]');
    if (!ov) return;
    if (open) { ov.hidden = false; return; }
    if (e.target.closest && (e.target.closest('[data-km-locatie-dicht]') || e.target === ov)) ov.hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ov = document.querySelector('[data-km-locatie-ov]');
    if (ov && !ov.hidden) ov.hidden = true;
  });

  var MAPSVG = '<svg class="kmmap-bg" viewBox="0 0 400 170" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="400" height="170" fill="#EAF2F6"/><g fill="#DCEAF0"><rect x="18" y="16" width="86" height="30" rx="3"/><rect x="150" y="60" width="104" height="40" rx="3"/><rect x="300" y="112" width="78" height="40" rx="3"/><rect x="30" y="112" width="70" height="34" rx="3"/></g><g stroke="#C6DCE7" stroke-width="7" fill="none" stroke-linecap="round"><path d="M0 54 H400"/><path d="M0 108 H400"/><path d="M118 0 V170"/><path d="M270 0 V170"/></g><g stroke="#B7D0DD" stroke-width="2" fill="none"><path d="M0 82 H400"/><path d="M196 0 V170"/></g></svg>';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;'); }

  // Shopify rich-text JSON -> HTML (met terugval op platte tekst/HTML)
  function richText(val) {
    if (!val) return '';
    var root;
    try { root = JSON.parse(val); } catch (e) { return val; }
    if (!root || root.type !== 'root') return val;
    function inline(nodes) {
      return (nodes || []).map(function (n) {
        if (n.type === 'text') {
          var t = esc(n.value);
          if (n.bold) t = '<strong>' + t + '</strong>';
          if (n.italic) t = '<em>' + t + '</em>';
          return t;
        }
        if (n.type === 'link') return '<a href="' + esc(n.url) + '"' + (/^https?:/.test(n.url || '') ? ' target="_blank" rel="noopener"' : '') + '>' + inline(n.children) + '</a>';
        return '';
      }).join('');
    }
    function block(nodes) {
      return (nodes || []).map(function (n) {
        if (n.type === 'paragraph') return '<p>' + inline(n.children) + '</p>';
        if (n.type === 'heading') { var l = Math.min(n.level || 3, 6); return '<h' + l + '>' + inline(n.children) + '</h' + l + '>'; }
        if (n.type === 'list') { var tag = n.listType === 'ordered' ? 'ol' : 'ul'; return '<' + tag + '>' + (n.children || []).map(function (li) { return '<li>' + inline(li.children) + '</li>'; }).join('') + '</' + tag + '>'; }
        return '';
      }).join('');
    }
    return block(root.children);
  }
  // De tijden van een evenement zijn Nederlandse kloktijden: 14:00 betekent
  // 14:00 in Lemmer, niet 14:00 op de telefoon van de bezoeker. Daarom rekenen
  // we hier ook met de Nederlandse klok. Anders zou iemand die vanuit een andere
  // tijdzone kijkt een ander tarief of een andere stand te zien krijgen dan jij
  // bedoelt. Dan zou de agenda ook iets anders zeggen dan de prijs-sync, die
  // uitdrukkelijk in Europe/Amsterdam rekent.
  function nuNL() {
    var d = new Date();
    try {
      var t = d.toLocaleString('en-CA', {
        timeZone: 'Europe/Amsterdam', hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var m = t.match(/(\d{4})-(\d{2})-(\d{2})\D+(\d{1,2}):(\d{2}):(\d{2})/);
      if (!m) return d;
      var u = +m[4]; if (u === 24) u = 0; // sommige browsers schrijven middernacht als 24
      return new Date(+m[1], +m[2] - 1, +m[3], u, +m[5], +m[6]);
    } catch (e) { return d; }
  }
  function parseDate(iso) { if (!iso) return null; var p = iso.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  // Loopt een activiteit over meerdere dagen (einddatum, bijvoorbeeld een minitoernee),
  // dan is hij pas afgelopen na de laatste dag (2-10-2026).
  function eventEnd(ev) {
    var d = parseDate(ev.einddatum || ev.datum); if (!d) return null;
    var t = (ev.eindtijd || '23:59').split(':');
    d.setHours(+t[0] || 23, +t[1] || 59, 0, 0); return d;
  }
  function fmtChip(ev) { var d = parseDate(ev.datum); return d ? d.getDate() + ' ' + MAAND[d.getMonth()] : ''; }
  function dagdeel(ev) {
    if (!ev.begintijd) return '';
    var h = parseInt(ev.begintijd.split(':')[0], 10);
    if (isNaN(h)) return '';
    return h < 12 ? 'ochtend' : (h < 18 ? 'middag' : 'avond');
  }
  // Een datum breekt alleen af bij "en", "tot en met" of het puntje, nooit tussen dag, maand en jaar (2-10-2026).
  function heel(s) {
    return String(s || '')
      .replace(/ (?=\d)/g, '\u00A0')
      .replace(new RegExp('(\\d) (?=(' + MAAND_VOL.join('|') + '))', 'g'), '$1\u00A0');
  }
  function fmtLong(ev) { return heel(fmtLongRuw(ev)); }
  function fmtLongRuw(ev) {
    var d = parseDate(ev.datum); if (!d) return '';
    var e = parseDate(ev.einddatum);
    if (e && e > d) {
      // Meerdere dagen: "Maandag 29 september tot en met vrijdag 10 oktober 2025".
      var dv = DAG[d.getDay()].charAt(0).toUpperCase() + DAG[d.getDay()].slice(1);
      var jaarVan = d.getFullYear() !== e.getFullYear() ? ' ' + d.getFullYear() : '';
      // Twee dagen achter elkaar: "Woensdag 7 en donderdag 8 oktober 2026" (Carolien, 2-10-2026).
      if (Math.round((e - d) / DAG_MS) === 1) {
        var zelfdeMaand = d.getMonth() === e.getMonth() && !jaarVan;
        return dv + ' ' + d.getDate() + (zelfdeMaand ? '' : ' ' + MAAND_VOL[d.getMonth()] + jaarVan) + ' en ' + DAG[e.getDay()] + ' ' + e.getDate() + ' ' + MAAND_VOL[e.getMonth()] + ' ' + e.getFullYear();
      }
      return dv + ' ' + d.getDate() + ' ' + MAAND_VOL[d.getMonth()] + jaarVan + ' tot en met ' + DAG[e.getDay()] + ' ' + e.getDate() + ' ' + MAAND_VOL[e.getMonth()] + ' ' + e.getFullYear();
    }
    var wd = DAG[d.getDay()].charAt(0).toUpperCase() + DAG[d.getDay()].slice(1) + dagdeel(ev);
    return wd + ' ' + d.getDate() + ' ' + MAAND_VOL[d.getMonth()] + ' ' + d.getFullYear();
  }
  function fmtTime(ev) { return ev.begintijd ? ev.begintijd + (ev.eindtijd ? '\u2060–\u2060' + ev.eindtijd : '') : ''; }
  function fmtCardDate(ev) {
    var d = parseDate(ev.datum); if (!d) return '';
    var s = DAG_KORT[d.getDay()].charAt(0).toUpperCase() + DAG_KORT[d.getDay()].slice(1) + ' ' + d.getDate() + ' ' + MAAND_VOL[d.getMonth()] + ' ' + d.getFullYear();
    if (ev.begintijd) s += ' · ' + ev.begintijd + (ev.eindtijd ? '–' + ev.eindtijd : '');
    return s;
  }
  function typeLabel(ev) {
    var labels = (ev.type || []).map(function (t) { return TYPE_LABEL[t] || t; });
    if (labels.length <= 1) return labels.join('');
    var rest = labels.slice(1).map(function (l) { return l.charAt(0).toLowerCase() + l.slice(1); });
    return labels[0] + ' en ' + rest.join(' en ');
  }
  function euro(n) { return '€' + Number(n).toFixed(2).replace('.', ','); }
  function cardPlace(ev) {
    var l = ev.locatie || {};
    if (!l.naam) return l.plaats || '';
    if (!l.plaats || l.naam === l.plaats) return l.naam;
    // 'Beachclub Lemmer · Lemmer' leest dubbelop. Staat de plaats al in de naam,
    // dan is de naam alleen genoeg.
    if (l.naam.toLowerCase().indexOf(l.plaats.toLowerCase()) >= 0) return l.naam;
    return l.naam + ' · ' + l.plaats;
  }

  // Prijstrap: welk tarief geldt nu + volgend omslagmoment
  function priceTier(ev, cfg) {
    var day = parseDate(ev.datum); if (!day) return null;
    var eventMidnight = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0);
    var voorStart = new Date(eventMidnight.getTime() - 7 * DAG_MS);
    var now = nuNL();
    var pv = ev._prijzen || cfg;
    var pVroeg = +pv.prijs_vroegboek || cfg.prijs_vroegboek;
    var pVoor = +pv.prijs_voorverkoop || cfg.prijs_voorverkoop;
    var pDeur = +pv.prijs_deur || cfg.prijs_deur;
    if (now < voorStart) return { fase: 'vroegboek', label: 'Vroegboek', prijs: pVroeg, tot: voorStart, volgend: 'voorverkoop' };
    if (now < eventMidnight) return { fase: 'voorverkoop', label: 'Voorverkoop', prijs: pVoor, tot: eventMidnight, volgend: 'aan de deur' };
    return { fase: 'deur', label: 'Aan de deur', prijs: pDeur, tot: null, volgend: null };
  }

  function initAgenda(root) {
    var dataEl = root.querySelector('[data-km-data]');
    var cfgEl = root.querySelector('[data-km-config]');
    var events, cfg;
    try { events = JSON.parse(dataEl.textContent) || []; } catch (e) { events = []; }
    try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; }
    var crossData = [];
    try { var cxEl = root.querySelector('[data-km-crosssell]'); if (cxEl) crossData = (JSON.parse(cxEl.textContent) || []).filter(Boolean); } catch (e) { crossData = []; }
    var kraamData = [];
    try { var krEl = root.querySelector('[data-km-kraam]'); if (krEl) kraamData = (JSON.parse(krEl.textContent) || []).filter(Boolean); } catch (e) { kraamData = []; }
    var knutselData = [];
    try { var knEl = root.querySelector('[data-km-knutsel]'); if (knEl) knutselData = (JSON.parse(knEl.textContent) || []).filter(Boolean); } catch (e) { knutselData = []; }
    // Staat er alleen de muur Hier speelden we al op deze pagina (zoals op Boek ons), dan hoeft de rest
    // van de agenda niet opgebouwd te worden: er is geen lijst, geen filter en geen kaartjeskiezer
    // (14-10-2026, C953). Zonder deze afslag loopt de opbouw stuk op elementen die er niet zijn.
    if (!root.querySelector('[data-km-grid]') && root.querySelector('[data-km-wall]')) {
      var nuM = nuNL();
      vulMuur(events.filter(function (ev) { var e = eventEnd(ev); return e && e < nuM; }));
      return;
    }
    cfg.prijs_vroegboek = +cfg.prijs_vroegboek || 7.5;
    cfg.prijs_voorverkoop = +cfg.prijs_voorverkoop || 8.5;
    cfg.prijs_deur = +cfg.prijs_deur || 9.5;

    // Solo-stand: één voorstelling, rechtstreeks in de pagina.
    var soloHandle = root.getAttribute('data-km-solo') || '';
    var soloMode = !!soloHandle;

    var grid = root.querySelector('[data-km-grid]');
    var emptyEl = root.querySelector('[data-km-empty]');
    var countEl = root.querySelector('[data-km-count]');
    var filterWrap = root.querySelector('[data-km-filters]');
    var searchEl = root.querySelector('[data-km-search]');
    var modal = root.querySelector('[data-km-modal]');
    var modalContent = root.querySelector('[data-km-modal-content]');

    var startView = (grid && grid.getAttribute('data-km-startview')) || '4';
    var maandView = null; // welke maand de kalender toont; wordt gezet bij het eerste gebruik
    var weekView = null;  // welke week de weekweergave toont (altijd een maandag)
    var behoudPeriode = false; // zet de knoppen 'deze week/maand' de periode zelf? dan niet resetten
    var herstelDatumknop = null; // wordt gevuld door de datumkiezer, zodat de kalender hem kan bijwerken
    var state = { tab: 'komst', q: '', types: [], soorten: [], plaatsen: [], jaren: [], dateFrom: null, dateTo: null, view: startView };
    var countdownTimers = [];

    function soortCat(ev) { return ev.toegang === 'kaartverkoop' ? 'kaartverkoop' : ev.toegang === 'besloten' ? 'besloten' : 'gratis'; }
    var SOORT_LABEL = { kaartverkoop: 'Kaartverkoop', gratis: 'Gratis', besloten: 'Besloten' };

    // Zoektekst per evenement, één keer klaargezet in plaats van bij elke toetsaanslag.
    // Er wordt nu ook in de omschrijvingen en in het soort activiteit gezocht: wie
    // 'zandkaars' of 'krimpfolie' intikt vindt de middag waar dat gebeurt, ook als
    // het woord niet in de titel staat.
    function plat(v) { return richText(v).replace(/<[^>]+>/g, ' '); }
    events.forEach(function (ev) {
      var l = ev.locatie || {};
      ev._zoek = [
        ev.titel, l.naam, l.plaats, l.host_naam, typeLabel(ev),
        plat(ev.beschrijving), plat(ev.over_voorstelling), plat(ev.over_knutselcafe),
        plat(l.over_locatie), l.adres, (ev.speeldagen || []).join(' ')
      ].filter(Boolean).join(' ').replace(/\s+/g, ' ').toLowerCase();
      // Plaatsen van deze activiteit: de plaats van de locatie en bij een toernee de plaatsen uit
      // de speeldagen ("Jokidé Ring, Nagele" geeft Nagele), zodat het plaatsfilter ze vindt (2-10-2026).
      ev._plaatsen = [];
      if (l.plaats) ev._plaatsen.push(l.plaats);
      (ev.speeldagen || []).forEach(function (r) { var plek = String(r || '').split('|')[1] || ''; var pl = plek.split(',').pop().trim(); if (pl && ev._plaatsen.indexOf(pl) < 0) ev._plaatsen.push(pl); });
    });

    // Filteropties uit de data
    var allTypes = [], allPlaatsen = [], allSoorten = [], eventDays = {};
    events.forEach(function (ev) {
      (ev.type || []).forEach(function (t) { if (allTypes.indexOf(t) < 0) allTypes.push(t); });
      (ev._plaatsen || []).forEach(function (pl) { if (allPlaatsen.indexOf(pl) < 0) allPlaatsen.push(pl); });
      var sc = soortCat(ev); if (allSoorten.indexOf(sc) < 0) allSoorten.push(sc);
      if (ev.datum) eventDays[ev.datum] = true;
    });
    allPlaatsen.sort();
    allSoorten.sort(function (a, b) { return ['kaartverkoop', 'gratis', 'besloten'].indexOf(a) - ['kaartverkoop', 'gratis', 'besloten'].indexOf(b); });

    function multi(icon, labelAll, labelShort, opts, key, labeller, kop) {
      var wrap = document.createElement('div'); wrap.className = 'kmmulti';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'kmfbtn' + (kop ? ' kmfbtn--kop' : '');
      function refresh() {
        var n = state[key].length;
        if (kop) {
          // Variant B (2-10-2026): klein kopje erboven, daaronder wat er gekozen is.
          var gekozen = n === 0 ? labelAll : n === 1 ? (labeller ? labeller(state[key][0]) : state[key][0]) : n + ' gekozen';
          btn.innerHTML = '<span class="kmftekst"><span class="kmfkop">' + esc(kop) + '</span><span class="kmflabel">' + esc(gekozen) + '</span></span><span class="chev">' + IC.chev + '</span>';
        } else {
          btn.innerHTML = (icon || '') + '<span class="kmflabel">' + esc(n ? labelShort + ' (' + n + ')' : labelAll) + '</span><span class="chev">' + IC.chev + '</span>';
        }
        btn.classList.toggle('act', n > 0);
      }
      wrap._refresh = function () { refresh(); };
      var pop = document.createElement('div'); pop.className = 'kmpop kmmultipop';
      opts.forEach(function (o) {
        var lab = document.createElement('label'); lab.className = 'kmcheck';
        var cb = document.createElement('input'); cb.type = 'checkbox'; cb.value = o;
        cb.addEventListener('change', function () {
          if (cb.checked) state[key].push(o); else state[key] = state[key].filter(function (x) { return x !== o; });
          refresh(); render();
        });
        lab.appendChild(cb); lab.appendChild(document.createTextNode(' ' + (labeller ? labeller(o) : o)));
        pop.appendChild(lab);
      });
      btn.addEventListener('click', function (e) { e.stopPropagation(); var wasOpen = pop.classList.contains('open'); closePops(); if (!wasOpen) pop.classList.add('open'); });
      wrap.appendChild(btn); wrap.appendChild(pop); refresh();
      return wrap;
    }
    function closePops() { root.querySelectorAll('.kmpop.open').forEach(function (p) { p.classList.remove('open'); }); }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.kmpop')) return; closePops(); });

    function fmtShortD(d) { return d.getDate() + ' ' + MAAND[d.getMonth()]; }
    function datePicker() {
      var wrap = document.createElement('div'); wrap.className = 'kmdatewrap';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'kmfbtn';
      var pop = document.createElement('div'); pop.className = 'kmpop kmdatepop';
      var view = nuNL(); view.setDate(1);
      herstelDatumknop = function () { refreshBtn(); drawPop(); };
      function refreshBtn() {
        var label = 'Datum';
        if (state.dateFrom && state.dateTo) label = fmtShortD(state.dateFrom) + ' – ' + fmtShortD(state.dateTo);
        else if (state.dateFrom) label = 'Vanaf ' + fmtShortD(state.dateFrom);
        btn.innerHTML = IC.cal + '<span>' + esc(label) + '</span><span class="chev">' + IC.chev + '</span>';
        btn.classList.toggle('act', !!(state.dateFrom || state.dateTo));
      }
      function setPreset(kind) {
        var now = nuNL(); now.setHours(0, 0, 0, 0);
        if (kind === 'week') { var day = (now.getDay() + 6) % 7; state.dateFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - day); state.dateTo = new Date(state.dateFrom.getFullYear(), state.dateFrom.getMonth(), state.dateFrom.getDate() + 6); }
        else if (kind === 'maand') { state.dateFrom = new Date(now.getFullYear(), now.getMonth(), 1); state.dateTo = new Date(now.getFullYear(), now.getMonth() + 1, 0); }
        else { state.dateFrom = new Date(now.getFullYear(), now.getMonth() + 1, 1); state.dateTo = new Date(now.getFullYear(), now.getMonth() + 2, 0); }
        view = new Date(state.dateFrom); view.setDate(1);
        // De knop kiest ook meteen de bijpassende weergave: 'deze week' laat de week
        // zien, de twee maandknoppen de maandkalender. Anders zou je een periode
        // kiezen en er nog steeds een rij tegels bij krijgen, wat niets zegt over
        // welke dagen bezet zijn. De weergavekiezer blijft staan, dus één klik terug.
        behoudPeriode = true;
        if (kind === 'week') { weekView = weekStart(state.dateFrom); zetWeergaveKlassen('week'); }
        else { maandView = new Date(state.dateFrom.getFullYear(), state.dateFrom.getMonth(), 1); zetWeergaveKlassen('maand'); }
        behoudPeriode = false;
        drawPop(); refreshBtn(); render();
      }
      function pickDay(d) {
        if (!state.dateFrom || (state.dateFrom && state.dateTo)) { state.dateFrom = d; state.dateTo = null; }
        else if (d < state.dateFrom) { state.dateTo = state.dateFrom; state.dateFrom = d; }
        else state.dateTo = d;
        drawPop(); refreshBtn(); render();
      }
      function clearDates() { state.dateFrom = null; state.dateTo = null; drawPop(); refreshBtn(); render(); }
      function drawPop() {
        var y = view.getFullYear(), m = view.getMonth();
        var startDay = (new Date(y, m, 1).getDay() + 6) % 7, days = new Date(y, m + 1, 0).getDate();
        var pres = [['week', 'Deze week'], ['maand', 'Deze maand'], ['volgende', 'Volgende maand']];
        var h = '<div class="kmpresets">' + pres.map(function (p) { return '<button type="button" class="kmpre" data-preset="' + p[0] + '">' + p[1] + '</button>'; }).join('') + '</div>';
        h += '<div class="kmcalhead"><button type="button" class="kmnav" data-nav="-1">‹</button><span class="kmcalm">' + MAAND_VOL[m].charAt(0).toUpperCase() + MAAND_VOL[m].slice(1) + ' ' + y + '</span><button type="button" class="kmnav" data-nav="1">›</button></div>';
        h += '<div class="kmcalgrid">' + ['M', 'D', 'W', 'D', 'V', 'Z', 'Z'].map(function (w) { return '<div class="kmwd">' + w + '</div>'; }).join('');
        for (var i = 0; i < startDay; i++) h += '<div class="kmdaycell empty"></div>';
        for (var dd = 1; dd <= days; dd++) {
          var cur = new Date(y, m, dd), iso = y + '-' + ('0' + (m + 1)).slice(-2) + '-' + ('0' + dd).slice(-2), cls = 'kmdaycell';
          if (eventDays[iso]) cls += ' ev';
          if (state.dateFrom && state.dateTo && cur >= state.dateFrom && cur <= state.dateTo) cls += (cur.getTime() === state.dateFrom.getTime() || cur.getTime() === state.dateTo.getTime()) ? ' edge' : ' inr';
          else if (state.dateFrom && !state.dateTo && cur.getTime() === state.dateFrom.getTime()) cls += ' edge';
          h += '<button type="button" class="' + cls + '" data-day="' + iso + '">' + dd + '</button>';
        }
        h += '</div>';
        var rangeTxt = state.dateFrom ? (fmtShortD(state.dateFrom) + (state.dateTo ? ' – ' + fmtShortD(state.dateTo) : ' – kies nu de einddatum')) : 'Kies zelf een begin- en einddatum';
        h += '<div class="kmdatefoot"><span class="kmrange">' + esc(rangeTxt) + '</span><button type="button" class="kmclear">Wissen</button></div>';
        pop.innerHTML = h;
      }
      pop.addEventListener('click', function (e) {
        e.stopPropagation();
        var t = e.target.closest('[data-preset],[data-nav],[data-day],.kmclear'); if (!t) return;
        if (t.getAttribute('data-preset')) setPreset(t.getAttribute('data-preset'));
        else if (t.getAttribute('data-nav')) { view.setMonth(view.getMonth() + parseInt(t.getAttribute('data-nav'), 10)); drawPop(); }
        else if (t.getAttribute('data-day')) { var p = t.getAttribute('data-day').split('-'); pickDay(new Date(+p[0], +p[1] - 1, +p[2])); }
        else if (t.classList.contains('kmclear')) clearDates();
      });
      btn.addEventListener('click', function (e) { e.stopPropagation(); var open = pop.classList.contains('open'); closePops(); if (!open) { drawPop(); pop.classList.add('open'); } });
      wrap.appendChild(btn); wrap.appendChild(pop); refreshBtn();
      return wrap;
    }

    // Filters variant B (Carolien, 2-10-2026): zoekvak met drie keuzelijstjes op één rij, Wat,
    // Kaartjes en Plaats, met een klein kopje erboven. De datumkiezer staat uit (code blijft).
    if (allTypes.length) filterWrap.appendChild(multi(IC.masks, 'Alles', 'Wat', allTypes, 'types', function (t) { return TYPE_LABEL[t] || t; }, 'Wat'));
    if (allSoorten.length) filterWrap.appendChild(multi(IC.tag, 'Alles', 'Kaartjes', allSoorten, 'soorten', function (s) { return SOORT_LABEL[s] || s; }, 'Kaartjes'));
    if (allPlaatsen.length) filterWrap.appendChild(multi(IC.pin, 'Alles', 'Plaats', allPlaatsen, 'plaatsen', null, 'Plaats'));
    // Onder de rij: hoeveel er gevonden zijn en Wis alle filters.
    var paneelVoet = document.createElement('div'); paneelVoet.className = 'kmpvoet';
    paneelVoet.innerHTML = '<span data-km-pcount></span><button type="button" class="kmpwis" data-km-pwis hidden>Wis alle filters</button>';
    var paneelEl = root.querySelector('[data-km-paneel]'); if (paneelEl) paneelEl.appendChild(paneelVoet);
    paneelVoet.querySelector('[data-km-pwis]').addEventListener('click', function () {
      state.types = []; state.soorten = []; state.plaatsen = []; state.q = ''; if (searchEl) searchEl.value = '';
      filterWrap.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = false; });
      filterWrap.querySelectorAll('.kmmulti').forEach(function (m) { if (m._refresh) m._refresh(); });
      render();
    });
    // Jaarfilter, alleen bij Afgelopen (2-10-2026, C614): wie terugkijkt wil per jaar
    // kunnen zoeken. Bij Op de planning zegt een jaartal niets, dus dan staat hij uit.
    var allJaren = [];
    events.forEach(function (ev) {
      var e = eventEnd(ev);
      if (e && e < nuNL() && ev.datum) { var y = ev.datum.slice(0, 4); if (allJaren.indexOf(y) < 0) allJaren.push(y); }
    });
    allJaren.sort().reverse();
    // Het jaar kies je met knoppen bovenin, niet meer in het filterpaneel (2-10-2026).
    var jaarFilter = null;
    var jarenEl = root.querySelector('[data-km-jaren]');
    function tekenJaren() {
      if (!jarenEl) return;
      jarenEl.hidden = !(state.tab === 'geweest' && allJaren.length > 1);
      var gekozen = state.jaren[0] || '';
      jarenEl.innerHTML = [''].concat(allJaren).map(function (y) {
        return '<button type="button" class="kmjaar' + (y === gekozen ? ' on' : '') + '" data-km-jaar="' + y + '">' + (y || 'Alle jaren') + '</button>';
      }).join('');
    }
    if (jarenEl) {
      jarenEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-km-jaar]'); if (!b) return;
        var y = b.getAttribute('data-km-jaar');
        state.jaren = y ? [y] : [];
        tekenJaren(); render();
      });
    }

    // De filters staan achter één knop naast de tabbladen, dan oogt het rustiger.
    var filtersKnop = root.querySelector('[data-km-filtersknop]');
    var paneel = root.querySelector('[data-km-paneel]');
    if (filtersKnop && paneel) {
      filtersKnop.addEventListener('click', function () {
        var open = paneel.hidden;
        paneel.hidden = !open;
        filtersKnop.classList.toggle('open', open);
        filtersKnop.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // De WhatsApp knoppen openen hetzelfde venster als in de voettekst (met de QR code).
    root.addEventListener('click', function (e) {
      var wa = e.target.closest && e.target.closest('[data-km-wa]');
      if (!wa) return;
      var voet = document.querySelector('[data-kmvt-open="wa"]');
      if (voet && !root.contains(voet)) { e.preventDefault(); voet.click(); }
    });

    root.querySelectorAll('[data-km-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-km-tab]').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on'); state.tab = t.getAttribute('data-km-tab');
        if (state.tab !== 'geweest') state.jaren = [];
        tekenJaren();
        render();
      });
    });
    searchEl.addEventListener('input', function () { state.q = searchEl.value.toLowerCase().trim(); render(); });

  /* Het cadeaubericht meekijken terwijl je typt. Het staat hier los van het
     tekstvak zelf omdat de kaartjeskiezer telkens opnieuw wordt opgebouwd; via
     de document-luisteraar werkt het ook na een herbouw. Regelovergangen blijven
     staan (white-space in de stijl), zodat wat je hier ziet hetzelfde is als wat
     er straks op het cadeaubewijs komt. */
  document.addEventListener('input', function (e) {
    var veld = e.target && e.target.closest && e.target.closest('[data-giftmsg]');
    if (!veld) return;
    var box = veld.closest('.kmgift-box');
    if (!box) return;
    var prev = box.querySelector('[data-giftprev]');
    var tekst = box.querySelector('[data-giftprevtekst]');
    if (!prev || !tekst) return;
    var waarde = (veld.value || '').replace(/\n{3,}/g, '\n\n').trim();
    tekst.textContent = waarde ? '\u201C' + waarde + '\u201D' : '';
    prev.hidden = !waarde;
  });

    function matches(ev) {
      var end = eventEnd(ev); var now = nuNL();
      var past = end && end < now;
      if (state.tab === 'komst' && past) return false;
      if (state.tab === 'geweest' && !past) return false;
      if (state.types.length && !(ev.type || []).some(function (t) { return state.types.indexOf(t) >= 0; })) return false;
      if (state.soorten.length && state.soorten.indexOf(soortCat(ev)) < 0) return false;
      if (state.plaatsen.length && !(ev._plaatsen || []).some(function (pl) { return state.plaatsen.indexOf(pl) >= 0; })) return false;
      if (state.jaren.length && state.jaren.indexOf((ev.datum || '').slice(0, 4)) < 0) return false;
      if (state.dateFrom || state.dateTo) {
        var ed = parseDate(ev.datum);
        if (ed) {
          if (state.dateFrom && ed < state.dateFrom) return false;
          if (state.dateTo) { var t2 = new Date(state.dateTo); t2.setHours(23, 59, 59, 999); if (ed > t2) return false; }
        }
      }
      if (state.q && (ev._zoek || '').indexOf(state.q) < 0) return false;
      return true;
    }

    function badge(ev) {
      if (ev.toegang === 'besloten') return '<span class="kmbadge b-closed">' + IC.lock + ' Besloten</span>';
      // Kaartjes die bij een andere partij verkocht worden krijgen een eigen label:
      // wie hierop klikt verlaat straks de site, en dat hoor je vooraf te zien.
      if (ev.toegang === 'kaartverkoop' && ev.externe_ticketlink) return '<span class="kmbadge b-extern">' + IC.ext + ' Kaartverkoop elders</span>';
      if (ev.toegang === 'kaartverkoop') return '<span class="kmbadge b-tickets">' + IC.ticket + ' Kaartverkoop</span>';
      return '<span class="kmbadge b-free">' + IC.check + (ev.toegang === 'gratis-aanmelden' ? ' Gratis · aanmelden' : ' Gratis te bezoeken') + '</span>';
    }

    // Statusbadge: Geweest / Vandaag / Bijna uitverkocht / Uitverkocht.
    // plekken_over komt in stap 4 uit de variant-voorraad; nu meestal null.
    function isTicket(ev) { return ev.toegang === 'kaartverkoop' && !ev.externe_ticketlink; }

    // Wat een betaald kaartje volgens Shopify zelf kost, in euro's. Dit is de prijs
    // die bij het afrekenen ook echt gerekend wordt: de kassa gebruikt altijd de
    // prijs van de variant en nooit iets wat wij hier uitrekenen.
    function variantPrijs(ev) {
      if (!ev.ticket || !ev.ticket.varianten) return null;
      var betaald = ev.ticket.varianten.filter(function (v) { return +v.prijs_cent > 0; });
      if (!betaald.length) return null;
      return (+betaald[0].prijs_cent) / 100;
    }

    // Welke trede van de prijstrap er nu geldt. Staat er een kaartjesproduct aan
    // dit evenement, dan is de variantprijs de waarheid en zoeken we de trede die
    // daarbij hoort: zo kan de pagina nooit iets anders beloven dan de kassa
    // rekent. Is er geen kaartjesproduct, dan is er ook geen geld in het spel en
    // volgen we gewoon de datum.
    function tredes(ev, cfg) {
      var pp = ev._prijzen || cfg;
      return [
        { prijs: (+pp.prijs_vroegboek || cfg.prijs_vroegboek), label: 'vroegboek', sub: 'meer dan een<br>week vooraf', fase: 'vroegboek' },
        { prijs: (+pp.prijs_voorverkoop || cfg.prijs_voorverkoop), label: 'voorverkoop', sub: 'in de<br>laatste week', fase: 'voorverkoop' },
        { prijs: (+pp.prijs_deur || cfg.prijs_deur), label: 'aan de deur', sub: 'op de<br>dag zelf', fase: 'deur' }
      ];
    }
    function geldendTarief(ev, cfg) {
      var opDatum = priceTier(ev, cfg);
      var echt = variantPrijs(ev);
      if (echt === null || !opDatum) return opDatum;
      if (Math.abs(echt - opDatum.prijs) < 0.005) return opDatum;
      // De variantprijs wijkt af van wat de datum zegt: de prijs-sync heeft nog
      // niet gedraaid. Toon dan de trede die bij de échte prijs hoort, zonder
      // aftelklok, want die zou over een verkeerd moment aftellen.
      var bij = tredes(ev, cfg).filter(function (t) { return Math.abs(echt - t.prijs) < 0.005; })[0];
      if (bij) return { fase: bij.fase, label: bij.label, prijs: echt, tot: null, volgend: null, afwijkend: true };
      return { fase: opDatum.fase, label: opDatum.label, prijs: echt, tot: null, volgend: null, afwijkend: true };
    }
    var LAAG = 10; // 'bijna uitverkocht'-drempel (aantal zitplaatsen)
    // Plekken over: live uit de variant-voorraad (Kind + Volwassene; baby telt niet mee), anders het handmatige veld.
    // De kindplekken bepalen of een voorstelling vol is - niet de optelsom van alle
    // kaarttypes. Dat laatste deden we eerst, en dan geldt een zaal van veertig als
    // vol bij honderdtwintig kaartjes, want kind en volwassene hebben elk hun eigen
    // voorraad in Shopify. Een volwassene komt mee met een kind; het kind is de
    // beperkende factor.
    function kindVariant(ev) {
      if (!ev.ticket || !ev.ticket.varianten) return null;
      return ev.ticket.varianten.filter(function (v) { return v.type === 'Kind'; })[0] || null;
    }
    // De speelruimte is het aantal plekken dat de allerlaatste bestelling over het
    // maximum mag gaan, zodat een gezin met vier kinderen nog past als er nog twee
    // plekken vrij zijn. Die plekken staan wel in Shopify - anders zou de kassa de
    // bestelling alsnog weigeren - maar tellen hier niet mee als vrij. Zodra het
    // maximum bereikt is staat de teller op nul en kan er niets meer bij, ook geen
    // een; en verder dan maximum plus speelruimte kan het nooit lopen, want daar
    // houdt Shopify zelf de deur dicht.
    function speelruimte(ev) {
      var n = +ev.speelruimte;
      return (isFinite(n) && n > 0) ? n : 0;
    }
    function plekkenOver(ev) {
      var k = kindVariant(ev);
      if (k) {
        var voorraad = (typeof k.voorraad === 'number') ? k.voorraad : 0;
        return voorraad - speelruimte(ev);
      }
      // Geen kinderkaartje bij deze voorstelling: dan telt gewoon alles wat te koop is.
      if (ev.ticket && ev.ticket.varianten) {
        return ev.ticket.varianten.reduce(function (s, v) {
          return s + (v.prijs_cent ? Math.max(0, (typeof v.voorraad === 'number' ? v.voorraad : 0)) : 0);
        }, 0);
      }
      return (typeof ev.plekken_over === 'number') ? ev.plekken_over : null;
    }
    // Is er buiten de kinderen nog iets te koop? Dan blijft de kiezer open staan,
    // ook al staat de voorstelling op uitverkocht.
    function andersNogPlek(ev) {
      if (!ev.ticket || !ev.ticket.varianten) return false;
      return ev.ticket.varianten.filter(function (v) {
        return v.type !== 'Kind' && v.prijs_cent && (typeof v.voorraad !== 'number' || v.voorraad > 0);
      }).length > 0;
    }

    function statusBadge(ev, past, isToday) {
      if (past) return '<span class="kmbadge b-closed">' + IC.check + ' Afgelopen</span>';
      var o = plekkenOver(ev);
      if (isTicket(ev) && typeof o === 'number') {
        if (o <= 0) return '<span class="kmsold">' + IC.lock + ' Uitverkocht</span>';
        if (!isToday && o <= LAAG) return '<span class="kmsoon">' + IC.flame + ' Bijna uitverkocht</span>';
      }
      if (isToday) return '<span class="kmtoday">' + IC.clock + ' Vandaag · aan de deur</span>';
      return '';
    }

    // Vroegboek (oranje) / voorverkoop-prijschip op de kaart, nooit een aantal plekken.
    function priceChip(ev) {
      if (!isTicket(ev)) return '';
      // Geen prijs beloven als er niets te bestellen valt. Hangt er nog geen
      // kaartjesproduct aan de voorstelling, dan stond hier "Vroegboek EUR 7,50"
      // op de tegel terwijl de pop-up leeg was - een prijs die nergens heen leidt.
      if (!ev.ticket) return '';
      var po = plekkenOver(ev); if (typeof po === 'number' && po <= 0) return '';
      var tier = geldendTarief(ev, cfg); if (!tier) return '';
      if (tier.fase === 'vroegboek') return '<span class="kmtprice early">' + IC.tag + ' Vroegboek ' + euro(tier.prijs) + '</span>';
      if (tier.fase === 'voorverkoop') return '<span class="kmtprice">' + euro(tier.prijs) + ' p.p.</span>';
      return '';
    }

    // Voorraad-nudge in de pop-up (vlak boven de winkelwagen-knop in stap 4).
    function stockBig(ev) {
      if (!isTicket(ev)) return '';
      var o = plekkenOver(ev); if (typeof o !== 'number') return '';
      if (o <= 0) return '<div class="kmstockbig kmstockbig--sold">' + IC.lock + ' Uitverkocht</div>';
      if (o > LAAG) return '';
      return '<div class="kmstockbig">' + IC.flame + ' De laatste kaartjes zijn nu te koop.<br>Wees er snel bij want vol is vol!</div>';
    }

    function tileImg(ev, big) {
      var kls = big ? 'kmmimg ' : 'kmtimg ';
      // Een echte afbeelding in het vak, geen lege div met een achtergrondfoto:
      // het thema heeft in base.css de regel div:empty { display:none }, en dan
      // verdwijnt zo'n vak spoorloos. Bij de tegels viel dat niet op omdat daar
      // de labels in worden gezet, waardoor ze niet leeg zijn; de grote foto in
      // de pop-up was daardoor nooit te zien zodra er een foto bij stond.
      if (ev.foto) return '<div class="' + kls + '"><img src="' + esc(ev.foto) + '" alt="" loading="lazy"></div>';
      var isVoor = (ev.type || []).indexOf('voorstelling') >= 0;
      return '<div class="' + kls + (isVoor ? 'pt' : 'sd') + '">' + (isVoor ? IC.masks : IC.palette) + '</div>';
    }

    // ---- Lijstweergave -------------------------------------------------------
    // Eén regel per evenement over de volle breedte. Wat een bezoeker als eerste
    // wil weten staat van links naar rechts: wanneer, wat, waar en wat je kunt doen.
    function rijDatum(ev, past, isToday) {
      var d = parseDate(ev.datum); if (!d) return '';
      var o = plekkenOver(ev);
      var kl = past ? ' is-past' : isToday ? ' is-today' : (isTicket(ev) && typeof o === 'number' && o <= 0) ? ' is-sold' : '';
      return '<div class="kmrdate' + kl + '"><span class="d">' + d.getDate() + '</span><span class="m">' + esc(MAAND[d.getMonth()]) + '</span></div>';
    }
    // De regel eronder: locatie, tijd en waar het uit bestaat. Alleen tonen wat
    // gevuld is, zodat er nooit een losse punt tussen twee lege stukken staat.
    // zonderTijd: in de weekweergave staat de tijd al in een eigen kolom links,
    // en twee keer 15:00 op een regel leest als een fout.
    function rijMeta(ev, zonderTijd) {
      var d = [];
      var pl = cardPlace(ev); if (pl) d.push(esc(pl));
      var t = zonderTijd ? '' : fmtTime(ev); if (t) d.push(esc(t) + ' uur');
      var tl = typeLabel(ev); if (tl) d.push(esc(tl));
      return d.join('<span class="sep">·</span>');
    }
    // De knop rechts vertelt wat er gebeurt als je erop klikt. De hele regel is
    // klikbaar; de knop is de blikvanger, niet het enige doelwit.
    function rijKnop(ev, past, isToday) {
      if (past) return { tekst: 'Bekijk', kl: 'muted' };
      if (ev.toegang === 'besloten') return { tekst: 'Meer info', kl: 'muted' };
      if (ev.externe_ticketlink) return { tekst: 'Naar de kaartverkoop', kl: 'ghost' };
      if (ev.toegang === 'gratis-aanmelden') return { tekst: 'Aanmelden', kl: '' };
      if (ev.toegang === 'gratis-vrij') return { tekst: 'Meer info', kl: 'ghost' };
      if (isTicket(ev) && !ev.ticket) return { tekst: 'Meer info', kl: 'ghost' };
      var o = plekkenOver(ev);
      if (typeof o === 'number' && o <= 0) {
        return { tekst: cfg.wachtlijst_url ? 'Zet me op de wachtlijst' : 'Hou me op de hoogte', kl: 'ghost' };
      }
      if (isToday) return { tekst: 'Aan de deur', kl: '' };
      return { tekst: 'Koop een kaartje', kl: '' };
    }

    // ---- Nieuwe lijstkaarten (2-10-2026, C614) ----------------------------------
    // Op de planning: een grote kaart met de poster (A4 staand) en de datum erop,
    // in het midden wat, wanneer en waar, en rechts een kolom met wat je moet doen.
    // Afgelopen: dezelfde kaart klein, zonder die kolom. Afspraken van Carolien:
    // geen tikkende klok op de kaart, alleen "Nog 3 dagen"; nooit laten zien hoeveel
    // kaartjes er nog zijn, alleen "Bijna uitverkocht".
    function nogTijd(tot) {
      if (!tot) return '';
      var ms = tot - nuNL(); if (ms <= 0) return '';
      var d = Math.floor(ms / DAG_MS);
      if (d >= 1) return 'Nog ' + d + (d === 1 ? ' dag' : ' dagen');
      var u = Math.max(1, Math.ceil(ms / 3600000));
      return 'Nog ' + u + ' uur';
    }
    function soortPil(ev) {
      if (ev.toegang === 'besloten') return '<span class="kmpil kmpil--grijs">' + IC.lock + ' Besloten</span>';
      if (ev.toegang === 'kaartverkoop' && ev.externe_ticketlink) return '<span class="kmpil kmpil--groen">' + IC.ext + ' Kaartverkoop elders</span>';
      if (ev.toegang === 'kaartverkoop') return '<span class="kmpil kmpil--groen">' + IC.ticket + ' Kaartverkoop</span>';
      return '<span class="kmpil kmpil--blauw">' + (ev.toegang === 'gratis-aanmelden' ? 'Gratis met aanmelden' : 'Gratis') + '</span>';
    }
    function kaartBeeld(ev) {
      var d = parseDate(ev.datum);
      var dat = d ? '<span class="kmdat"><b>' + d.getDate() + '</b><span>' + esc(MAAND[d.getMonth()]) + '</span></span>' : '';
      if (ev.foto) return '<div class="kmkbeeld"><img src="' + esc(ev.foto) + '" alt="" loading="lazy">' + dat + '</div>';
      var isVoor = (ev.type || []).indexOf('voorstelling') >= 0;
      return '<div class="kmkbeeld kmkbeeld--leeg ' + (isVoor ? 'pt' : 'sd') + '">' + (isVoor ? IC.masks : IC.palette) + dat + '</div>';
    }
    function logoKlasse(alt) { return 'kmlg-' + String(alt || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    // De Wyken heeft in zijn bestand nog een losse regel onder het logo staan; die snijden we weg op
    // 64 procent, net onder het blauwe rondje dat tot 167 van de 271 loopt (14-10-2026, C957).
    // Eén plek waar een partnerlogo getekend wordt, zodat het kaartje, de banner en het blok Samen met
    // precies dezelfde maten en dezelfde bijsnede gebruiken (14-10-2026, Carolien: "Dit dan ook op
    // andere plekken doen waar deze logo's staan op de website").
    function partnerLogo(pl) {
      var kl = logoKlasse(pl.alt);
      var img = '<img class="' + kl + '" src="' + esc(pl.src) + '" alt="' + esc(pl.alt || '') + '" loading="lazy">';
      return kl === 'kmlg-logo-obs-de-wyken' ? '<span class="km-bijsnee">' + img + '</span>' : img;
    }
    function partnerRijHtml(ps, klasse, label) {
      if (!ps || !ps.length) return '';
      return '<span class="km-partners ' + klasse + '">'
        + (label ? '<span class="km-partners__h">' + label + '</span>' : '')
        + ps.map(partnerLogo).join('') + '</span>';
    }
    function partnerStrook(l) {
      return partnerRijHtml((l && l.partners) || [], 'km-partners--kaart', 'Samen met');
    }
    function kaartLogos(ev) {
      var l = ev.locatie; if (!l) return '';
      var srcs = [];
      if (l.logo) srcs.push({ src: l.logo, alt: l.host_naam || l.naam || '' });
      (l.partners || []).forEach(function (p) { if (p && p.src) srcs.push(p); });
      if (!srcs.length) return '';
      return '<div class="kmklogos">' + srcs.map(function (p) { return '<img class="' + logoKlasse(p.alt) + '" src="' + esc(p.src) + '" alt="' + escAttr(p.alt || '') + '" loading="lazy">'; }).join('') + '</div>';
    }
    function kaartWanneer(ev) {
      var t = fmtTime(ev);
      return fmtLong(ev) + (t ? '\u00A0· ' + t : '');
    }
    function kaartWaar(ev) {
      var d = [], pl = cardPlace(ev), tl = typeLabel(ev);
      if (pl) d.push(esc(pl)); if (tl) d.push(esc(tl));
      return d.join(' · ');
    }
    function eindKolom(ev, isToday) {
      if (ev.toegang === 'besloten') return '<span class="kmeind-groot">Besloten</span><span class="kmeind-klein">Niet vrij te bezoeken</span><span class="kmknop">Bekijk</span>';
      if (ev.toegang === 'gratis-vrij') return '<span class="kmeind-groot">Gratis</span><span class="kmeind-klein">Kom gewoon langs</span><span class="kmknop">Meer info</span>';
      if (ev.toegang === 'gratis-aanmelden') return '<span class="kmeind-groot">Gratis</span><span class="kmeind-klein">Wel even aanmelden</span><span class="kmknop kmknop--geel">Aanmelden</span>';
      if (ev.externe_ticketlink) return '<span class="kmeind-groot">Kaartjes</span><span class="kmeind-klein">Via ' + esc(ev.locatie && ev.locatie.host_naam || 'de organisatie') + '</span><span class="kmknop">Naar de kaartverkoop</span>';
      if (!ev.ticket) return '<span class="kmeind-groot">Kaartverkoop</span><span class="kmeind-klein">Binnenkort te koop</span><span class="kmknop">Meer info</span>';
      var o = plekkenOver(ev);
      if (typeof o === 'number' && o <= 0) return '<span class="kmeind-groot">Uitverkocht</span><span class="kmknop">' + (cfg.wachtlijst_url ? 'Zet me op de wachtlijst' : 'Hou me op de hoogte') + '</span>';
      var tier = geldendTarief(ev, cfg); if (!tier) return '<span class="kmknop">Meer info</span>';
      var segs = tredes(ev, cfg);
      var trap = '<div class="kmtrap">' + segs.map(function (sg, i) {
        var nu = sg.fase === tier.fase, weg = segs.map(function (x) { return x.fase; }).indexOf(tier.fase) > i;
        return '<span class="' + (nu ? 'nu nu--' + sg.fase : weg ? 'weg' : '') + '"><b>' + euro(sg.prijs) + '</b>' + sg.label + '</span>';
      }).join('') + '</div>';
      var bijna = (!isToday && typeof o === 'number' && o <= LAAG) ? '<span class="kmpil kmpil--oranje kmeind-bijna">Bijna uitverkocht</span>' : '';
      if (isToday || tier.fase === 'deur') {
        return '<span class="kmeind-fase kmeind-fase--deur">Vandaag · aan de deur</span><span class="kmeind-prijs">' + euro(tier.prijs) + '</span>' +
          '<span class="kmeind-klein">Online gesloten. Aan de deur zijn nog kaartjes.<br><strong>Kom op tijd want vol is vol!</strong></span>' + trap + '<span class="kmknop">Meer info</span>';
      }
      var nog = tier.afwijkend ? '' : nogTijd(tier.tot);
      if (tier.fase === 'vroegboek') {
        var deur = segs[2] ? segs[2].prijs : null;
        return '<span class="kmeind-fase">Vroegboekprijs</span><span class="kmeind-prijs">' + euro(tier.prijs) + (deur && deur > tier.prijs ? '<s>' + euro(deur) + '</s>' : '') + '</span>' +
          (nog ? '<span class="kmeind-klein"><strong>' + nog + '</strong></span>' : '') + trap + bijna + '<span class="kmknop kmknop--geel">Kaartjes kopen</span>';
      }
      return '<span class="kmeind-fase kmeind-fase--voor">Online voorverkoop</span><span class="kmeind-prijs">' + euro(tier.prijs) + '</span>' +
        (nog ? '<span class="kmeind-klein"><strong>' + nog + '</strong> online</span>' : '') + trap + bijna + '<span class="kmknop kmknop--geel">Kaartjes kopen</span>';
    }
    // Het rondje op de tijdlijn (2-10-2026): dag, datum en maand in het blauw naast de
    // kaart. De eerstvolgende activiteit krijgt een geel rondje.
    function tijdlijnPunt(ev, eerste) {
      var d = parseDate(ev.datum); if (!d) return '';
      var dag = DAG_KORT[d.getDay()]; dag = dag.charAt(0).toUpperCase() + dag.slice(1);
      var e = parseDate(ev.einddatum);
      // Op de telefoon staat de datum als label op de bovenrand van de kaart, voluit en op één regel:
      // "7 en 8 oktober", "29 september t/m 10 oktober" of "7 oktober" (2-10-2026, Carolien).
      var lang;
      if (e && e > d) {
        var tus = Math.round((e - d) / DAG_MS) === 1 ? ' en ' : ' t/m ';
        lang = d.getMonth() === e.getMonth()
          ? d.getDate() + tus + e.getDate() + '\u00A0' + MAAND_VOL[e.getMonth()]
          : d.getDate() + '\u00A0' + MAAND_VOL[d.getMonth()] + tus + e.getDate() + '\u00A0' + MAAND_VOL[e.getMonth()];
        // Meerdere dagen: begin en eind in het rondje, "29 sep" en "t/m 10 okt".
        return '<span class="kmtl-punt kmtl-punt--reeks' + (eerste ? ' is-eerste' : '') + '" aria-hidden="true"><b>' + d.getDate() + '</b><span>' + esc(MAAND[d.getMonth()]) + '</span><small>' + (Math.round((e - d) / DAG_MS) === 1 ? 'en ' : 't/m ') + e.getDate() + ' ' + esc(MAAND[e.getMonth()]) + '</small><em class="kmtl-lang">' + esc(lang) + '</em></span>';
      }
      lang = d.getDate() + '\u00A0' + MAAND_VOL[d.getMonth()];
      return '<span class="kmtl-punt' + (eerste ? ' is-eerste' : '') + '" aria-hidden="true"><small>' + esc(dag) + '</small><b>' + d.getDate() + '</b><span>' + esc(MAAND[d.getMonth()]) + '</span><em class="kmtl-lang">' + esc(lang) + '</em></span>';
    }
    // ---- Reeksen (2-10-2026) --------------------------------------------------
    // Data die naar dezelfde Voorstelling verwijzen horen bij elkaar, zoals de zes
    // dagen van het zomerprogramma bij FJ08. Bij Op de planning houdt elke datum zijn
    // eigen kaart op zijn plek in de tijd, met een labeltje "<reeks> · 2 van 6". Bij
    // Afgelopen worden ze één kaartje met de data als knopjes; elk knopje gaat naar
    // de eigen pagina van die datum (te delen en vindbaar).
    function reeksLeden(ev) {
      if (!ev.reeks || !ev.reeks.id) return [];
      return events.filter(function (e) { return e.reeks && e.reeks.id === ev.reeks.id; })
        .sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); });
    }
    // Toernee (2-10-2026): één activiteit over meerdere dagen, met per dag de plek en hoe vaak.
    // Uit het veld speeldagen, per regel "datum | plek | aantal".
    function speeldagen(ev) {
      return (ev.speeldagen || []).map(function (r) {
        var p = String(r || '').split('|').map(function (x) { return x.trim(); });
        return { datum: p[0], plek: p[1] || '', keer: parseInt(p[2], 10) || 0 };
      }).filter(function (d) { return d.datum && d.plek; })
        .sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); });
    }
    function toerneeDagen(ev) {
      var gezien = {}, n = 0;
      speeldagen(ev).forEach(function (d) { if (!gezien[d.datum]) { gezien[d.datum] = 1; n++; } });
      return n;
    }
    function toerneeLabel(ev) {
      var n = toerneeDagen(ev); if (n < 2) return '';
      // "Toernee · 2 dagen · 6 voorstellingen" (Carolien, 2-10-2026); het aantal alleen als het bij elke dag staat.
      var dagen = speeldagen(ev), som = 0, compleet = dagen.every(function (d) { return d.keer > 0; });
      dagen.forEach(function (d) { som += d.keer; });
      return '<span class="kmpil kmpil--reeks">Toernee · ' + n + ' dagen' + (compleet && som ? '<span class="kmpil-extra"> · ' + som + (som === 1 ? ' voorstelling' : ' voorstellingen') + '</span>' : '') + '</span>';
    }
    function toerneeBlok(ev, past) {
      var dagen = speeldagen(ev); if (toerneeDagen(ev) < 2) return '';
      var vorige = '';
      var rijen = dagen.map(function (d) {
        var dt = parseDate(d.datum);
        var dag = d.datum === vorige ? '' : (dt ? DAG[dt.getDay()].charAt(0).toUpperCase() + DAG[dt.getDay()].slice(1) + ' ' + dt.getDate() + ' ' + MAAND_VOL[dt.getMonth()] : d.datum);
        vorige = d.datum;
        return '<li><span class="kmtoer-dag">' + esc(dag) + '</span><span class="kmtoer-plek">' + esc(d.plek) + '</span>' +
          (d.keer ? '<span class="kmtoer-keer">' + d.keer + ' keer</span>' : '<span></span>') + '</li>';
      }).join('');
      return '<div class="kmsec-h">' + (past ? 'Hier speelden we' : 'Hier spelen we') + '</div><ul class="kmtoer">' + rijen + '</ul>';
    }
    function reeksLabel(ev) {
      var tl = toerneeLabel(ev); if (tl) return tl;
      var leden = reeksLeden(ev); if (leden.length < 2) return '';
      return '<span class="kmpil kmpil--reeks">' + esc(ev.reeks.titel) + ' · ' + (leden.indexOf(ev) + 1) + ' van ' + leden.length + '</span>';
    }
    function kaartReeksKlein(leden) {
      var eerste = leden[0], laatste = leden[leden.length - 1];
      var periode = { datum: eerste.datum, einddatum: laatste.datum };
      var l = eerste.locatie;
      var logoKol = '<div class="kmkleinlogo">' + (l && l.logo ? '<img src="' + esc(l.logo) + '" alt="' + escAttr(l.host_naam || l.naam || '') + '" loading="lazy">' : tekstLogo(l && (l.naam || l.host_naam))) + '</div>';
      // De partners (andere scholen of organisaties die meededen) op de regel van de knop Bekijk,
      // niet in het logovak: daar hoort de locatie zelf (14-10-2026, C957).
      var partnerRij = partnerStrook(l);
      var knopjes = '<div class="kmchips">' + leden.map(function (e) {
        var d = parseDate(e.datum); if (!d) return '';
        return '<a class="kmchip" href="' + esc(e.url || '#') + '">' + esc(DAG_KORT[d.getDay()]) + ' ' + d.getDate() + ' ' + esc(MAAND[d.getMonth()]) + '</a>';
      }).join('') + '</div>';
      return tijdlijnPunt(periode, false) + kaartBeeld(eerste) +
        '<div class="kmktekst">' +
          '<div class="kmkpils">' + soortPil(eerste) + '</div>' +
          '<h3 class="kmkt">' + esc(eerste.reeks.titel) + '</h3>' +
          '<p class="kmkr">' + IC.cal + '<span>' + leden.length + ' keer · ' + esc(fmtLong(periode)) + '</span></p>' +
          '<p class="kmkr">' + IC.pin + '<span>' + kaartWaar(eerste) + '</span></p>' +
          knopjes +
          (partnerRij ? '<div class="kmkonder">' + partnerRij + '</div>' : '') +
        '</div>' + logoKol;
    }
    function kaartGroot(ev, isToday, eerste) {
      return tijdlijnPunt(ev, eerste) + kaartBeeld(ev) +
        '<div class="kmktekst">' +
          '<div class="kmkpils">' + reeksLabel(ev) + (eerste ? '<span class="kmpil kmpil--geel">Binnenkort</span>' : '') + (isToday ? '<span class="kmpil kmpil--geel">Vandaag</span>' : '') + soortPil(ev) + '</div>' +
          '<h3 class="kmkt">' + esc(ev.titel) + '</h3>' +
          '<p class="kmkr">' + IC.cal + '<span>' + esc(kaartWanneer(ev)) + '</span></p>' +
          '<p class="kmkr">' + IC.pin + '<span>' + kaartWaar(ev) + '</span></p>' +
        '</div>' +
        // De logo's staan los onder de poster en de tekst, op één rij (2-10-2026).
        kaartLogos(ev) +
        '<div class="kmkeind">' + eindKolom(ev, isToday) + '</div>';
    }
    function kaartKlein(ev) {
      var l = ev.locatie;
      // Het logo van de plek staat naast de tekst, in een eigen kolom rechts (2-10-2026). Geen label
      // Afgelopen: op dit tabblad is alles afgelopen (Carolien, 2-10-2026).
      var logoKol = '<div class="kmkleinlogo">' + (l && l.logo ? '<img src="' + esc(l.logo) + '" alt="' + escAttr(l.host_naam || l.naam || '') + '" loading="lazy">' : tekstLogo(l && (l.naam || l.host_naam))) + '</div>';
      // De partners (andere scholen of organisaties die meededen) op de regel van de knop Bekijk,
      // niet in het logovak: daar hoort de locatie zelf (14-10-2026, C957).
      var partnerRij = partnerStrook(l);
      return tijdlijnPunt(ev, false) + kaartBeeld(ev) +
        '<div class="kmktekst">' +
          '<div class="kmkpils">' + toerneeLabel(ev) + soortPil(ev) + '</div>' +
          '<h3 class="kmkt">' + esc(ev.titel) + '</h3>' +
          '<p class="kmkr">' + IC.cal + '<span>' + esc(kaartWanneer(ev)) + '</span></p>' +
          '<p class="kmkr">' + IC.pin + '<span>' + kaartWaar(ev) + '</span></p>' +
          '<div class="kmkonder">' + (partnerRij || '<span></span>') + '<span class="kmknop kmknop--klein">Bekijk</span></div>' +
        '</div>' + logoKol;
    }
    // De eerstvolgende activiteit groot bovenaan, met een rustig "Over 5 dagen".
    var uitEl = root.querySelector('[data-km-uit]');
    function tekenUit() {
      if (!uitEl) return;
      var nu = nuNL();
      var vol = events.filter(function (ev) { var e = eventEnd(ev); return e && e >= nu; })
        .sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); })[0];
      if (!vol || state.tab !== 'komst' || !uitEl.hasAttribute('data-aan')) { uitEl.innerHTML = ''; uitEl.hidden = true; return; }
      var d = parseDate(vol.datum), van = new Date(nu); van.setHours(0, 0, 0, 0);
      var n = Math.round((d - van) / DAG_MS);
      var wanneer = n <= 0 ? 'Vandaag!' : n === 1 ? 'Morgen!' : 'Over ' + n + ' dagen';
      uitEl.hidden = false;
      uitEl.innerHTML = '<button type="button" class="kmuit-k">' +
        (vol.foto ? '<img src="' + esc(vol.foto) + '" alt="" loading="lazy">' : '') +
        '<span class="kmuit-t"><span class="kmuit-o">Eerstvolgende voorstelling</span><span class="kmuit-h">' + esc(vol.titel) + '</span>' +
        '<span class="kmuit-p">' + esc(kaartWanneer(vol)) + (vol.locatie && vol.locatie.plaats ? ' · ' + esc(vol.locatie.plaats) : '') + '</span>' +
        '<span class="kmuit-over">' + wanneer + '</span></span><span class="kmknop">Meer info</span></button>';
      uitEl.querySelector('button').addEventListener('click', function () { openModal(vol); });
    }

    // ---- Maandkalender -------------------------------------------------------
    // Handig zodra er veel in de agenda staat: je ziet in één oogopslag welke
    // weekenden bezet zijn. Toont dezelfde evenementen als de andere weergaven,
    // dus filters en het gekozen tabblad tellen gewoon mee.
    function weekStart(d) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; }
    // De teller boven de lijst. In de lijst- en tegelweergave zie je alles wat door
    // je filters komt, dus daar is één getal genoeg. In de week- en maandweergave
    // kijk je naar één periode, en dan klopte dat getal niet met wat er in beeld
    // stond: "11 evenementen" boven een week waarin er twee staan. Nu staat er wat
    // je ziet, met het totaal erachter zodat je niet kwijtraakt hoeveel er nog is.
    function telTekst(n) { return n + (n === 1 ? ' evenement' : ' evenementen'); }
    function telPeriode(inPeriode, totaal, wanneer) {
      if (inPeriode === totaal) return telTekst(totaal);
      return inPeriode + ' ' + wanneer + ' \u00b7 ' + totaal + ' in totaal';
    }

    function weekLabel(ma) {
      var zo = new Date(ma.getFullYear(), ma.getMonth(), ma.getDate() + 6);
      var l = ma.getDate() + ' ' + MAAND[ma.getMonth()];
      var r = zo.getDate() + ' ' + MAAND[zo.getMonth()] + ' ' + zo.getFullYear();
      return l + ' – ' + r;
    }
    function maandLabel(d) { return MAAND_VOL[d.getMonth()].charAt(0).toUpperCase() + MAAND_VOL[d.getMonth()].slice(1) + ' ' + d.getFullYear(); }

    // Bladeren met de pijltjes haalt het datumfilter eraf: vanaf dat moment is de
    // kalender zelf de periode. Zonder dat zou je naar oktober bladeren terwijl een
    // onzichtbaar augustus-filter alles wegfiltert, en dan staat er een lege maand
    // zonder dat iets vertelt waarom.
    function losDatumfilter() {
      if (!state.dateFrom && !state.dateTo) return;
      state.dateFrom = null; state.dateTo = null;
      if (typeof herstelDatumknop === 'function') herstelDatumknop();
    }

    // ---- Weekweergave --------------------------------------------------------
    // Bewust GEEN maandkalender met zeven vakjes: in zeven smalle kolommen past
    // niet meer dan een afgekorte titel, en juist in een week wil je de details
    // zien. Daarom een dagboek: zeven regels onder elkaar, links de dag en
    // rechts de activiteiten met tijd, plaats en de knop die erbij hoort.
    // Lege dagen blijven staan - dat een woensdag vrij is, is ook informatie.
    function tekenWeek(lijst) {
      if (!weekView) {
        var eerste = lijst.length ? parseDate(lijst[0].datum) : null;
        weekView = weekStart(eerste || nuNL());
      }
      var nu = nuNL();
      var h = '<div class="kmmaandkop">' +
        '<button type="button" class="kmmaandnav" data-week="-1" aria-label="Vorige week">' + IC.chev + '</button>' +
        '<span class="kmmaandtitel">' + esc(weekLabel(weekView)) + '</span>' +
        '<button type="button" class="kmmaandnav" data-week="1" aria-label="Volgende week">' + IC.chev + '</button>' +
        '</div><div class="kmweeklijst">';
      var totaal = 0;
      for (var i = 0; i < 7; i++) {
        var dag = new Date(weekView.getFullYear(), weekView.getMonth(), weekView.getDate() + i);
        var evs = lijst.filter(function (ev) {
          var d = parseDate(ev.datum);
          return d && d.getFullYear() === dag.getFullYear() && d.getMonth() === dag.getMonth() && d.getDate() === dag.getDate();
        });
        totaal += evs.length;
        var isNu = dag.getFullYear() === nu.getFullYear() && dag.getMonth() === nu.getMonth() && dag.getDate() === nu.getDate();
        h += '<div class="kmwdag' + (evs.length ? ' heeft' : '') + (isNu ? ' vandaag' : '') + '">' +
          '<div class="kmwdatum"><b>' + esc(DAG[dag.getDay()]) + '</b>' +
            '<span>' + dag.getDate() + ' ' + esc(MAAND[dag.getMonth()]) + '</span>' +
            (isNu ? '<em>vandaag</em>' : '') + '</div>' +
          '<div class="kmwevs">';
        if (evs.length) { evs.forEach(function (ev) { h += weekRegel(ev, isNu); }); }
        else { h += '<p class="kmwleeg">Niets gepland</p>'; }
        h += '</div></div>';
      }
      h += '</div>';
      // 'in beeld' en niet 'deze week': zodra je doorbladert kijk je naar een
      // andere week, en dan zou 'deze week' niet meer kloppen. Welke week het is
      // staat er vlak boven.
      countEl.textContent = telPeriode(totaal, lijst.length, 'in beeld');
      if (!totaal) h += '<p class="kmmaandleeg">Deze week staat er niets in de agenda. Blader met de pijltjes naar een andere week.</p>';
      grid.innerHTML = h;
      grid.querySelectorAll('[data-week]').forEach(function (b) {
        b.addEventListener('click', function () {
          losDatumfilter();
          weekView = new Date(weekView.getFullYear(), weekView.getMonth(), weekView.getDate() + 7 * (+b.getAttribute('data-week')));
          render();
        });
      });
      koppelDagKnoppen();
    }

    // Een activiteit binnen een weekdag. Zelfde opbouw als de lijstweergave -
    // tijd, titel met labels, en eronder plaats en soort - maar zonder het
    // datumblok links, want de dag staat al aan het begin van de regel.
    function weekRegel(ev, isToday) {
      var eind = eventEnd(ev);
      var past = !!(eind && eind < nuNL());
      var o = plekkenOver(ev);
      var vol = (isTicket(ev) && typeof o === 'number' && o <= 0);
      var k = rijKnop(ev, past, isToday);
      var t = fmtTime(ev);
      var bdg = past ? statusBadge(ev, past, isToday)
                     : (badge(ev) + priceChip(ev) + statusBadge(ev, past, isToday));
      return '<button type="button" class="kmwev' + (vol ? ' vol' : '') + (past ? ' voorbij' : '') + '" data-maand-ev="' + esc(ev.id) + '">' +
        '<span class="kmwtijd">' + (t ? esc(t) : '&middot;') + '</span>' +
        '<span class="kmwmid">' +
          '<span class="kmwtitel">' + esc(ev.titel) + '</span>' +
          '<span class="kmwmeta">' + rijMeta(ev, true) + '</span>' +
          (bdg ? '<span class="kmwbadges">' + bdg + '</span>' : '') +
        '</span>' +
        '<span class="kmwknop ' + k.kl + '">' + esc(k.tekst) + '</span>' +
        '</button>';
    }

    function dagKnop(ev) {
      var o = plekkenOver(ev);
      var stand = (isTicket(ev) && typeof o === 'number' && o <= 0) ? ' vol' : '';
      return '<button type="button" class="kmdagev' + stand + '" data-maand-ev="' + esc(ev.id) + '" title="' + escAttr(ev.titel) + '">' +
        (ev.begintijd ? '<b>' + esc(ev.begintijd) + '</b> ' : '') + esc(ev.titel) + '</button>';
    }
    function koppelDagKnoppen() {
      grid.querySelectorAll('[data-maand-ev]').forEach(function (b) {
        b.addEventListener('click', function () {
          var ev = events.filter(function (x) { return x.id === b.getAttribute('data-maand-ev'); })[0];
          if (ev) openModal(ev);
        });
      });
    }

    function tekenMaand(lijst) {
      // Beginmaand: die van het eerstvolgende evenement dat aan de filters voldoet,
      // anders deze maand. Zo kijk je niet naar een lege kalender terwijl er verderop
      // van alles staat.
      if (!maandView) {
        var eersteDatum = lijst.length ? parseDate(lijst[0].datum) : null;
        var basis = eersteDatum || nuNL();
        maandView = new Date(basis.getFullYear(), basis.getMonth(), 1);
      }
      var jaar = maandView.getFullYear(), maand = maandView.getMonth();

      // Evenementen per dag van deze maand
      var perDag = {};
      lijst.forEach(function (ev) {
        var d = parseDate(ev.datum); if (!d) return;
        if (d.getFullYear() !== jaar || d.getMonth() !== maand) return;
        (perDag[d.getDate()] = perDag[d.getDate()] || []).push(ev);
      });

      var eersteVanDeMaand = new Date(jaar, maand, 1);
      var start = (eersteVanDeMaand.getDay() + 6) % 7; // maandag = 0
      var dagenInMaand = new Date(jaar, maand + 1, 0).getDate();
      var nu = nuNL();
      var vandaagInBeeld = (nu.getFullYear() === jaar && nu.getMonth() === maand) ? nu.getDate() : 0;

      var h = '<div class="kmmaandkop">' +
        '<button type="button" class="kmmaandnav" data-maand="-1" aria-label="Vorige maand">' + IC.chev + '</button>' +
        '<span class="kmmaandtitel">' + esc(maandLabel(maandView)) + '</span>' +
        '<button type="button" class="kmmaandnav" data-maand="1" aria-label="Volgende maand">' + IC.chev + '</button>' +
        '</div><div class="kmmaandnamen">';
      ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'].forEach(function (d) { h += '<span>' + d + '</span>'; });
      h += '</div><div class="kmmaandraster">';

      for (var i = 0; i < start; i++) h += '<div class="kmdag leeg"></div>';
      for (var dag = 1; dag <= dagenInMaand; dag++) {
        var evs = perDag[dag] || [];
        var kl = 'kmdag' + (evs.length ? ' heeft' : '') + (dag === vandaagInBeeld ? ' vandaag' : '');
        h += '<div class="' + kl + '"><span class="kmdagnr">' + dag + '</span>';
        evs.forEach(function (ev) { h += dagKnop(ev); });
        h += '</div>';
      }
      var rest = (start + dagenInMaand) % 7;
      if (rest) for (var r = rest; r < 7; r++) h += '<div class="kmdag leeg"></div>';
      h += '</div>';

      var inMaand = Object.keys(perDag).reduce(function (n, k) { return n + perDag[k].length; }, 0);
      countEl.textContent = telPeriode(inMaand, lijst.length, 'in ' + MAAND_VOL[maandView.getMonth()]);
      if (!inMaand) h += '<p class="kmmaandleeg">Deze maand staat er niets in de agenda. Blader met de pijltjes naar een andere maand.</p>';
      grid.innerHTML = h;

      grid.querySelectorAll('[data-maand]').forEach(function (b) {
        b.addEventListener('click', function () {
          losDatumfilter();
          maandView = new Date(jaar, maand + (+b.getAttribute('data-maand')), 1);
          render();
        });
      });
      koppelDagKnoppen();
    }

    function render() {
      countdownTimers.forEach(clearInterval); countdownTimers = [];
      var list = events.filter(matches);
      // sorteer: komst oplopend, geweest aflopend
      list.sort(function (a, b) {
        var da = parseDate(a.datum), db = parseDate(b.datum);
        return state.tab === 'geweest' ? db - da : da - db;
      });
      // Afgelopen in de lijst: een reeks wordt één kaartje, op de plek van zijn laatste datum.
      events.forEach(function (e) { e._leden = null; });
      if (state.view === 'lijst' && state.tab === 'geweest') {
        var reeksGezien = {};
        list = list.filter(function (ev) {
          if (!ev.reeks || !ev.reeks.id) return true;
          var leden = list.filter(function (e) { return e.reeks && e.reeks.id === ev.reeks.id; });
          if (leden.length < 2) return true;
          if (reeksGezien[ev.reeks.id]) return false;
          reeksGezien[ev.reeks.id] = 1;
          ev._leden = leden.slice().sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); });
          return true;
        });
      }
      grid.innerHTML = '';
      var n0 = list.length;
      countEl.textContent = telTekst(n0);
      emptyEl.style.display = (n0 || state.view === 'maand' || state.view === 'week') ? 'none' : 'block';
      if (state.view === 'maand') { tekenMaand(list); return; }
      if (state.view === 'week') { tekenWeek(list); return; }
      var lijst = state.view === 'lijst';
      root.classList.toggle('km-tab-geweest', state.tab === 'geweest');
      grid.classList.toggle('is-klein', lijst && state.tab === 'geweest');
      grid.classList.toggle('is-tijdlijn', lijst);
      var laatsteGroep = '', perJaar = {};
      list.forEach(function (e) { var y = (e.datum || '').slice(0, 4); perJaar[y] = (perJaar[y] || 0) + (e._leden ? e._leden.length : 1); });
      tekenUit();
      var now = nuNL();
      list.forEach(function (ev, idx) {
        var end = eventEnd(ev), day = parseDate(ev.datum);
        var past = end && end < now;
        var isToday = day && day.getFullYear() === now.getFullYear() && day.getMonth() === now.getMonth() && day.getDate() === now.getDate();
        // 'Binnenkort' alleen op het eerstvolgende evenement waar je nog bij kunt.
        // Een uitverkochte voorstelling accent geven zou de aandacht verkeerd sturen.
        var vol = isTicket(ev) && (function () { var o = plekkenOver(ev); return typeof o === 'number' && o <= 0; })();
        // Niet op iets van vandaag: daar staat al 'Vandaag · aan de deur', en twee
        // labels die hetzelfde moment beschrijven leest rommelig.
        var eerste = state.tab === 'komst' && idx === 0 && !past && !vol && !isToday;
        var badgesHtml = past ? statusBadge(ev, past, isToday) : (badge(ev) + priceChip(ev) + statusBadge(ev, past, isToday));
        var kaart = document.createElement('div');

        if (lijst) {
          // Een kopje per maand (Op de planning) of per jaar met het aantal (Afgelopen).
          var gk = state.tab === 'geweest' ? (ev.datum || '').slice(0, 4) : (day ? MAAND_VOL[day.getMonth()] + ' ' + day.getFullYear() : '');
          if (gk && gk !== laatsteGroep) {
            laatsteGroep = gk;
            var kopEl = document.createElement('div');
            kopEl.className = 'kmgroep';
            kopEl.innerHTML = esc(gk.charAt(0).toUpperCase() + gk.slice(1));
            grid.appendChild(kopEl);
          }
          if (ev._leden) {
            kaart.className = 'kmklein kmklein--reeks';
            kaart.innerHTML = kaartReeksKlein(ev._leden);
          } else if (state.tab === 'geweest' || past) {
            kaart.className = 'kmklein' + (ev.toegang === 'besloten' ? ' is-stil' : '');
            kaart.innerHTML = kaartKlein(ev);
          } else {
            kaart.className = 'kmkaart' + (ev.toegang === 'besloten' ? ' is-stil' : '') + (eerste ? ' is-next' : '');
            kaart.innerHTML = kaartGroot(ev, isToday, eerste);
          }
        } else {
          var chips = '<span class="kmdchip">' + esc(fmtChip(ev)) + '</span>';
          if (eerste) chips += '<span class="kmnext">Binnenkort</span>';
          var tl = typeLabel(ev);
          kaart.className = 'kmtile';
          kaart.innerHTML =
            tileImg(ev, false).replace('">', '">' + chips) +
            '<div class="kmti">' +
            '<h3 class="kmtt">' + esc(ev.titel) + '</h3>' +
            (tl ? '<p class="kmttype">' + esc(tl) + '</p>' : '') +
            '<p class="kmtd">' + IC.cal + esc(fmtCardDate(ev)) + '</p>' +
            (ev.locatie ? '<p class="kmtp">' + IC.pin + esc(cardPlace(ev)) + '</p>' : '') +
            '<div class="kmtrow">' + badgesHtml + '</div>' +
            (vol && cfg.wachtlijst_url ? '<p class="kmtwl">' + IC.mail + ' Zet je op de wachtlijst</p>' : '') +
            '</div>';
        }

        // Ook met het toetsenbord te openen: tab erheen, Enter of spatie.
        kaart.setAttribute('role', 'button');
        kaart.setAttribute('tabindex', '0');
        // Een knopje met een eigen link (de data van een reeks) gaat naar die pagina, niet naar de pop-up.
        kaart.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href]')) return; openModal(ev); });
        kaart.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); openModal(ev); }
        });
        grid.appendChild(kaart);
      });
      var n = list.length;
      countEl.textContent = n + (n === 1 ? ' evenement' : ' evenementen');
      var pc = root.querySelector('[data-km-pcount]'), pw = root.querySelector('[data-km-pwis]');
      if (pc) pc.textContent = n + (n === 1 ? ' activiteit gevonden' : ' activiteiten gevonden');
      if (pw) pw.hidden = !(state.types.length || state.soorten.length || state.plaatsen.length || state.q);
      emptyEl.style.display = n ? 'none' : 'block';
      toonEerder(n === 0);
    }

    // Staat er niets op de planning, dan laten we eronder zien wat we eerder speelden (14-10-2026,
    // C952). Zo ziet een bezoeker meteen wat voor voorstellingen er zijn in plaats van alleen wat er
    // niet is. Het zijn dezelfde kaarten als in de weergave Afgelopen, geen eenvoudiger namaak.
    var eerderEl = null;
    function toonEerder(aan) {
      if (!aan) { if (eerderEl) eerderEl.hidden = true; return; }
      var band = emptyEl.closest('.kmband') || emptyEl.parentElement;
      if (!eerderEl) {
        eerderEl = document.createElement('div');
        eerderEl.className = 'kmeerder';
        band.appendChild(eerderEl);
      }
      var vandaag = nuNL();
      var geweest = events.filter(function (e) { var x = eventEnd(e); return x && x < vandaag; })
        .sort(function (a, b) { return (parseDate(b.datum) || 0) - (parseDate(a.datum) || 0); })
        .slice(0, 3);
      if (!geweest.length) { eerderEl.hidden = true; return; }
      eerderEl.hidden = false;
      eerderEl.innerHTML = '<div class="kmsite">'
        + '<h2>Hier speelden we eerder</h2>'
        + '<p class="kmeerder-sub">Klik op een Kaatje&amp;Mup evenement voor meer informatie.</p>'
        + '<div class="kmgrid kmgrid--lijst is-tijdlijn is-klein" data-km-eerder-grid></div>'
        + '<p class="kmeerder-knop"><a class="kmknop" href="#" data-km-naar-afgelopen>Bekijk alle Kaatje&amp;Mup evenementen</a></p>'
        + '</div>';
      // De kaarten net zo opbouwen en klikbaar maken als in de gewone lijst, zodat het venster
      // van een voorstelling ook hier opengaat.
      var eg = eerderEl.querySelector('[data-km-eerder-grid]');
      geweest.forEach(function (ev) {
        var kaart = document.createElement('div');
        kaart.className = 'kmklein' + (ev.toegang === 'besloten' ? ' is-stil' : '');
        kaart.innerHTML = kaartKlein(ev);
        kaart.tabIndex = 0;
        kaart.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href]')) return; openModal(ev); });
        kaart.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(ev); } });
        eg.appendChild(kaart);
      });
    }
    // De knop eronder zet de agenda op Afgelopen, zodat je de hele lijst ziet.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-km-naar-afgelopen]');
      if (!a) return;
      e.preventDefault();
      var knop = root.querySelector('[data-km-tab="geweest"]') ||
        Array.prototype.filter.call(root.querySelectorAll('button,a'), function (b) { return b.textContent.trim() === 'Afgelopen'; })[0];
      if (knop) knop.click();
    });

    // ---- Weergavekiezer ------------------------------------------------------
    // De keuze wordt niet onthouden, net als bij de producten in de webwinkel:
    // de pagina opent altijd op de weergave die in de sectie staat ingesteld.
    var viewKnoppen = root.querySelectorAll('[data-km-view]');
    // Alleen de klassen en de knopstand zetten. Het opnieuw opbouwen van de lijst
    // gebeurt met render(), zodat er bij het openen van de pagina niet twee keer
    // achter elkaar getekend wordt.
    function zetWeergaveKlassen(v) {
      if (v !== state.view && !behoudPeriode) { maandView = null; weekView = null; }
      state.view = v;
      ['lijst', '2', '3', '4', '5', 'maand', 'week'].forEach(function (x) { grid.classList.remove('kmgrid--' + x); });
      grid.classList.add('kmgrid--' + v);
      viewKnoppen.forEach(function (b) {
        var aan = b.getAttribute('data-km-view') === v;
        b.classList.toggle('on', aan);
        b.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
    }
    viewKnoppen.forEach(function (b) {
      b.addEventListener('click', function () {
        zetWeergaveKlassen(b.getAttribute('data-km-view'));
        render();
      });
    });
    zetWeergaveKlassen(startView);

    // ---- Onder de agenda (2-10-2026, C614 en C615) ---------------------------
    // De muur Hier speelden we al werd alleen gevuld als de extra strook bestond (14-10-2026, C953).
    // Sinds de muur een eigen blok is dat ook los op Boek ons kan staan, hangt dat niet meer samen.
    if (!soloMode && (root.querySelector('[data-km-extra]') || root.querySelector('[data-km-wall]'))) {
      var nuX = nuNL();
      var geweest = events.filter(function (ev) { var e = eventEnd(ev); return e && e < nuX; })
        .sort(function (a, b) { return parseDate(b.datum) - parseDate(a.datum); });
      // Foto's van de vorige keer: de nieuwste vier verschillende foto's.
      var fotoBlok = root.querySelector('[data-km-fotoblok]'), fotoBak = root.querySelector('[data-km-fotos]');
      var gezien = {}, fotos = [];
      // Polaroids (2-10-2026): eigen foto's en filmpjes uit de themaeditor openen groot in de lichtbak;
      // zonder eigen blokken de nieuwste vijf foto's uit de agenda, die openen de activiteit.
      if (fotoBak && fotoBak.hasAttribute('data-km-eigen')) {
        var eigen = [].slice.call(fotoBak.querySelectorAll('[data-pola]')).map(function (b) {
          var src = b.getAttribute('data-src');
          return b.getAttribute('data-type') === 'video' ? { type: 'video', src: src } : { type: 'image', full: src };
        });
        fotoBak.addEventListener('click', function (e) { var b = e.target.closest('[data-pola]'); if (b) openLb(eigen, +b.getAttribute('data-pola')); });
      } else {
        geweest.forEach(function (ev) { (ev.media || []).forEach(function (m) { if (fotos.length < 5 && m.type === 'image' && m.full && !gezien[m.full.split('?')[0]]) { gezien[m.full.split('?')[0]] = 1; fotos.push({ ev: ev, src: m.full }); } }); });
        if (fotoBak && fotos.length >= 2) {
          fotoBak.innerHTML = fotos.map(function (f, i) { return '<button type="button" class="kmpo km-vergroot" data-foto="' + i + '"><i class="kmpo-pin" aria-hidden="true"></i><img src="' + esc(f.src) + '" alt="" loading="lazy"><span class="kmpo-tekst">' + esc(f.ev.titel) + '</span></button>'; }).join('');
          // Klikken opent de foto groot, met doorklikken naar de volgende (Carolien, 2-10-2026).
          var groot = fotos.map(function (f) { return { type: 'image', full: f.src }; });
          fotoBak.addEventListener('click', function (e) { var b = e.target.closest('[data-foto]'); if (b) openLb(groot, +b.getAttribute('data-foto')); });
          fotoBlok.hidden = false;
        }
      }
      // Waar zijn we te zien: per plaats hoe vaak.
      var plaatsBak = root.querySelector('[data-km-plaatsen]'), kaartBlok = root.querySelector('[data-km-kaartblok]');
      var tel = {};
      events.forEach(function (ev) { var p = ev.locatie && ev.locatie.plaats; if (p) tel[p] = (tel[p] || 0) + 1; });
      var plaatsen = Object.keys(tel).sort(function (a, b) { return tel[b] - tel[a] || a.localeCompare(b); });
      if (plaatsBak && plaatsen.length) {
        plaatsBak.innerHTML = plaatsen.map(function (p) { return '<li>' + IC.pin + esc(p) + ' · ' + tel[p] + ' keer</li>'; }).join('');
        kaartBlok.hidden = false;
      }
      vulMuur(geweest);
    }

    // De muur Hier speelden we al, als eigen functie zodat hij ook werkt op een pagina waar alleen
    // de muur staat, zoals Boek ons (14-10-2026, C953).
    function vulMuur(geweest) {
        // Hier speelden we al: de plekken uit de agenda (met logo) en de extra regels.
        var wall = root.querySelector('[data-km-wall]'), muurData = { friesland: [], terschelling: [] };
        try { muurData = JSON.parse(root.querySelector('[data-km-muurdata]').textContent) || muurData; } catch (e) {}
        // Eén regel: naam|jaar|logo|naam. Het logo is de bestandsnaam uit Inhoud, Bestanden; met
        // naam als vierde deel staat de naam onder het logo (2-10-2026).
        function regels(lijst, standaard) { return (lijst || []).map(function (r) { return String(r || '').trim(); }).filter(Boolean).map(function (r) { var p = r.split('|'), lg = (p[2] || '').trim(); if (lg && lg.indexOf('/') < 0) lg = '/cdn/shop/files/' + lg; return { naam: p[0].trim(), jaar: (p[1] || '').trim(), logo: lg, metNaam: (p[3] || '').trim() === 'naam' }; }); }
        // Twee tabbladen: Op het vasteland (standaard open) en Op Terschelling (2-10-2026). Het
        // veld provincie op de locatie blijft bestaan, maar bepaalt nu geen tabblad meer.
        var VAST = 'Op het vasteland', EILAND = 'Op Terschelling';
        var perProv = {}, gezien = {};
        function zet(prov, item, sleutel) {
          if (!perProv[prov]) { perProv[prov] = []; gezien[prov] = {}; }
          if (gezien[prov][sleutel]) return;
          gezien[prov][sleutel] = 1; perProv[prov].push(item);
        }
        events.slice().sort(function (a, b) { return parseDate(b.datum) - parseDate(a.datum); }).forEach(function (ev) {
          var l = ev.locatie; if (!l || !l.naam) return;
          // Alleen plekken met een logo; een plek zonder logo (zoals IKC Duinterpen, waar de
          // scholen als partner op staan) komt er niet als losse naam bij (2-10-2026).
          if (l.logo) zet(VAST, { naam: l.naam, logo: l.logo }, l.naam);
          (l.partners || []).forEach(function (p) { if (p && p.src) zet(VAST, { naam: p.alt || '', logo: p.src }, p.src); });
        });
        // Staat een logo zowel bij een plek uit de agenda als in een extra regel (zoals het wapen van
        // Easterwierrum), dan wint de extra regel, want die kan de naam eronder tonen (2-10-2026).
        function bestand(u) { return String(u || '').split('?')[0].split('/').pop(); }
        regels(muurData.friesland, '').forEach(function (p) {
          if (p.logo && perProv[VAST]) perProv[VAST] = perProv[VAST].filter(function (q) { return bestand(q.logo) !== bestand(p.logo); });
          zet(VAST, p, 'x:' + p.naam);
        });
        var ts = regels(muurData.terschelling, '');
        var tabs = perProv[VAST] ? [VAST] : [];
        if (ts.length) { perProv[EILAND] = ts; tabs.push(EILAND); }
        // Een klik op een logo opent het groot in het vergrootvenster, met pijltjes naar het volgende logo, net als bij de foto's
        // (5-10-2026, C929, Carolien: "als je op de logo's klikt kan je dan een vergroot logo zien en dat je dan kan doorklikken
        // naar de volgende zelfde als bij foto's?").
        var muurLogos = [];
        function tekenMuur(welke) {
          if (!wall) return;
          muurLogos = [];
          wall.innerHTML = (perProv[welke] || []).map(function (p) {
            // Geen jaartallen meer op de tegels (2-10-2026); met |naam staat de naam onder het logo.
            if (p.logo) {
              var nr = muurLogos.push({ type: 'logo', full: p.logo, naam: String(p.naam || '').replace(/^logo\s+/i, '') }) - 1;
              return '<button type="button" class="kmmuur-tegel km-vergroot' + (p.metNaam ? ' kmmuur-tegel--naam' : '') + '" data-muurlogo="' + nr + '" aria-label="' + escAttr(p.naam) + ' groter bekijken"><img src="' + esc(p.logo) + '" alt="' + escAttr(p.naam) + '" loading="lazy">' + (p.metNaam ? '<small>' + esc(p.naam) + '</small>' : '') + '</button>';
            }
            return '<div class="kmmuur-tegel"><span>' + esc(p.naam) + '</span></div>';
          }).join('');
        }
        if (wall) wall.addEventListener('click', function (e) {
          var b = e.target.closest('[data-muurlogo]');
          if (b) openLb(muurLogos, +b.getAttribute('data-muurlogo'));
        });
        var tabBak = root.querySelector('[data-km-muurtabs]');
        if (tabBak) {
          tabBak.innerHTML = tabs.map(function (t, i) { return '<button type="button" class="kmtab' + (i === 0 ? ' on' : '') + '" data-km-muur="' + escAttr(t) + '">' + esc(t) + '</button>'; }).join('');
          tabBak.hidden = tabs.length < 2;
        }
        root.querySelectorAll('[data-km-muur]').forEach(function (b) {
          b.addEventListener('click', function () {
            root.querySelectorAll('[data-km-muur]').forEach(function (x) { x.classList.toggle('on', x === b); });
            tekenMuur(b.getAttribute('data-km-muur'));
          });
        });
        if (tabs.length) tekenMuur(tabs[0]);
    }

    function accessBox(ev, tier) {
      if (ev.toegang === 'besloten') return '<div class="kmacc closed">' + IC.lock + '<strong>Besloten evenement</strong><span>Voor dit evenement zijn geen kaartjes te koop.</span></div>';
      if (ev.toegang === 'gratis-vrij') return '<div class="kmacc free">' + IC.check + '<strong>Gratis te bezoeken</strong><span>Je hoeft geen kaartje te kopen.<br>Kom wel op tijd, dan mis je niks.</span></div>';
      if (ev.toegang === 'gratis-aanmelden') return '<div class="kmacc reg">' + IC.check + '<strong>Gratis maar aanmelden verplicht</strong><span>Er is een beperkt aantal plekken, dus meld je op tijd aan.</span></div>';
      // kaartverkoop
      if (ev.externe_ticketlink) return '<div class="kmacc tickets">' + IC.ticket + '<strong>Kaartverkoop via ' + esc(ev.locatie && ev.locatie.host_naam || 'de organisatie') + '</strong><span>Kaartjes koop je via de externe ticketlink hieronder.</span></div>';
      return '';
    }

    function priceBlock(ev, cfg) {
      if (ev.toegang !== 'kaartverkoop' || ev.externe_ticketlink) return '';
      var tier = geldendTarief(ev, cfg); if (!tier) return '';
      var segs = tredes(ev, cfg);
      var nc = nConsumpties(ev);
      var h = '<p class="kmprijs-h">Prijzen</p>' +
        (nc > 0 ? '<p class="kmprijs-sub">elk kaartje is inclusief ' + consumptieTekst(nc) + '</p>' : '') +
        '<div class="kmladder">';
      segs.forEach(function (s) {
        h += '<div class="kmladseg' + (s.fase === tier.fase ? ' on' : '') + '"><span class="kmladp">' + euro(s.prijs) + '</span><span class="kmladl">' + s.label + '</span><span class="kmladsub">' + s.sub + '</span></div>';
      });
      h += '</div>';
      if (tier.fase === 'vroegboek' && tier.tot) {
        h += '<div class="kmdoorbox"><p class="kmsoldt">Het vroegboekvoordeel geldt nu</p><p class="kmsoldp">Nu boek je voor de laagste prijs!<br>Nog <span class="kmcountdown" data-target="' + tier.tot.getTime() + '">…</span> te gaan.<br>Wees er snel bij!</p></div>';
      } else if (tier.fase === 'voorverkoop' && tier.tot) {
        h += '<div class="kmdoorbox"><p class="kmsoldt">De online voorverkoop is open</p><p class="kmsoldp">Koop je kaartjes makkelijk online.<br>Nog <span class="kmcountdown" data-target="' + tier.tot.getTime() + '">…</span> te gaan.<br>Tot dan!</p></div>';
      } else if (tier.afwijkend) {
        h += '<div class="kmdoorbox"><p class="kmsoldt">Dit tarief geldt nu</p><p class="kmsoldp">De prijs hiernaast is wat je bij het<br>afrekenen betaalt.</p></div>';
      } else {
        h += '<div class="kmdoorbox"><p class="kmsoldt">De online voorverkoop is gesloten</p><p class="kmsoldp">Aan de deur zijn er nog kaartjes,<br>zolang er plek is.<br>Tot straks!</p></div>';
      }
      return h;
    }

    // ---- Consumpties bij een kaartje ----------------------------------------
    // Het aantal staat sinds 27-08-2026 als getal bij de vermelding. Het oude
    // vinkje blijft de terugval voor alles wat nog geen getal heeft ingevuld:
    // aangevinkt is 1, uitgevinkt is 0. Zo hoefde er niets omgezet te worden.
    function nConsumpties(ev) {
      if (typeof ev.consumpties === 'number' && ev.consumpties >= 0) return ev.consumpties;
      return ev.consumptie === false ? 0 : 1;
    }
    // "1 consumptie" maar "2 consumpties" - een tekst met een getal erin moet
    // meebuigen, anders staat er vroeg of laat "2 consumptie".
    function consumptieTekst(n) { return n + (n === 1 ? ' consumptie' : ' consumpties'); }
    // Hoe je hem krijgt hoort bij de zaal en niet bij de dag: de ene locatie
    // werkt met muntjes, de andere zegt het gewoon aan de bar.
    function consumptieHoe(ev) {
      var loc = ev.locatie || {};
      return (loc.consumptie_hoe && String(loc.consumptie_hoe).trim())
        || 'Bij binnenkomst krijg je een muntje dat je aan de bar kunt inwisselen.';
    }

    function consumptieLine(ev) {
      var n = nConsumpties(ev);
      if (ev.toegang !== 'kaartverkoop' || n <= 0) return '';
      return '<div class="kmconsum">' + IC.ticket + ' Elk kaartje is <strong>inclusief ' +
        consumptieTekst(n) + '</strong><br>' + esc(consumptieHoe(ev)) + '</div>';
    }

    // Kaartjeskiezer (stap 2): leest de varianten van het gekoppelde ticketproduct.
    var TT_META = {
      'Kind': { label: 'Kind', sub: 'vanaf 2 jaar' },
      'Volwassene': { label: 'Volwassene', sub: '11 tot 99 jaar' },
      'Baby': { label: 'Baby', sub: '0 tot 2 jaar · op schoot' }
    };
    function ticketTypes(ev) {
      if (!ev.ticket || !ev.ticket.varianten || !ev.ticket.varianten.length) return [];
      // De prijs komt uit de variant zelf, niet uit onze eigen berekening. Dat is
      // precies het bedrag dat de kassa straks rekent.
      return ev.ticket.varianten.map(function (v) {
        var gratis = !v.prijs_cent;
        var m = TT_META[v.type] || { label: v.type, sub: '' };
        return { id: v.id, type: v.type, label: m.label, sub: m.sub, prijs: gratis ? 0 : (+v.prijs_cent) / 100, voorraad: (typeof v.voorraad === 'number' ? v.voorraad : 0), gratis: gratis };
      });
    }
    // Versturen gaat naar ons eigen doorgeefluik, want een webpagina kan niet
    // rechtstreeks in de Shopify-beheerkant schrijven: daar hoort een geheime
    // sleutel bij, en die kan nooit in de broncode van een pagina staan. Het
    // doorgeefluik controleert het verzoek en zet de persoon in Shopify neer.
    function verstuurWachtlijst(box, ev) {
      if (!box) return;
      var naam = box.querySelector('[data-wl-naam]');
      var mail = box.querySelector('[data-wl-mail]');
      var tel = box.querySelector('[data-wl-tel]');
      var nb = box.querySelector('[data-wl-nieuwsbrief]');
      var lokaas = box.querySelector('[data-wl-lokaas]');
      var knop = box.querySelector('[data-wl-verstuur]');
      var melding = box.querySelector('.kmwl-melding');
      var zeg = function (tekst, fout) {
        melding.textContent = tekst;
        melding.className = 'kmwl-melding' + (fout ? ' fout' : ' goed');
      };

      var e = mail.value.trim(), t = tel ? tel.value.trim() : '';
      if (!naam.value.trim()) { zeg('Vul even je naam in.', true); naam.focus(); return; }
      if (!e && !t) {
        zeg('Vul je e-mailadres in of je telefoonnummer. Eén van de twee is genoeg.', true);
        mail.focus(); return;
      }
      if (e && !/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(e)) {
        zeg('Dat e-mailadres klopt nog niet helemaal.', true); mail.focus(); return;
      }
      // De nieuwsbrief gaat per mail, dus zonder e-mailadres kan hij niet worden
      // verstuurd. Dat zeggen we meteen in plaats van het vinkje stil te negeren.
      if (nb && nb.checked && !e) {
        zeg('Voor de nieuwsbrief hebben we je e-mailadres nodig. Vul dat in of haal het vinkje weg.', true);
        mail.focus(); return;
      }
      // Alleen grof kijken of er een nummer in zit; het echte omzetten naar de
      // internationale schrijfwijze gebeurt aan de andere kant.
      if (t && (t.replace(/\D/g, '').length < 9 || t.replace(/\D/g, '').length > 15)) {
        zeg('Dat telefoonnummer klopt nog niet helemaal. Bijvoorbeeld 06 12345678.', true);
        tel.focus(); return;
      }

      knop.disabled = true;
      var oudeTekst = knop.textContent;
      knop.textContent = 'Even geduld…';
      zeg('', false);

      fetch(cfg.wachtlijst_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          naam: naam.value.trim(),
          email: e,
          telefoon: t,
          evenement: ev.id,
          nieuwsbrief: !!(nb && nb.checked),
          // Welke nieuwsbrief het is hangt af van de site waar je staat. Het
          // formulier in de pagina heeft dat label al; we lezen het daar af zodat
          // er maar één plek is waar het bepaald wordt (km-nieuwsbrieflabels).
          labels: (function () {
            var veld = document.querySelector('input[name="contact[tags]"]');
            return veld ? veld.value : '';
          })(),
          website: lokaas ? lokaas.value : '',
        }),
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.ok) {
          // Het formulier verdwijnt: blijft het staan, dan denkt iemand dat het
          // niet gelukt is en meldt hij zich nog een keer aan.
          box.innerHTML = '<div class="kmwl-gelukt">' + IC.check +
            '<strong>Je staat op de wachtlijst</strong>' +
            '<span>Komt er een plek vrij voor deze voorstelling, dan laten we het je weten.' +
            (nb && nb.checked ? ' En je staat nu ook op de nieuwsbrief.' : ' Je krijgt verder geen post van ons.') +
            '</span></div>';
        } else {
          knop.disabled = false; knop.textContent = oudeTekst;
          zeg((d && d.error) || 'Het lukte even niet. Probeer het zo nog eens.', true);
        }
      }).catch(function () {
        knop.disabled = false; knop.textContent = oudeTekst;
        zeg('Het lukte even niet. Probeer het zo nog eens.', true);
      });
    }

    // Uitverkocht is niet hetzelfde als "de kaartjeskiezer zegt nul". Een
    // voorstelling zonder gekoppeld kaartjesproduct komt nooit bij die kiezer,
    // maar kan wel degelijk vol zitten - dat staat dan in plekken_over. Daarom
    // hier een gedeelde vraag, die het label, de knop in de lijst en de
    // wachtlijst allemaal hetzelfde beantwoorden.
    function isUitverkocht(ev) {
      if (!isTicket(ev)) return false;
      var o = plekkenOver(ev);
      return typeof o === 'number' && o <= 0;
    }

    // ---- Wat er op de kraam ligt ---------------------------------------------
    // Nadrukkelijk geen tweede winkel: er zit geen bestelknop bij en er wordt niets
    // in de winkelwagen gelegd. Het is er om mensen met een plan te laten komen -
    // wie weet dat er ansichtkaarten liggen, denkt er thuis al over na. Vandaar ook
    // dat het onderaan de pop-up staat en niet boven de kaartjes: eerst je kaartje,
    // dan pas dit.
    //
    // Soorten in plaats van losse producten: op een kraam ligt niet een ansichtkaart
    // maar een hele bak, en wie het plaatje ziet wil de rest ook. Elke tegel is dus
    // een voorbeeld van een soort, en klikken brengt je naar alles van die soort.
    //
    // Een lijst voor alle voorstellingen; per voorstelling zet het vinkje "Kraam
    // aanwezig" in Shopify alleen aan of uit of het blokje er komt. Niet overal is
    // gelegenheid om te verkopen.
    // Twee blokken met dezelfde opbouw: de Kaatje&Mup-spullen bij de voorstelling,
    // en de knutselspullen bij het knutselcafe. Die laatste zijn van Cutiepix en
    // staan in een eigen webwinkel, dus daar gaan de links naartoe - vandaar dat
    // het webadres meegegeven wordt in plaats van vast in de code te staan.
    function kraamBlok(aan, data, kop, tekst, domein, merk) {
      if (!aan || !data.length) return '';
      var h = '<div class="kmsec-h">' + esc(kop) + '</div>';
      if (tekst) h += '<p class="kmkraam-p">' + esc(tekst) + '</p>';
      h += '<div class="kmkraam">';
      data.forEach(function (c) {
        var n = +c.aantal;
        var telling = isFinite(n) && n > 0 ? (n === 1 ? '1 stuk' : n + ' stuks') : '';
        // Een knop en geen link: klikken opent een venster over de agenda heen in
        // plaats van dat de bezoeker de agenda verlaat. Wie halverwege het kopen
        // van een kaartje wegklikt naar de webshop, komt vaak niet terug.
        h += '<button type="button" class="kmkraam-item" data-kraam="' + escAttr(c.handle) + '"' +
          ' data-kraam-domein="' + escAttr(domein || '') + '" data-kraam-merk="' + escAttr(merk || '') + '">' +
          (c.afbeelding
            ? '<span class="kmkraam-f" style="background-image:url(' + esc(c.afbeelding) + ')"></span>'
            : '<span class="kmkraam-f kmkraam-leeg">' + IC.tag + '</span>') +
          '<span class="kmkraam-t">' + esc(c.titel) + '</span>' +
          (telling ? '<span class="kmkraam-pr">' + esc(telling) + '</span>' : '') +
          '</button>';
      });
      return h + '</div>';
    }

    // Het venster met alles van een soort staat sinds 29-9-2026 in km-kraamvenster.js (C428),
    // zodat de homepage precies hetzelfde venster gebruikt. Hier alleen het doorgeven.
    function openKraam(handle, titel, domein) {
      window.kmKraamVenster.open(handle, titel, domein, { kleuren: cfg.kleuren });
    }
    function sluitKraam() { window.kmKraamVenster.sluit(); }
    // ---- Wachtlijst bij een uitverkochte voorstelling ------------------------
    // Tot nu toe wees een uitverkochte voorstelling naar de nieuwsbrief, en dat is
    // iets anders: "hou mij op de hoogte van alles" in plaats van "ik wilde bij
    // DEZE erbij zijn". Het verschil is niet alleen netter voor de bezoeker, het
    // levert ook de enige informatie op waar je iets aan hebt - voor welke datum
    // de vraag groter was dan de zaal. Daarop besluit je of je een tweede
    // voorstelling plant.
    //
    // Er wordt bewust maar twee dingen gevraagd. Elk extra vakje kost aanmeldingen,
    // en meer dan een naam en een adres is niet nodig om iemand te laten weten dat
    // er plek is.
    // De kanaalknoppen staan als sjabloon in de sectie (zie km-agenda.liquid).
    // We plakken de inhoud mee in de html-string; een style-element werkt ook
    // gewoon als het zo in de pagina komt.
    function kanaalblok() {
      var t = document.getElementById('kmKanaalTpl');
      return t ? '<div class="kmwl-kanaal">' + t.innerHTML + '</div>' : '';
    }

    function wachtlijst(ev) {
      if (!cfg.wachtlijst_url) return '';
      return '<div class="kmwl" data-wl="' + escAttr(ev.id) + '">' +
        '<div class="kmwl-h">' + IC.mail + ' Zet me op de wachtlijst</div>' +
        '<p class="kmwl-p">Komt er een plek vrij of plannen we een extra voorstelling op deze dag?<br>' +
        'Dan laten we het je weten.</p>' +
        '<label class="kmwl-veld kmwl-breed"><span>Je naam</span><input type="text" data-wl-naam autocomplete="name" maxlength="80" placeholder="Voor- en achternaam"></label>' +
        '<div class="kmwl-rij">' +
          '<label class="kmwl-veld"><span>Je e-mailadres</span><input type="email" data-wl-mail autocomplete="email" maxlength="200" placeholder="naam@voorbeeld.nl"></label>' +
          '<label class="kmwl-veld"><span>Of je telefoonnummer</span><input type="tel" data-wl-tel autocomplete="tel" maxlength="40" placeholder="06 12345678"></label>' +
        '</div>' +
        // Twee manieren om bereikbaar te zijn, en een is genoeg. Wie liever niet
        // mailt geeft een nummer; komt er op de dag zelf een plek vrij, dan is
        // bellen of appen sowieso sneller dan een mailtje.
        '<p class="kmwl-uitleg">Eén van de twee is genoeg. Bij een nummer kunnen we ook appen.</p>' +
        // Bewust een leeg vinkje: wie alleen op de wachtlijst wil, hoort geen
        // nieuwsbrief te krijgen omdat hij niet oplette. Sinds dit vinkje er staat
        // belooft de tekst erboven niet meer "je krijgt verder geen nieuwsbrief" -
        // dat sprak elkaar tegen - en noemt het kleine lettertje het vinkje wel.
        '<label class="kmwl-vink"><input type="checkbox" data-wl-nieuwsbrief>' +
        '<span>' + esc(cfg.wachtlijst_nieuwsbrief || 'Gebruik mijn e-mailadres om mij aan te melden voor de nieuwsbrief') + '</span></label>' +
        // Onzichtbaar vakje: mensen zien het niet, robots vullen het wel in.
        '<div class="kmwl-verstopt" aria-hidden="true"><label>Laat dit leeg<input type="text" data-wl-lokaas tabindex="-1" autocomplete="off"></label></div>' +
        '<button type="button" class="kmtkbtn kmwl-knop" data-wl-verstuur>Zet me op de wachtlijst</button>' +
        '<p class="kmwl-melding" role="status" aria-live="polite"></p>' +
        // De uitleg staat op een eigen pagina en niet in het privacybeleid: dat beleid
        // wordt door Shopify bijgehouden, en zodra je er zelf iets in zet stopt dat.
        // Bovendien leest niemand pagina veertien; hier staat het waar het telt.
        '<p class="kmwl-klein">We gebruiken wat je hier invult alleen voor deze wachtlijst. ' +
        'Vink je de nieuwsbrief aan, dan bewaren we je e-mailadres ook daarvoor. ' +
        '<a href="/pages/wachtlijst-en-je-gegevens" data-wl-uitleg rel="noopener">Wat we met je gegevens doen</a></p>' +
        // Volgen kan alleen de bezoeker zelf, dus dit is een knop naast het
        // formulier en geen extra vinkje erin.
        kanaalblok() +
        '</div>';
    }

    // Sinds 2-10-2026 in drie witte kaartjes (Kaartjes, cadeau, bestellen), maar allemaal binnen
    // één .kmtk: plus en min, namen, cadeau en de winkelwagen zoeken elkaar via closest('.kmtk').
    function ticketPicker(ev, voor) {
      if (ev.toegang !== 'kaartverkoop' || ev.externe_ticketlink) return '';
      var types = ticketTypes(ev); if (!types.length) return '';
      // Vol is vol op de kindplekken. Zijn die op maar is er voor volwassenen nog
      // ruimte, dan blijft de kiezer staan met een regel erboven die uitlegt wat er
      // aan de hand is - anders staat er 'uitverkocht' en toch een bestelknop, en
      // dat leest als een fout.
      var kindOp = plekkenOver(ev) <= 0;
      var soldOut = kindOp && !andersNogPlek(ev);
      // Zonder wachtlijst blijft de nieuwsbrief het enige dat je nog kunt aanbieden,
      // dus dan hoort die zin er weer bij te staan.
      if (soldOut) {
        // Het wachtlijstformulier staat onderaan, en wie niet scrolt ziet het nooit.
        // Daarom hier meteen de weg erheen, op de plek waar het slechte nieuws staat.
        var vervolg = cfg.wachtlijst_url ? ''
          : ' Schrijf je in voor de nieuwsbrief, dan hoor je het als er nieuwe data zijn.';
        var naarWl = cfg.wachtlijst_url
          ? '<button type="button" class="kmtk-naarwl" data-wl-spring>' + IC.mail + ' Zet me op de wachtlijst</button>'
          : '';
        return '<div class="kmtk"><div class="kmv-kaart kmv-kaartjes"><h3 class="kmv-h">Kaartjes</h3>' + (voor || '') + '<div class="kmtk-sold">' + IC.lock +
          ' Helaas, uitverkocht<span>Alle kaartjes voor deze voorstelling zijn vergeven.' + vervolg + '</span>' +
          naarWl + '</div></div></div>';
      }
      var h = '<div class="kmtk"><div class="kmv-kaart kmv-kaartjes"><h3 class="kmv-h">Kaartjes</h3>' + (voor || '');
      if (kindOp) {
        // Ook hier staat het wachtlijstformulier verderop, dus ook hier de weg erheen.
        var springKind = cfg.wachtlijst_url
          ? ' <button type="button" class="kmtk-wllink" data-wl-spring>Zet je op de wachtlijst voor een kinderplek</button>'
          : '';
        h += '<div class="kmtk-kindop">' + IC.lock +
          '<span><strong>De kinderplekken zijn vergeven.</strong> Wil je als volwassene ' +
          'toch komen kijken, dan is er nog plek. Gezellig als je erbij bent.' +
          springKind + '</span></div>';
      }
      types.forEach(function (t) {
        // Een kinderkaartje is op zodra de kindplekken op zijn, ook al staat er in
        // Shopify nog wat: die laatste zijn de speelruimte, geen losse kaartjes.
        var out = (t.type === 'Kind') ? (kindOp || t.voorraad <= 0) : t.voorraad <= 0;
        // Vrij = wat er echt nog te vergeven is. Te koop = wat de knop toestaat, en
        // bij kinderen is dat vrij plus de speelruimte: die laatste bestelling mag
        // er nog overheen.
        var vrij = (t.type === 'Kind') ? Math.max(0, plekkenOver(ev)) : t.voorraad;
        var teKoop = out ? 0 : t.voorraad;
        // Nooit zeggen hoeveel kaartjes er nog zijn (Carolien, 2-10-2026): geen "nog 4" meer.
        var showNog = false;
        h += '<div class="kmtkrow" data-max="' + teKoop + '" data-prijs="' + t.prijs + '" data-vid="' + esc(t.id) + '" data-type="' + escAttr(t.type) + '">' +
          '<div class="kmtkinfo"><span class="kmtkl">' + esc(t.label) + (t.sub ? ' <span class="kmtksub">(' + esc(t.sub) + ')</span>' : '') + '</span>' +
          '<span class="kmtkp">' + (t.gratis ? 'Gratis · mag op schoot mee'
            : euro(t.prijs) + (nConsumpties(ev) > 0 ? ' · incl. ' + consumptieTekst(nConsumpties(ev)) : '')) + '</span></div>' +
          (out
            ? '<span class="kmtkout">' + IC.lock + ' uitverkocht</span>'
            : (showNog ? '<span class="kmtknog">nog ' + vrij + '</span>' : '') +
              '<div class="kmstep"><button type="button" class="kmstepb" data-step="-1" aria-label="Minder">–</button><span class="kmstepq" data-qty>0</span><button type="button" class="kmstepb" data-step="1" aria-label="Meer">+</button></div>') +
          '</div>';
      });
      // Namen van de kinderen: alleen aanbieden als er kinderkaartjes zijn. Staat dicht;
      // wie het invult, geeft ons de kans de kinderen bij naam te begroeten.
      var heeftKind = !kindOp && types.filter(function (t) { return t.type === 'Kind' && t.voorraad > 0; }).length > 0;
      if (heeftKind) {
        h += '<div class="kmtk-namebox">' +
          '<button type="button" class="kmtk-namelink" data-namelink aria-expanded="false">' +
          IC.usercheck + ' Namen van de kinderen toevoegen ' +
          '<svg class="ic kmtk-namechev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
          '</button>' +
          '<div class="kmtk-namewrap" data-namewrap>' +
          '<input type="text" class="kmtk-in" data-kidnames placeholder="bijv. Fenna en Sem">' +
          '<p class="kmtk-namenote">Zo kunnen we de kinderen met hun naam aanspreken.</p>' +
          '</div></div>';
      }
      // 'De laatste kaartjes' hoort bij de kindplekken, niet bij het totaal: zijn die
      // op maar is er nog volwassenruimte, dan staat er al een eigen melding boven.
      if (!soldOut && !kindOp && plekkenOver(ev) <= 10) {
        h += '<div class="kmtk-alert">' + IC.flame + ' De laatste kaartjes zijn nu te koop.<br>Wees er snel bij want vol is vol!</div>';
      }
      h += '</div><div class="kmv-kaart kmv-cadeau"><h3 class="kmv-h">Zijn deze kaartjes een cadeau?</h3>' +
        '<div class="kmgift-tiles">' +
        '<button type="button" class="kmgift-tile on" data-gift="self">' + IC.user + '<span>Voor mezelf</span></button>' +
        '<button type="button" class="kmgift-tile" data-gift="gift">' + IC.gift + '<span>Als cadeau</span></button>' +
        '</div>' +
        '<div class="kmgift-box" data-giftbox>' +
        '<p class="kmgift-gt">Wat leuk, een voorstelling cadeau geven!</p>' +
        '<p class="kmgift-gs">Schrijf hieronder een persoonlijk berichtje. Dat komt op het cadeaubewijs te staan.</p>' +
        '<textarea class="kmgift-msg" data-giftmsg rows="5" placeholder="bijv. Lieve Fenna en Sem,&#10;veel plezier bij Kaatje&amp;Mup!&#10;&#10;Dikke kus van oma" aria-required="true"></textarea>' +
        '<p class="kmgift-tip">Je mag gerust op Enter drukken voor een nieuwe regel. Zo blijft het ook op het cadeaubewijs staan.</p>' +
        /* Meekijken terwijl je typt: het berichtje is het hart van het cadeau, en je
           wilt kunnen zien hoe het straks bij de ander op de bon staat. */
        '<div class="kmgift-prev" data-giftprev hidden>' +
        '<p class="kmgift-prevk">Zo komt het op het cadeaubewijs te staan</p>' +
        '<div class="kmgift-prevkaart"><span class="kmgift-prevlabel">Een berichtje voor jou</span>' +
        '<span class="kmgift-prevtekst" data-giftprevtekst></span></div>' +
        '</div>' +
        /* Eén regel in beeld, de rest achter een uitklapper. De volledige uitleg was
           vijf regels lang en kwam precies op het moment dat iemand een persoonlijk
           berichtje zit te typen. Wie het al snapt leest één zin; wie twijfelt klapt open. */
        '<details class="kmgift-hoe2">' +
        '<summary>' + IC.mail + ' <span>Jij krijgt het cadeaubewijs in je mail en stuurt het zelf door. <b>Hoe werkt het?</b></span></summary>' +
        '<div class="kmgift-hoe2b">' +
        '<p>In je bevestigingsmail staat een knop naar <strong>het cadeaubewijs</strong>: een aparte pagina met de voorstelling, de datum, jouw berichtje en de kaartjes, zonder prijzen erop.</p>' +
        '<p>Dat cadeaubewijs stuur je zelf door via WhatsApp of mail of je print het uit en pakt het in.</p>' +
        '<p>De bevestigingsmail zelf is ook je factuur, dus die stuur je liever niet door.</p>' +
        '</div></details>' +
        /* Het zetje naar de cadeaubon stond hier, maar is verhuisd naar de
           bevestigingsmail (29-08-2026). Hier kwam het bovenop een persoonlijk
           berichtje dat iemand net zat te typen, en het maakte het cadeaublok twee
           keer zo hoog. In de mail is de aankoop al gedaan en leeft de vraag
           "hoe maak ik hier iets moois van" juist wel. */
        '</div>';
      h += '</div><div class="kmv-kaart kmv-bestel"><button type="button" class="kmtkbtn" data-cart disabled>In winkelwagen · <span data-carttotal>' + euro(0) + '</span></button>';
      h += '<p class="kmtkerr" data-carterr></p>';
      return h + (cfg.betaalzin || '') + '</div></div>';
    }
    function updateTicketTotals(tk) {
      if (!tk) return;
      var total = 0, count = 0;
      tk.querySelectorAll('.kmtkrow').forEach(function (row) {
        var q = row.querySelector('[data-qty]'); if (!q) return;
        var qty = parseInt(q.textContent, 10) || 0;
        var prijs = parseFloat(row.getAttribute('data-prijs')) || 0;
        var max = parseInt(row.getAttribute('data-max'), 10) || 0;
        total += qty * prijs; count += qty;
        var minus = row.querySelector('[data-step="-1"]'); var plus = row.querySelector('[data-step="1"]');
        if (minus) minus.disabled = qty <= 0;
        if (plus) plus.disabled = qty >= max;
      });
      var tot = tk.querySelector('[data-carttotal]'); if (tot) tot.textContent = euro(total);
      var btn = tk.querySelector('[data-cart]'); if (btn) btn.disabled = count <= 0;
    }

    function readMore(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html.replace(/(<\/(?:p|div|h[1-6]|li)>)/gi, '$1 ');
      var plain = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      if (plain.length <= 200) return '<div class="kmmdesc">' + html + '</div>';
      var cut = plain.slice(0, 175);
      var sp = cut.lastIndexOf(' '); if (sp > 120) cut = cut.slice(0, sp);
      var full = /<\/p>\s*$/.test(html)
        ? html.replace(/<\/p>\s*$/, ' <button type="button" class="kmrm-btn" data-rm-less>Lees minder</button></p>')
        : html + ' <button type="button" class="kmrm-btn" data-rm-less>Lees minder</button>';
      return '<div class="kmmdesc" data-rm>' +
        '<p class="kmrm-collapsed">' + esc(cut) + '… <button type="button" class="kmrm-btn" data-rm-more>Lees meer</button></p>' +
        '<div class="kmrm-full" hidden>' + full + '</div>' +
        '</div>';
    }

    function buildFaq(ev) {
      var qs = [], td = ev.type || [];
      var ld = td.indexOf('voorstelling') > -1
        ? 'De voorstelling is voor kinderen vanaf ongeveer 1,5 tot 10 jaar en duurt ongeveer 45 minuten.'
        : (td.indexOf('knutselcafe') > -1 ? 'Het knutselcafé is voor alle leeftijden, met vrije inloop.' : 'Voor alle leeftijden.');
      qs.push(['Voor welke leeftijd is het en hoe lang duurt het?', ld]);
      qs.push(['Hoe laat moet ik er zijn?', 'Kom gerust een kwartiertje van tevoren, dan kun je rustig een plekje zoeken en op je gemak beginnen.']);
      if (ev.toegang === 'kaartverkoop') {
        qs.push(['Zijn kinderen tot 2 jaar gratis?', 'Ja, kinderen tot 2 jaar mogen gratis op schoot mee.']);
        var nq = nConsumpties(ev);
        if (nq > 0) {
          qs.push([nq === 1 ? 'Wat is die consumptie bij het kaartje?' : 'Wat zijn die consumpties bij het kaartje?',
            'Je kaartje is inclusief ' + consumptieTekst(nq) + ', dus ' + (nq === 1 ? 'een drankje' : nq + ' drankjes') + '. ' +
            consumptieHoe(ev) + ' Zo heeft iedereen meteen wat te drinken en is het lekker gezellig samen.']);
        }
      }
      if (td.indexOf('knutselcafe') > -1) qs.push(['Wat kost het knutselcafé?', 'Het knutselcafé heeft gratis entree. De knutselmaterialen zijn ter plekke verkrijgbaar vanaf € 1,-.']);
      qs.push(['Worden er foto’s gemaakt?', 'Tijdens onze activiteiten maken we soms foto’s en filmpjes voor onze promotie, bijvoorbeeld voor de website en social media. Liever niet in beeld? Laat het ons gerust even weten.']);
      qs.push(['Is er parkeergelegenheid?', 'Bij de meeste locaties kun je in de buurt (gratis) parkeren. Kijk voor de zekerheid bij de locatiegegevens of vraag het de host.']);
      if (ev.toegang === 'kaartverkoop') qs.push(['Kan ik kaartjes ruilen of terugkrijgen?', 'Kaartjes worden niet terugbetaald. Heb je toch een vraag? Neem gerust even contact met ons op.']);
      return qs;
    }

    function faqSection(ev) {
      var afw = richText(ev.faq);
      var h = '<div class="kmsec-h">Veelgestelde vragen</div>';
      if (afw) h += '<div class="kmfaq-note">' + afw + '</div>';
      h += '<div class="kmfaq">';
      buildFaq(ev).forEach(function (q) {
        h += '<details class="kmfaq-item"><summary class="kmfaq-q"><span>' + esc(q[0]) + '</span><span class="kmfaq-ic">' + IC.chev + '</span></summary><div class="kmfaq-a">' + esc(q[1]) + '</div></details>';
      });
      return h + '</div>';
    }

    var curEvent = null;
    // Lightbox
    var lightbox = document.createElement('div');
    lightbox.className = 'kmlb';
    lightbox.innerHTML = '<button class="kmlb-close" data-lb-close aria-label="Sluiten">' + IC.x + '</button><button class="kmlb-nav kmlb-prev" data-lb-prev aria-label="Vorige">‹</button><div class="kmlb-stage"></div><button class="kmlb-nav kmlb-next" data-lb-next aria-label="Volgende">›</button><div class="kmlb-count"></div>';
    root.appendChild(lightbox);
    var lbMedia = [], lbIndex = 0;
    function showLb() {
      var m = lbMedia[lbIndex]; if (!m) return;
      var stage = lightbox.querySelector('.kmlb-stage');
      if (m.type === 'video') stage.innerHTML = '<video class="kmlb-media" src="' + esc(m.src) + '" controls autoplay playsinline></video>';
      else if (m.type === 'logo') stage.innerHTML = '<figure class="kmlb-logo"><img src="' + esc(m.full) + '" alt="' + escAttr(m.naam) + '"><figcaption>' + esc(m.naam) + '</figcaption></figure>';
      else stage.innerHTML = '<img class="kmlb-media" src="' + esc(m.full) + '" alt="">';
      lightbox.querySelector('.kmlb-count').textContent = (m.type === 'video' ? 'Filmpje ' : m.type === 'logo' ? 'Logo ' : 'Foto ') + (lbIndex + 1) + ' van ' + lbMedia.length;
      var nav = lbMedia.length > 1 ? '' : 'none'; lightbox.querySelector('.kmlb-prev').style.display = nav; lightbox.querySelector('.kmlb-next').style.display = nav;
    }
    function openLb(media, i) { lbMedia = media || []; lbIndex = i || 0; showLb(); lightbox.classList.add('open'); }
    function closeLb() { lightbox.classList.remove('open'); lightbox.querySelector('.kmlb-stage').innerHTML = ''; }
    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]') || e.target === lightbox) closeLb();
      else if (e.target.closest('[data-lb-prev]')) { lbIndex = (lbIndex - 1 + lbMedia.length) % lbMedia.length; showLb(); }
      else if (e.target.closest('[data-lb-next]')) { lbIndex = (lbIndex + 1) % lbMedia.length; showLb(); }
    });

    // Winkelwagen-lade (zijpaneel): tussenstap voor het afrekenen, leest de echte Shopify-winkelwagen.
    var drawer = document.createElement('div');
    drawer.className = 'kmcart';
    drawer.innerHTML = '<div class="kmcart-back" data-cart-close></div><div class="kmcart-panel">' +
      '<div class="kmcart-head"><span class="kmcart-title">' + IC.cart + ' Winkelwagen</span><button type="button" class="kmcart-close" data-cart-close aria-label="Sluiten">' + IC.x + '</button></div>' +
      '<div class="kmcart-body" data-cart-body></div>' +
      '<div class="kmcart-extra" data-cart-extra style="display:none"></div>' +
      '<div class="kmcart-foot"><div class="kmcart-sub"><span>Totaal</span><span data-cart-total>' + euro(0) + '</span></div>' +
      '<div class="kmcart-trust" data-cart-trust></div>' +
      '<div class="kmcart-btns"><button type="button" class="kmscnd" data-cart-close>Verder winkelen</button><button type="button" class="kmtkbtn" data-cart-checkout>' + IC.ticket + ' Afrekenen</button></div>' +
      // Welke betaalmanieren er zijn, vlak bij de knop (C438, uit snippets/km-betaalzin.liquid).
      (cfg.betaalzin || '') + '</div>';
    root.appendChild(drawer);
    var fab = document.createElement('button');
    fab.type = 'button'; fab.className = 'kmcartfab'; fab.setAttribute('data-cart-open', '');
    // Het woord erachter buigt mee met wat er werkelijk in de wagen ligt. Stond
     // hier vast 'kaartjes', dan meldde de knop "4 kaartjes" terwijl het twee
     // kaartjes, een cadeaubon en een sleutelhanger waren.
    fab.innerHTML = IC.cart + ' <span data-fab-count>0</span> <span data-fab-woord>artikelen</span>';
    root.appendChild(fab);

    // Wat telt als een kaartje in de winkelwagen. Het producttype van onze kaartjes
    // is 'Kaartje'; op vier plekken stond hier 'Evenement-ticket', en dat bestaat in
    // de winkel helemaal niet. Daardoor werd een kaartje in het bestelscherm als een
    // gewoon product behandeld: geen kopje met de voorstelling erboven, geen vakje
    // voor de namen van de kinderen, en het rijtje 'leuk om erbij te bestellen'
    // verscheen nooit. Nu op één plek geregeld, zodat het niet weer uit elkaar loopt.
    var TICKETSOORTEN = ['Kaartje'];
    function isKaartjeRegel(it) { return TICKETSOORTEN.indexOf(it.product_type) >= 0; }

    function cartLine(it) {
      // Bij kaartjes staat de voorstelling al als kopje boven de groep, dus daar is de
      // variant genoeg. Bij alles daarbuiten hoort de productnaam erbij.
      var label = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : it.product_title;
      if (!isKaartjeRegel(it) && it.variant_title && it.variant_title !== 'Default Title') {
        label = it.product_title + ' · ' + it.variant_title;
      }
      var priceTxt = it.final_line_price === 0 ? 'Gratis' : euro(it.final_line_price / 100);
      return '<div class="kmcart-line"><span class="kmcart-line-l"><span class="kmcart-x2">' + it.quantity + '×</span> ' + esc(label) + '</span>' +
        '<span class="kmcart-line-r">' + priceTxt + '<button type="button" class="kmcart-del" data-cart-remove="' + esc(it.key) + '" aria-label="Verwijderen">' + IC.x + '</button></span></div>';
    }
    function renderDrawer() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var count = cart.item_count || 0;
        var hasTickets = (cart.items || []).some(isKaartjeRegel);
        var ex = drawer.querySelector('[data-cart-extra]'); if (ex) ex.style.display = (hasTickets && crossData.length) ? '' : 'none';
        fab.style.display = count > 0 ? 'inline-flex' : 'none';
        var fc = fab.querySelector('[data-fab-count]'); if (fc) fc.textContent = count;
        // Alleen 'kaartjes' als het ook echt allemaal kaartjes zijn; zit er iets
        // anders bij, dan het neutrale woord. Zo klopt de knop altijd.
        var fw = fab.querySelector('[data-fab-woord]');
        if (fw) {
          var kaartjes = (cart.items || []).filter(isKaartjeRegel)
            .reduce(function (n, it) { return n + it.quantity; }, 0);
          fw.textContent = (kaartjes === count)
            ? (count === 1 ? 'kaartje' : 'kaartjes')
            : (count === 1 ? 'artikel' : 'artikelen');
        }
        drawer.querySelector('[data-cart-total]').textContent = euro((cart.total_price || 0) / 100);
        /* De regel boven de afrekenknop beantwoordt de vraag 'wat krijg ik nu eigenlijk?'.
           Die stond vast en beloofde altijd een cadeaubewijs, ook zonder cadeau, en
           altijd 'alles per mail', ook als er een t-shirt in de wagen lag dat gewoon
           verstuurd wordt. Hij buigt nu mee met de inhoud. */
        var trust = drawer.querySelector('[data-cart-trust]');
        if (trust) {
          var rgls = cart.items || [];
          var heeftKaartje = rgls.some(isKaartjeRegel);
          var heeftSpullen = rgls.some(function (it) { return !isKaartjeRegel(it); });
          var heeftCadeau = rgls.some(function (it) {
            return it.properties && it.properties['Cadeau'] === 'Ja';
          });
          var z = [];
          if (heeftKaartje) z.push('Je kaartjes komen per mail, met een QR-code voor aan de deur.');
          if (heeftCadeau) z.push('Er zit een cadeaubewijs bij om door te sturen of uit te printen.');
          if (heeftSpullen) z.push(heeftKaartje
            ? 'De rest sturen we je toe.'
            : 'We sturen je bestelling zo snel mogelijk op.');
          trust.innerHTML = z.length ? IC.check + ' ' + z.join(' ') : '';
          trust.style.display = z.length ? '' : 'none';
        }
        var body = drawer.querySelector('[data-cart-body]');
        if (!cart.items || !cart.items.length) { body.innerHTML = '<p class="kmcart-empty">Je winkelwagen is nog leeg.</p>'; return cart; }
        var groups = {}, order = [], extras = [];
        cart.items.forEach(function (it) {
          if (isKaartjeRegel(it)) {
            var itDate = (it.properties && it.properties['Datum']) || '';
            var k = it.product_id + '|' + itDate;
            if (!groups[k]) { groups[k] = { title: it.product_title, date: itDate, lines: [] }; order.push(k); }
            groups[k].lines.push(it);
          } else { extras.push(it); }
        });
        var TYPE_ORDER = { 'Kind': 0, 'Volwassene': 1, 'Baby': 2 };
        function typeRank(t) { return (TYPE_ORDER[t] != null) ? TYPE_ORDER[t] : 8; }
        var h = '';
        order.forEach(function (k) {
          var g = groups[k];
          g.lines.sort(function (a, b) { return typeRank(a.variant_title) - typeRank(b.variant_title); });
          h += '<div class="kmcart-grp"><div class="kmcart-grp-h"><span class="kmcart-grp-t">' + esc(g.title) + '</span>' + (g.date ? '<span class="kmcart-grp-d">' + IC.cal + esc(g.date) + '</span>' : '') + '</div>';
          g.lines.forEach(function (it) { h += cartLine(it); });
          var kind = g.lines.filter(function (it) { return it.variant_title === 'Kind'; })[0];
          if (kind) {
            var nm = (kind.properties && kind.properties['Namen kinderen']) || '';
            h += '<div class="kmcart-names">' + (nm
              ? '<span class="kmcart-names-l">' + IC.usercheck + ' ' + esc(nm) + '</span><button type="button" class="kmcart-nameed" data-name-edit data-key="' + escAttr(kind.key) + '" data-name="' + escAttr(nm) + '">wijzig</button>'
              : '<button type="button" class="kmcart-addnames" data-name-edit data-key="' + escAttr(kind.key) + '" data-name="">' + IC.usercheck + ' Namen van de kinderen toevoegen</button>') + '</div>';
          }
          var giftLine = g.lines.filter(function (it) { return it.properties && it.properties['Cadeau'] === 'Ja'; })[0];
          if (giftLine) {
            var gmsg = (giftLine.properties && giftLine.properties['Cadeaubericht']) || '';
            h += '<div class="kmcart-gift">' + IC.gift + '<span class="kmcart-gift-l">Cadeau' + (gmsg ? ': <em>“' + esc(gmsg) + '”</em>' : '') + '</span></div>';
          }
          h += '</div>';
        });
        if (extras.length) { h += '<div class="kmcart-grp"><span class="kmcart-grp-t">Extra\'s</span>'; extras.forEach(function (it) { h += cartLine(it); }); h += '</div>'; }
        body.innerHTML = h;
        return cart;
      }).catch(function () { });
    }
    function openDrawer() { renderDrawer(); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('open'); document.body.style.overflow = ''; }

    // ---- Namen van de kinderen, laatste kans vlak voor het afrekenen ----------------
    var namenLaag = document.createElement('div');
    namenLaag.className = 'kmnamen';
    namenLaag.innerHTML = '<div class="kmnamen-back" data-namen-sluit></div><div class="kmnamen-panel">' +
      '<button type="button" class="kmnamen-close" data-namen-sluit aria-label="Sluiten">' + IC.x + '</button>' +
      '<div data-namen-body></div></div>';
    root.appendChild(namenLaag);
    var namenGroepen = [];

    function naarKassa() { window.location.href = '/checkout'; }

    function afrekenen() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var perGroep = {}, orde = [];
        (cart.items || []).forEach(function (it) {
          if (!isKaartjeRegel(it) || it.variant_title !== 'Kind') return;
          var datum = (it.properties && it.properties['Datum']) || '';
          var k = it.product_id + '|' + datum;
          if (!perGroep[k]) { perGroep[k] = { titel: it.product_title, datum: datum, naam: '', regels: [] }; orde.push(k); }
          perGroep[k].regels.push(it);
          var n = it.properties && it.properties['Namen kinderen'];
          if (n && !perGroep[k].naam) perGroep[k].naam = n;
        });
        namenGroepen = orde.map(function (k) { return perGroep[k]; });
        var ontbreekt = namenGroepen.filter(function (g) { return !g.naam; });
        if (!namenGroepen.length || !ontbreekt.length) { naarKassa(); return; }
        var h = '<div class="kmnames-ic">' + IC.usercheck + '</div>' +
          '<p class="kmth-h">Voor welke kinderen zijn de kaartjes?</p>' +
          '<p class="kmth-sub">Zo kunnen we de kinderen tijdens het evenement met hun naam aanspreken.</p>' +
          '<div class="kmnames-list">';
        namenGroepen.forEach(function (g, i) {
          h += '<div class="kmnames-row"><span class="kmnames-ev">' + esc(g.titel) + '</span>' +
            (g.datum ? '<span class="kmnames-date">' + IC.cal + esc(g.datum) + '</span>' : '') +
            '<input type="text" class="kmtk-in" data-namen-veld="' + i + '" value="' + escAttr(g.naam) + '" placeholder="bijv. Fenna en Sem"></div>';
        });
        h += '</div><p class="kmnames-skipnote">Niet verplicht. Je mag dit ook overslaan.</p>' +
          '<div class="kmnames-btns"><button type="button" class="kmscnd" data-namen-over>Overslaan</button>' +
          '<button type="button" class="kmtkbtn" data-namen-verder>Ga verder</button></div>';
        namenLaag.querySelector('[data-namen-body]').innerHTML = h;
        namenLaag.classList.add('open');
        var eerste = namenLaag.querySelector('input[data-namen-veld]'); if (eerste) eerste.focus();
      }).catch(naarKassa);
    }

    // De namen bewaren bij de kinderkaartjes en dan door naar de kassa. Eén regel per keer,
    // want Shopify verwerkt wijzigingen aan de winkelwagen niet door elkaar heen.
    function bewaarNamenEnDoor() {
      var taken = [];
      namenLaag.querySelectorAll('input[data-namen-veld]').forEach(function (inp) {
        var g = namenGroepen[+inp.getAttribute('data-namen-veld')]; if (!g) return;
        var val = (inp.value || '').trim();
        g.regels.forEach(function (regel) {
          var props = {};
          if (regel.properties) { for (var p in regel.properties) props[p] = regel.properties[p]; }
          if (val) props['Namen kinderen'] = val; else delete props['Namen kinderen'];
          taken.push({ id: regel.key, quantity: regel.quantity, properties: props });
        });
      });
      var verder = namenLaag.querySelector('[data-namen-verder]');
      if (verder) { verder.disabled = true; verder.textContent = 'Bezig…'; }
      taken.reduce(function (rij, taak) {
        return rij.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(taak) });
        });
      }, Promise.resolve()).then(naarKassa).catch(naarKassa);
    }

    namenLaag.addEventListener('click', function (e) {
      if (e.target.closest('[data-namen-sluit]')) { namenLaag.classList.remove('open'); return; }
      if (e.target.closest('[data-namen-over]')) { naarKassa(); return; }
      if (e.target.closest('[data-namen-verder]')) { bewaarNamenEnDoor(); return; }
    });
    namenLaag.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input[data-namen-veld]')) { e.preventDefault(); bewaarNamenEnDoor(); }
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-cart-checkout]')) { afrekenen(); return; }
      var kleur = e.target.closest('[data-kleur]');
      if (kleur) {
        var rij = kleur.closest('.kmcart-x');
        rij.querySelectorAll('[data-kleur]').forEach(function (k) { k.classList.toggle('on', k === kleur); });
        var lijst = rij.querySelector('.kmcart-sel--kleur');
        if (lijst) lijst.value = kleur.getAttribute('data-kleur');
        return;
      }
      var crossAdd = e.target.closest('[data-cross-add]');
      if (crossAdd) {
        var p = crossData[+crossAdd.getAttribute('data-cross-add')]; if (!p) return;
        var vid;
        if ((p.varianten || []).length <= 1 || (p.opties.length === 1 && p.opties[0].naam === 'Title')) { vid = p.varianten[0] && p.varianten[0].id; }
        else {
          var chosen = [], missing = false;
          crossAdd.closest('.kmcart-x').querySelectorAll('.kmcart-sel').forEach(function (s) { if (!s.value) missing = true; chosen.push(s.value); });
          if (missing) { var b0 = crossAdd.textContent; crossAdd.textContent = 'Kies opties'; setTimeout(function () { crossAdd.textContent = b0; }, 1400); return; }
          var match = (p.varianten || []).filter(function (v) { return (v.opties || []).length === chosen.length && v.opties.every(function (ov, i) { return ov === chosen[i]; }); })[0];
          vid = match && match.id;
        }
        if (!vid) return;
        crossAdd.disabled = true; var oldtxt = crossAdd.textContent; crossAdd.textContent = 'Bezig…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
          .then(function (r) { return r.json(); }).then(function () { crossAdd.disabled = false; crossAdd.textContent = 'Toegevoegd ✓'; setTimeout(function () { crossAdd.textContent = oldtxt; }, 1400); renderDrawer(); })
          .catch(function () { crossAdd.disabled = false; crossAdd.textContent = oldtxt; });
        return;
      }
      var nameEdit = e.target.closest('[data-name-edit]');
      if (nameEdit) {
        var wrap = nameEdit.closest('.kmcart-names');
        var cur = nameEdit.getAttribute('data-name') || '';
        wrap.innerHTML = '<input class="kmcart-nameinput" type="text" placeholder="bijv. Fenna en Sem"><button type="button" class="kmcart-namesave" data-name-save data-key="' + escAttr(nameEdit.getAttribute('data-key')) + '">Klaar</button>';
        var inp = wrap.querySelector('input'); inp.value = cur; inp.focus();
        return;
      }
      var nameSave = e.target.closest('[data-name-save]');
      if (nameSave) {
        var key2 = nameSave.getAttribute('data-key');
        var val = (nameSave.closest('.kmcart-names').querySelector('.kmcart-nameinput').value || '').trim();
        nameSave.disabled = true;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var line = (cart.items || []).filter(function (it) { return it.key === key2; })[0];
          if (!line) { renderDrawer(); return; }
          var props = {}; if (line.properties) { for (var p in line.properties) props[p] = line.properties[p]; }
          if (val) props['Namen kinderen'] = val; else delete props['Namen kinderen'];
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key2, quantity: line.quantity, properties: props }) }).then(function () { renderDrawer(); });
        });
        return;
      }
      var rem = e.target.closest('[data-cart-remove]');
      if (rem) {
        rem.disabled = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: rem.getAttribute('data-cart-remove'), quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(function () { renderDrawer(); });
        return;
      }
    });
    fab.addEventListener('click', openDrawer);
    // Alleen tonen wat er ook echt ligt: is een product helemaal uitverkocht, dan schuift
    // het volgende uit de lijst door. Zo staat er nooit een leeg shirt in de winkelwagen.
    function opVoorraad(p) {
      if (p.eigen_pagina) return true;
      return (p.varianten || []).some(function (v) { return v.beschikbaar; });
    }
    function renderCrossInto(sel, volleLijst, listIdx, heading) {
      var ex = drawer.querySelector(sel); if (!ex) return;
      var list = (volleLijst || []).filter(opVoorraad).slice(0, 3);
      if (!list.length) { ex.innerHTML = ''; return; }
      var h = '<div class="kmcart-extra-h">' + esc(heading) + '</div>';
      list.forEach(function (p, pi) {
        var single = (p.varianten || []).length <= 1 || (p.opties.length === 1 && p.opties[0].naam === 'Title');
        // Een cadeaubon kan niet snel toegevoegd worden: op de eigen pagina vul je het
        // mailadres van de ontvanger, het berichtje en de verstuurdatum in. Dus een link
        // in plaats van een plusknop, en in een nieuw tabblad zodat de kaartjes blijven staan.
        var knop = p.eigen_pagina
          ? '<button type="button" class="kmcart-xadd" data-bon-open>Kiezen</button>'
          : '<button type="button" class="kmcart-xadd" data-kleding-open="' + escAttr(p.titel) + '">Kiezen</button>';
        // De kleurbolletjes horen bij het product, dus ze staan in dezelfde kolom als de
        // naam en de prijs, netjes onder elkaar in plaats van als losse regel onder de rij.
        var keuzes = (single || p.eigen_pagina ? '' : '<div class="kmcart-xopts">' + p.opties.filter(function (o) { return o.codes && o.codes.length; }).map(function (o) {
            // Kleur wordt een rijtje bolletjes; de keuze gaat naar een verborgen lijst,
            // zodat het uitzoeken van de juiste variant hetzelfde blijft werken.
            if (o.codes && o.codes.length) {
              var beschikbaar = o.waarden.filter(function (w) {
                return (p.varianten || []).some(function (v) { return v.beschikbaar && (v.opties || []).indexOf(w) > -1; });
              });
              if (!beschikbaar.length) beschikbaar = o.waarden;
              return '<div class="kmcart-kleuren">' + beschikbaar.map(function (w) {
                var code = o.codes[o.waarden.indexOf(w)] || '';
                return '<button type="button" class="kmcart-kleur" data-kleur="' + escAttr(w) + '" title="' + escAttr(w) + '" aria-label="' + escAttr(w) + '"' +
                  (code ? ' style="background:' + escAttr(code) + '"' : '') + '></button>';
              }).join('') + '</div>' +
              '<select class="kmcart-sel kmcart-sel--kleur" hidden><option value="">' + esc(o.naam) + '</option>' +
              beschikbaar.map(function (w) { return '<option value="' + escAttr(w) + '">' + esc(w) + '</option>'; }).join('') + '</select>';
            }
            return '<select class="kmcart-sel"><option value="">' + esc(o.naam) + '…</option>' + o.waarden.map(function (w) { return '<option value="' + escAttr(w) + '">' + esc(w) + '</option>'; }).join('') + '</select>';
          }).join('') + '</div>');
        h += '<div class="kmcart-x">' +
          '<div class="kmcart-xthumb"' + (p.afbeelding ? ' style="background-image:url(' + esc(p.afbeelding) + ')"' : '') + '></div>' +
          '<div class="kmcart-xinfo">' +
            '<span class="kmcart-xname">' + esc(p.titel) + '</span>' +
            '<span class="kmcart-xprice">' + (p.meerdere_prijzen ? 'vanaf ' : '') + euro(p.prijs_cent / 100) + '</span>' +
            keuzes +
          '</div>' +
          knop +
          '</div>';
      });
      ex.innerHTML = h;
    }
    // ---- Cadeaubon-pop-up ---------------------------------------------------------
    // De bon is een echte Shopify-cadeaubon. Op de productpagina staat een formulier voor
    // de ontvanger; die velden bouwen we hier na, zodat iemand die kaartjes aan het kiezen
    // is niet naar een andere pagina hoeft. De veldnamen zijn die van Shopify zelf.
    var bonLaag = document.createElement('div');
    bonLaag.className = 'kmbon';
    bonLaag.innerHTML = '<div class="kmbon-back" data-bon-sluit></div><div class="kmbon-panel">' +
      '<button type="button" class="kmbon-close" data-bon-sluit aria-label="Sluiten">' + IC.x + '</button>' +
      '<div data-bon-body></div></div>';
    root.appendChild(bonLaag);

    function bonProduct() {
      return crossData.filter(function (p) { return p.eigen_pagina; })[0] || null;
    }
    function openBon() {
      var p = bonProduct(); if (!p) return;
      var plaat = (cfg.bon_blanco || p.afbeelding || '');
      var h = '<div class="kmbon-kop">' +
        '<p class="kmbon-titel">' + esc(p.titel) + '</p>' +
        '<p class="kmkleding-prijs">vanaf ' + euro(p.prijs_cent / 100) + '</p>' +
        (plaat ? '<div class="kmbon-plaat"><img src="' + escAttr(plaat) + '" alt="">' +
          (cfg.bon_achter ? '<img class="kmbon-plaatachter" src="' + escAttr(cfg.bon_achter) + '" alt="">' : '') +
          '<span class="kmbon-plaattekst" data-bon-plaattekst></span></div>' +
          '<p class="kmbon-draai">Beweeg over de bon voor de achterkant</p>' : '') +
        '<p class="kmbon-sub">Hiermee mag hij of zij zelf iets uitzoeken bij Kaatje&amp;Mup: tijdens het evenement bij onze kraam (Kaatje&amp;Mup spullen en knutselmateriaal) of thuis in de webshop.</p>' +
        '</div><p class="kmbon-label">Kies een bedrag</p><div class="kmbon-bedragen">';
      (p.varianten || []).forEach(function (v, i) {
        h += '<button type="button" class="kmbon-bedrag' + (i === 0 ? ' on' : '') + '" data-bon-bedrag="' + escAttr(v.id) + '" data-bon-prijs="' + (v.prijs_cent / 100) + '">' + euro(v.prijs_cent / 100) + '</button>';
      });
      h += '</div>' +
        '<label class="kmbon-vink"><input type="checkbox" data-bon-mail>' +
        '<span>Geef deze bon cadeau: wij mailen hem rechtstreeks naar de gelukkige</span></label>' +
        '<div class="kmbon-velden" data-bon-velden>' +
        '<input type="email" class="kmtk-in" data-bon-email placeholder="E-mailadres van de ontvanger">' +
        '<input type="text" class="kmtk-in" data-bon-naam placeholder="Naam (mag je leeg laten)">' +
        '<textarea class="kmtk-in" data-bon-bericht rows="2" placeholder="bijv. Lieve Fenna, veel plezier bij Kaatje&Mup! Groetjes oma"></textarea>' +
        '<p class="kmbon-veldlabel">Op welke dag mag de bon aankomen?</p>' +
        '<input type="date" class="kmtk-in" data-bon-datum aria-label="Verstuurdatum">' +
        '<p class="kmbon-note">Kies bijvoorbeeld de verjaardag. Laat je dit leeg, dan gaat hij meteen weg.</p>' +
        '</div>' +
        '<p class="kmbon-uitleg">De bon komt hoe dan ook in <strong>jouw</strong> mailbox, zodat je hem kunt uitprinten of zelf doorsturen. Vul je hierboven een adres in, dan krijgt de ontvanger hem daarnaast ook rechtstreeks van ons.</p>' +
        '<button type="button" class="kmtkbtn" data-bon-toevoegen>In winkelwagen · <span data-bon-totaal></span></button>' +
        '<p class="kmtkerr" data-bon-fout></p>';
      bonLaag.querySelector('[data-bon-body]').innerHTML = h;
      werkBonBij();
      bonLaag.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function sluitBon() { bonLaag.classList.remove('open'); document.body.style.overflow = ''; }
    function werkBonBij() {
      var gekozen = bonLaag.querySelector('.kmbon-bedrag.on');
      var tot = bonLaag.querySelector('[data-bon-totaal]');
      if (tot && gekozen) tot.textContent = euro(parseFloat(gekozen.getAttribute('data-bon-prijs')));
      var plaattekst = bonLaag.querySelector('[data-bon-plaattekst]');
      if (plaattekst && gekozen) plaattekst.textContent = 'Cadeaubon t.w.v. ' + euro(parseFloat(gekozen.getAttribute('data-bon-prijs')));
      var vink = bonLaag.querySelector('[data-bon-mail]');
      var velden = bonLaag.querySelector('[data-bon-velden]');
      if (velden) velden.classList.toggle('open', !!(vink && vink.checked));
    }
    bonLaag.addEventListener('click', function (e) {
      if (e.target.closest('[data-bon-sluit]')) { sluitBon(); return; }
      var bedrag = e.target.closest('[data-bon-bedrag]');
      if (bedrag) {
        bonLaag.querySelectorAll('.kmbon-bedrag').forEach(function (b) { b.classList.toggle('on', b === bedrag); });
        werkBonBij(); return;
      }
      var toe = e.target.closest('[data-bon-toevoegen]');
      if (toe) {
        var gekozen = bonLaag.querySelector('.kmbon-bedrag.on'); if (!gekozen) return;
        var fout = bonLaag.querySelector('[data-bon-fout]'); if (fout) fout.textContent = '';
        var props = {};
        var vink = bonLaag.querySelector('[data-bon-mail]');
        if (vink && vink.checked) {
          var mail = (bonLaag.querySelector('[data-bon-email]').value || '').trim();
          if (!mail) { if (fout) fout.textContent = 'Vul een e-mailadres in of haal het vinkje weg.'; return; }
          props['__shopify_send_gift_card_to_recipient'] = 'true';
          props['Recipient email'] = mail;
          var naam = (bonLaag.querySelector('[data-bon-naam]').value || '').trim();
          if (naam) props['Recipient name'] = naam;
          var ber = (bonLaag.querySelector('[data-bon-bericht]').value || '').trim();
          if (ber) props['Message'] = ber;
          var dat = (bonLaag.querySelector('[data-bon-datum]').value || '').trim();
          if (dat) props['Send on'] = dat;
        }
        toe.disabled = true; var oud = toe.innerHTML; toe.textContent = 'Bezig…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: gekozen.getAttribute('data-bon-bedrag'), quantity: 1, properties: props }] }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            toe.disabled = false; toe.innerHTML = oud;
            if (res.ok) { sluitBon(); renderDrawer(); openDrawer(); }
            else if (fout) fout.textContent = (res.d && res.d.description) || 'Er ging iets mis. Probeer het opnieuw.';
          })
          .catch(function () { toe.disabled = false; toe.innerHTML = oud; if (fout) fout.textContent = 'Er ging iets mis. Probeer het opnieuw.'; });
        return;
      }
    });
    bonLaag.addEventListener('change', function (e) { if (e.target.matches('[data-bon-mail]')) werkBonBij(); });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-bon-open]')) { e.preventDefault(); openBon(); } });

    // ---- Kleding-pop-up ------------------------------------------------------------
    // Zelfde opzet als de cadeaubon-pop-up: kleur en maat kiezen zonder de pagina te
    // verlaten. Met pijltjes blader je door alle Kaatje&Mup shirts en hoodies.
    var kledingLaag = document.createElement('div');
    kledingLaag.className = 'kmbon kmkleding';
    kledingLaag.innerHTML = '<div class="kmbon-back" data-kleding-sluit></div><div class="kmbon-panel">' +
      '<button type="button" class="kmbon-close" data-kleding-sluit aria-label="Sluiten">' + IC.x + '</button>' +
      '<div data-kleding-body></div></div>';
    root.appendChild(kledingLaag);

    // Blader alleen door dezelfde soort: bij een t-shirt geen hoodies ertussen.
    var kledingSoort = null;
    function kledingLijst() {
      return crossData.filter(function (p) {
        if (p.eigen_pagina || !opVoorraad(p)) return false;
        return !kledingSoort || p.soort === kledingSoort;
      });
    }
    var kledingIndex = 0;
    function toonKleding() {
      var lijst = kledingLijst(); if (!lijst.length) return;
      if (kledingIndex < 0) kledingIndex = lijst.length - 1;
      if (kledingIndex >= lijst.length) kledingIndex = 0;
      var p = lijst[kledingIndex];
      var kleurOptie = (p.opties || []).filter(function (o) { return o.codes && o.codes.length; })[0];
      var maatOptie = (p.opties || []).filter(function (o) { return !(o.codes && o.codes.length); })[0];
      var kleuren = kleurOptie ? kleurOptie.waarden.filter(function (w) {
        return (p.varianten || []).some(function (v) { return v.beschikbaar && (v.opties || []).indexOf(w) > -1; });
      }) : [];
      var eersteKleur = kleuren[0] || '';
      var uitverkocht = !opVoorraad(p);
      var h = '<div class="kmbon-kop">' +
        (lijst.length > 1 ? '<div class="kmkleding-bladeren">' +
          '<button type="button" class="kmkleding-pijl" data-kleding-stap="-1">' + IC.chev + ' <span>Vorige</span></button>' +
          '<span class="kmkleding-teller">' + (kledingIndex + 1) + ' van ' + lijst.length + '</span>' +
          '<button type="button" class="kmkleding-pijl" data-kleding-stap="1"><span>Volgende</span> ' + IC.chev + '</button>' +
        '</div>' : '') +
        '<p class="kmbon-titel">' + esc(p.titel) + '</p>' +
        '<p class="kmkleding-prijs">' + euro(p.prijs_cent / 100) + (uitverkocht ? ' <span class="kmkleding-uitverkocht">uitverkocht</span>' : '') + '</p>' +
        '<div class="kmkleding-fotovak">' +
          (p.afbeelding_groot || p.afbeelding ? '<img class="kmkleding-foto" src="' + escAttr(p.afbeelding_groot || p.afbeelding) + '" alt="" data-kleding-foto>' : '') +
          (p.achterkant ? '<img class="kmkleding-foto kmkleding-achter" src="' + escAttr(p.achterkant) + '" alt="" data-kleding-achter>' : '') +
        '</div>' +
        (p.achterkant ? '<p class="kmbon-draai">Beweeg over de foto voor de achterkant</p>' : '') +
        (p.beschrijving ? '<div class="kmbon-sub kmkleding-tekst" data-kleding-tekst><span data-kleding-kort>' + esc(p.beschrijving) + '</span>' +
          '<button type="button" class="kmkleding-meer" data-kleding-meer>Lees meer</button></div>' : '') +
        '</div>';
      if (kleuren.length) {
        h += '<p class="kmbon-label">Kies een kleur</p><div class="kmkleding-kleuren">' +
          kleuren.map(function (w, i) {
            var code = kleurOptie.codes[kleurOptie.waarden.indexOf(w)] || '';
            return '<button type="button" class="kmkleding-kleur' + (i === 0 ? ' on' : '') + '" data-kkleur="' + escAttr(w) + '" title="' + escAttr(w) + '" aria-label="' + escAttr(w) + '"' +
              (code ? ' style="background:' + escAttr(code) + '"' : '') + '></button>';
          }).join('') + '</div><p class="kmkleding-kleurnaam" data-kleding-kleurnaam>' + esc(eersteKleur) + '</p>';
      }
      if (maatOptie) {
        h += '<p class="kmbon-label">Kies een maat</p><div class="kmkleding-maten" data-kleding-maten></div>';
      }
      h += '<button type="button" class="kmtkbtn" data-kleding-toevoegen>In winkelwagen · ' + euro(p.prijs_cent / 100) + '</button>' +
        '<p class="kmtkerr" data-kleding-fout></p>';
      kledingLaag.querySelector('[data-kleding-body]').innerHTML = h;
      werkMatenBij();
      kledingLaag.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function huidigeKleding() { var l = kledingLijst(); return l[kledingIndex]; }
    function werkMatenBij() {
      var p = huidigeKleding(); if (!p) return;
      var vak = kledingLaag.querySelector('[data-kleding-maten]'); if (!vak) return;
      var kleurKnop = kledingLaag.querySelector('.kmkleding-kleur.on');
      var kleur = kleurKnop ? kleurKnop.getAttribute('data-kkleur') : null;
      var maatOptie = (p.opties || []).filter(function (o) { return !(o.codes && o.codes.length); })[0];
      if (!maatOptie) return;
      vak.innerHTML = maatOptie.waarden.map(function (m) {
        var kan = (p.varianten || []).some(function (v) {
          return v.beschikbaar && (v.opties || []).indexOf(m) > -1 && (!kleur || (v.opties || []).indexOf(kleur) > -1);
        });
        return '<button type="button" class="kmkleding-maat' + (kan ? '' : ' uit') + '" data-kmaat="' + escAttr(m) + '"' + (kan ? '' : ' disabled') + '>' + esc(m) + '</button>';
      }).join('');
      var naam = kledingLaag.querySelector('[data-kleding-kleurnaam]');
      if (naam && kleur) naam.textContent = kleur;
      // Laat de foto van de gekozen kleur zien - voorkant en achterkant allebei.
      // De achterkant bleef eerst hangen op die van de eerste kleur: hij werd een
      // keer uit de tweede productfoto gehaald en daarna nooit meer bijgewerkt.
      if (kleur) {
        var paar = (p.kleurfotos || {})[kleur] || null;
        var metFoto = (p.varianten || []).filter(function (v) { return v.foto && (v.opties || []).indexOf(kleur) > -1; })[0];
        var voor = (paar && paar.voor) || (metFoto && metFoto.foto) || '';
        var fotoEl = kledingLaag.querySelector('[data-kleding-foto]');
        if (voor && fotoEl && fotoEl.getAttribute('src') !== voor) fotoEl.setAttribute('src', voor);
        var achterEl = kledingLaag.querySelector('[data-kleding-achter]');
        if (achterEl) {
          if (paar && paar.achter) {
            if (achterEl.getAttribute('src') !== paar.achter) achterEl.setAttribute('src', paar.achter);
            achterEl.style.display = '';
          } else if (paar) {
            // Deze kleur heeft geen achterkantfoto: dan liever niets omdraaien dan
            // de achterkant van een andere kleur laten zien.
            achterEl.style.display = 'none';
          }
        }
      }
    }
    kledingLaag.addEventListener('click', function (e) {
      if (e.target.closest('[data-kleding-sluit]')) { kledingLaag.classList.remove('open'); document.body.style.overflow = ''; return; }
      var stap = e.target.closest('[data-kleding-stap]');
      if (stap) { kledingIndex += parseInt(stap.getAttribute('data-kleding-stap'), 10); toonKleding(); return; }
      var kl = e.target.closest('[data-kkleur]');
      if (kl) {
        kledingLaag.querySelectorAll('[data-kkleur]').forEach(function (k) { k.classList.toggle('on', k === kl); });
        werkMatenBij(); return;
      }
      var meer = e.target.closest('[data-kleding-meer]');
      if (meer) {
        var vak = meer.closest('[data-kleding-tekst]');
        var open = vak.classList.toggle('uit');
        meer.textContent = open ? 'Lees minder' : 'Lees meer';
        return;
      }
      var ma = e.target.closest('[data-kmaat]');
      if (ma && !ma.disabled) {
        kledingLaag.querySelectorAll('[data-kmaat]').forEach(function (k) { k.classList.toggle('on', k === ma); });
        return;
      }
      var toe = e.target.closest('[data-kleding-toevoegen]');
      if (toe) {
        var p = huidigeKleding(); if (!p) return;
        var fout = kledingLaag.querySelector('[data-kleding-fout]'); if (fout) fout.textContent = '';
        var kleurKnop = kledingLaag.querySelector('.kmkleding-kleur.on');
        var maatKnop = kledingLaag.querySelector('.kmkleding-maat.on');
        var kleur = kleurKnop ? kleurKnop.getAttribute('data-kkleur') : null;
        var maat = maatKnop ? maatKnop.getAttribute('data-kmaat') : null;
        var heeftMaat = (p.opties || []).some(function (o) { return !(o.codes && o.codes.length); });
        if (heeftMaat && !maat) { if (fout) fout.textContent = 'Kies eerst een maat.'; return; }
        var v = (p.varianten || []).filter(function (v) {
          return v.beschikbaar && (!kleur || (v.opties || []).indexOf(kleur) > -1) && (!maat || (v.opties || []).indexOf(maat) > -1);
        })[0];
        if (!v) { if (fout) fout.textContent = 'Die combinatie is niet meer op voorraad.'; return; }
        toe.disabled = true; var oudT = toe.innerHTML; toe.textContent = 'Bezig…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            toe.disabled = false; toe.innerHTML = oudT;
            if (res.ok) { kledingLaag.classList.remove('open'); document.body.style.overflow = ''; renderDrawer(); openDrawer(); }
            else if (fout) fout.textContent = (res.d && res.d.description) || 'Er ging iets mis.';
          })
          .catch(function () { toe.disabled = false; toe.innerHTML = oudT; if (fout) fout.textContent = 'Er ging iets mis.'; });
        return;
      }
    });
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-kleding-open]');
      if (!open) return;
      e.preventDefault();
      var titel = open.getAttribute('data-kleding-open');
      var gekozen = crossData.filter(function (p) { return p.titel === titel; })[0];
      kledingSoort = gekozen ? gekozen.soort : null;
      var lijst = kledingLijst();
      var i = lijst.findIndex(function (p) { return p.titel === titel; });
      kledingIndex = i > -1 ? i : 0;
      toonKleding();
    });

    function renderCrossSell() {
      renderCrossInto('[data-cart-extra]', crossData, 0, cfg.crosssell_heading || 'Leuk om erbij te bestellen!');
    }
    renderCrossSell();
    renderDrawer();

    modalContent.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (step) {
        var row = step.closest('.kmtkrow');
        var q = row.querySelector('[data-qty]');
        var max = parseInt(row.getAttribute('data-max'), 10) || 0;
        var next = Math.min(max, Math.max(0, (parseInt(q.textContent, 10) || 0) + parseInt(step.getAttribute('data-step'), 10)));
        q.textContent = next;
        updateTicketTotals(step.closest('.kmtk'));
        return;
      }
      var nameLink = e.target.closest('[data-namelink]');
      if (nameLink) {
        var nameWrap = nameLink.parentElement.querySelector('[data-namewrap]');
        var openNu = !nameWrap.classList.contains('open');
        nameWrap.classList.toggle('open', openNu);
        nameLink.classList.toggle('open', openNu);
        nameLink.setAttribute('aria-expanded', openNu ? 'true' : 'false');
        if (openNu) { var nameInp = nameWrap.querySelector('[data-kidnames]'); if (nameInp) nameInp.focus(); }
        return;
      }
      var giftTile = e.target.closest('[data-gift]');
      if (giftTile) {
        var tkg = giftTile.closest('.kmtk');
        tkg.querySelectorAll('[data-gift]').forEach(function (t) { t.classList.toggle('on', t === giftTile); });
        var box = tkg.querySelector('[data-giftbox]'); if (box) box.classList.toggle('show', giftTile.getAttribute('data-gift') === 'gift');
        return;
      }
      var cartBtn = e.target.closest('[data-cart]');
      if (cartBtn) {
        var tk = cartBtn.closest('.kmtk');
        var props = {};
        if (curEvent) { var dt = fmtLong(curEvent) + (fmtTime(curEvent) ? ' · ' + fmtTime(curEvent) : ''); if (dt) props.Datum = dt; }
        // Waar de voorstelling is. Stond alleen op de agendapagina; in de
        // bestelbevestiging en op het cadeaubewijs hoort het er ook bij, want
        // daar kijk je naar als je je klaarmaakt om te gaan.
        if (curEvent) { var pl = cardPlace(curEvent); if (pl) props.Locatie = pl; }
        // Het adres en een kaartlink erbij. In de mail stond wel de naam van de zaal maar
        // nergens een adres, en dus ook geen manier om de navigatie te starten. Beide
        // beginnen met een underscore, zodat ze niet in de winkelwagen en bij het
        // afrekenen bij de klant in beeld komen; de mail leest ze apart uit.
        if (curEvent) {
          var lo = curEvent.locatie || {};
          var straat = [lo.adres, lo.plaats].filter(Boolean).join(', ');
          if (straat) props._Adres = straat;
          // Staat er in de agenda een eigen kaartlink, dan die; anders een zoekopdracht
          // op het adres. Google Maps opent op een telefoon vanzelf in de app.
          var zoek = straat || lo.naam;
          if (lo.maps_link) props._Kaart = lo.maps_link;
          else if (zoek) props._Kaart = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(zoek);
        }
        // De tijdlijn van deze voorstelling. Die stond alleen op de agendapagina onder
        // 'Tijden', terwijl je er juist naar zoekt als je op het punt staat te gaan:
        // 'Datum' geeft alleen het hele dagdeel (10:00-13:30) en zegt niet wanneer de
        // voorstelling zelf begint. De naam begint met een underscore, zodat hij niet
        // in de winkelwagen en bij het afrekenen bij de klant in beeld komt; de mail
        // leest hem apart uit. Tijd en activiteit met ' · ' ertussen, de punten
        // onderling met ' | ', want een activiteit kan zelf een middelpunt bevatten.
        if (curEvent && curEvent.programma && curEvent.programma.length) {
          var tl = curEvent.programma
            .filter(function (pp) { return pp && pp.tijd && pp.activiteit; })
            .map(function (pp) { return pp.tijd + ' · ' + pp.activiteit; })
            .join(' | ');
          if (tl) props._Programma = tl;
        }
        var giftOn = tk.querySelector('[data-gift="gift"]');
        if (giftOn && giftOn.classList.contains('on')) {
          props.Cadeau = 'Ja';
          var msgEl = tk.querySelector('[data-giftmsg]'); var msg = msgEl && (msgEl.value || '').trim();
          // Het berichtje is verplicht bij een cadeau: zonder bericht is het
          // cadeaubewijs een leeg kaartje. Het onderscheidt ook een echt cadeau van
          // iemand die het vinkje per ongeluk aanzette.
          if (!msg) {
            var fout = tk.querySelector('[data-carterr]');
            if (fout) fout.textContent = 'Schrijf er even een berichtje bij. Dat komt op het cadeaubewijs te staan.';
            if (msgEl) { try { msgEl.focus(); } catch (er) {} }
            return;
          }
          props.Cadeaubericht = msg;
        }
        // Namen horen alleen bij de kinderkaartjes, niet bij de volwassenen of de baby's.
        var namenEl = tk.querySelector('[data-kidnames]');
        var kidNamen = namenEl && (namenEl.value || '').trim();
        var items = [];
        tk.querySelectorAll('.kmtkrow').forEach(function (row) {
          var qEl = row.querySelector('[data-qty]'); if (!qEl) return;
          var qty = parseInt(qEl.textContent, 10) || 0;
          var vid = row.getAttribute('data-vid');
          if (!(qty > 0 && vid)) return;
          var rowProps = props;
          if (kidNamen && row.getAttribute('data-type') === 'Kind') {
            rowProps = {};
            for (var pk in props) rowProps[pk] = props[pk];
            rowProps['Namen kinderen'] = kidNamen;
          }
          items.push({ id: vid, quantity: qty, properties: rowProps });
        });
        if (!items.length) return;
        var errEl = tk.querySelector('[data-carterr]'); if (errEl) errEl.textContent = '';
        var orig = cartBtn.innerHTML;
        cartBtn.disabled = true; cartBtn.textContent = 'Bezig…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            cartBtn.disabled = false; cartBtn.innerHTML = orig;
            if (res.ok) {
              // Bij een cadeau ook een kenmerk op de bestelling zelf zetten, niet
              // alleen op de regels. Reden: Shopify Flow kan wel eenvoudig op een
              // kenmerk van de bestelling kijken, maar moeizaam door de regels
              // heen. Dit maakt de voorwaarde van de cadeaumail één regel.
              if (props.Cadeau === 'Ja') {
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ attributes: { Cadeau: 'Ja', Cadeaubericht: props.Cadeaubericht || '' } }),
                }).catch(function () {});
              }
              closeModal(); openDrawer();
            }
            else if (errEl) { errEl.textContent = (res.d && res.d.description) || 'Er ging iets mis. Probeer het opnieuw.'; }
          })
          .catch(function () { cartBtn.disabled = false; cartBtn.innerHTML = orig; if (errEl) errEl.textContent = 'Er ging iets mis. Probeer het opnieuw.'; });
        return;
      }
      var more = e.target.closest('[data-rm-more]');
      if (more) { var rm = more.closest('[data-rm]'); rm.querySelector('.kmrm-collapsed').hidden = true; rm.querySelector('.kmrm-full').hidden = false; return; }
      var less = e.target.closest('[data-rm-less]');
      if (less) { var rm2 = less.closest('[data-rm]'); rm2.querySelector('.kmrm-full').hidden = true; rm2.querySelector('.kmrm-collapsed').hidden = false; return; }
      var s = e.target.closest('[data-lb]');
      if (s && curEvent) { openLb(curEvent.media, parseInt(s.getAttribute('data-lb'), 10)); return; }
      var dd = e.target.closest('[data-dd]');
      if (dd) { var menu = dd.parentElement.querySelector('.kmddmenu'); var wasOpen = menu.classList.contains('open'); modalContent.querySelectorAll('.kmddmenu.open').forEach(function (m) { m.classList.remove('open'); }); if (!wasOpen) menu.classList.add('open'); return; }
      if (e.target.closest('[data-ics]') && curEvent) { downloadIcs(curEvent); return; }
      var cp = e.target.closest('[data-copy]');
      if (cp && curEvent) { copyLink(curEvent, cp); return; }
      var kt = e.target.closest('[data-kraam]');
      if (kt && kt.classList.contains('km-product__link')) {
        // Tegel uit het gedeelde onderdeel: hetzelfde venster als op de homepage, met de groep.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        var groepen = null;
        try { groepen = JSON.parse(kt.getAttribute('data-kraam-groep') || 'null'); } catch (err) { groepen = null; }
        window.kmKraamVenster.open(kt.getAttribute('data-kraam'), kt.getAttribute('data-kraam-titel'), '', {
          kleuren: cfg.kleuren, groepen: groepen, meerLink: kt.getAttribute('data-kraam-meer') || undefined
        });
        return;
      }
      if (kt) {
        openKraam(kt.getAttribute('data-kraam'), kt.querySelector('.kmkraam-t').textContent,
          kt.getAttribute('data-kraam-domein'));
        return;
      }
      if (e.target.closest('[data-wl-spring]')) {
        var doel = modalContent.querySelector('.kmwl');
        if (doel) {
          // Bewust zonder soepele beweging. Op deze pagina wordt een lopende smooth
          // scroll door het thema afgekapt: hij kwam niet aan, of bleef halverwege
          // steken met de wachtlijst net onder de onderrand - erger dan geen
          // beweging, want dan denk je dat de knop niets doet. Direct springen komt
          // altijd aan, en het naamveld krijgt meteen de aandacht zodat duidelijk is
          // waar je terecht bent gekomen.
          doel.scrollIntoView({ block: 'center' });
          var eerste = doel.querySelector('[data-wl-naam]');
          if (eerste) { try { eerste.focus({ preventScroll: true }); } catch (er) {} }
        }
        return;
      }
      var wl = e.target.closest('[data-wl-verstuur]');
      if (wl && curEvent) { verstuurWachtlijst(wl.closest('.kmwl'), curEvent); return; }
      if (e.target.closest('[data-newsletter]')) {
        closeModal();
        var nl = root.querySelector('.kmnews');
        if (nl) { nl.scrollIntoView({ behavior: 'smooth', block: 'center' }); var inp = nl.querySelector('.kmnewsin'); if (inp) setTimeout(function () { try { inp.focus(); } catch (er) {} }, 500); }
        return;
      }
      if (!e.target.closest('.kmddmenu')) modalContent.querySelectorAll('.kmddmenu.open').forEach(function (m) { m.classList.remove('open'); });
    });

    function evDateTimes(ev) {
      var d = parseDate(ev.datum); if (!d) return null;
      var s = new Date(d), bt = (ev.begintijd || '10:00').split(':'); s.setHours(+bt[0] || 10, +bt[1] || 0, 0, 0);
      var e2;
      if (ev.eindtijd) { e2 = new Date(d); var et = ev.eindtijd.split(':'); e2.setHours(+et[0] || 0, +et[1] || 0, 0, 0); }
      else e2 = new Date(s.getTime() + 2 * 3600000);
      return { start: s, end: e2 };
    }
    function icsStamp(d) { function p(n) { return ('0' + n).slice(-2); } return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + 'T' + p(d.getHours()) + p(d.getMinutes()) + '00'; }
    // Delen gaat naar de eigen pagina van de voorstelling (/agenda/<naam>) en niet
    // meer naar de agenda met een vraagteken erachter. Reden: WhatsApp en Facebook
    // maken hun voorvertoning per pagina, en Liquid kan niets zien van het stuk
    // achter het vraagteken - dus kreeg elke gedeelde voorstelling dezelfde
    // algemene tegel. Met een eigen webadres krijgt elke voorstelling zijn eigen
    // naam, omschrijving en foto in dat blokje.
    function shareUrl(ev) {
      // Het adres komt van Shopify zelf mee; alleen als dat er onverhoopt niet is
      // vallen we terug op de agenda met de voorstelling erachter.
      if (ev.url) return location.origin + ev.url;
      return location.origin + '/pages/agenda?event=' + encodeURIComponent(ev.id);
    }
    function locString(ev) { var l = ev.locatie || {}; return [l.naam, l.adres].filter(Boolean).join(', '); }
    function googleCal(ev) {
      var t = evDateTimes(ev); if (!t) return '#';
      return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(ev.titel) +
        '&dates=' + icsStamp(t.start) + '/' + icsStamp(t.end) + '&location=' + encodeURIComponent(locString(ev)) +
        '&details=' + encodeURIComponent('Meer info: ' + shareUrl(ev));
    }
    function downloadIcs(ev) {
      var t = evDateTimes(ev); if (!t) return;
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kaatje&Mup//Agenda//NL', 'BEGIN:VEVENT',
        'UID:' + ev.id + '@kaatjemup', 'DTSTART:' + icsStamp(t.start), 'DTEND:' + icsStamp(t.end),
        'SUMMARY:' + ev.titel, 'LOCATION:' + locString(ev), 'URL:' + shareUrl(ev), 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var a = document.createElement('a');
      a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
      a.download = (ev.id || 'evenement') + '.ics'; document.body.appendChild(a); a.click(); a.remove();
    }
    function waUrl(ev) { return 'https://wa.me/?text=' + encodeURIComponent(ev.titel + ': ' + shareUrl(ev)); }
    // De agenda kent al een diepe link (?event=...) die het venster meteen opent;
    // daar haken we op in, zodat er geen tweede manier bij komt om hetzelfde te doen.
    function agendaUrl(ev) { return '/pages/agenda?event=' + encodeURIComponent(ev.id); }
    function mailUrl(ev) { return 'mailto:?subject=' + encodeURIComponent(ev.titel) + '&body=' + encodeURIComponent('Kijk eens naar dit Kaatje&Mup evenement:\n' + shareUrl(ev)); }
    function fbUrl(ev) { return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl(ev)); }
    function xUrl(ev) { return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(ev.titel) + '&url=' + encodeURIComponent(shareUrl(ev)); }
    function copyLink(ev, btn) {
      var done = function () { if (btn) { var o = btn.innerHTML; btn.innerHTML = IC.check + ' Gekopieerd'; setTimeout(function () { btn.innerHTML = o; }, 1500); } };
      if (navigator.clipboard) navigator.clipboard.writeText(shareUrl(ev)).then(done, done); else done();
    }
    function footerButtons(ev, past) {
      // In de pop-up staat een uitweg naar de eigen pagina van deze voorstelling:
      // daar staat hetzelfde, maar met alle ruimte van het scherm. Op die pagina
      // zelf laten we hem weg - je bent er dan al.
      var groot = soloMode
        ? '<a class="kmscnd kmgroot" href="' + escAttr(agendaUrl(ev)) + '">' + IC.klein + ' Bekijk in de agenda</a>'
        : (ev.url ? '<a class="kmscnd kmgroot" href="' + escAttr(ev.url) + '">' + IC.groot + ' Op groot scherm</a>' : '');
      // Sinds 2-10-2026: Op groot scherm staat al linksboven, en een agendaknop alleen als het nog komt.
      groot = '';
      return '<div class="kmfoot">' + groot +
        (past ? '' : '<div class="kmdd"><button type="button" class="kmscnd" data-dd>' + IC.cal + ' Zet in mijn agenda ' + IC.chev + '</button>' +
          '<div class="kmddmenu"><a class="kmscnd" href="' + googleCal(ev) + '" target="_blank" rel="noopener">' + IC.cal + ' Google Agenda</a>' +
          '<button type="button" class="kmscnd" data-ics>' + IC.cal + ' Apple / Outlook (.ics)</button></div></div>') +
        '<div class="kmdd"><button type="button" class="kmscnd kmdeel" data-dd>' + IC.share + ' Delen ' + IC.chev + '</button>' +
          '<div class="kmddmenu"><a class="kmscnd kmwa" href="' + waUrl(ev) + '" target="_blank" rel="noopener">' + IC.wa + ' WhatsApp</a>' +
          '<a class="kmscnd" href="' + mailUrl(ev) + '">' + IC.mail + ' E-mail</a>' +
          '<a class="kmscnd kmfb" href="' + fbUrl(ev) + '" target="_blank" rel="noopener">' + IC.fb + ' Facebook</a>' +
          '<a class="kmscnd kmxsh" href="' + xUrl(ev) + '" target="_blank" rel="noopener">' + IC.xlogo + ' X</a>' +
          '<button type="button" class="kmscnd" data-copy>' + IC.link + ' Kopieer link</button></div></div>' +
        '<button type="button" class="kmscnd kmnl" data-newsletter>' + IC.mail + ' Nieuwsbrief</button>' +
        '</div>';
    }

    function openModal(ev) {
      curEvent = ev;
      var end = eventEnd(ev), past = end && end < nuNL();
      var loc = ev.locatie || {};
      // Klein linkje linksboven, tegenover het kruisje: wie meteen ziet dat het
      // ook groter kan hoeft niet eerst helemaal naar beneden te scrollen.
      // Beide kanten op: vanuit de agenda naar de eigen pagina, en vanaf die
      // pagina terug naar de agenda met deze voorstelling meteen open. Zo zit je
      // nooit vast in de weergave waar je toevallig in terechtkwam.
      var grootKlein = soloMode
        ? '<a class="kmgrootklein" href="' + escAttr(agendaUrl(ev)) + '">' + IC.klein + ' Bekijk in de agenda</a>'
        : (ev.url ? '<a class="kmgrootklein" href="' + escAttr(ev.url) + '">' + IC.groot + ' Op groot scherm</a>' : '');
      // ---- Nieuwe opmaak van het venster (variant B, gekozen 2-10-2026) ----------------
      // Zie ontwerp/venster-bekijk/LEESMIJ.md. Bovenin op zand de hele poster met rechts de
      // labels, titel, wanneer, waar en wat; daaronder een golf en losse witte kaartjes.
      // Alle onderdelen van voor die tijd (prijzen, timer, kaartjeskiezer, cadeau, wachtlijst,
      // kraam, vragen, knoppen) worden hieronder hergebruikt, zodat er niets wegvalt.
      function kaart(binnen, extra) { return binnen ? '<div class="kmv-kaart' + (extra ? ' ' + extra : '') + '">' + binnen + '</div>' : ''; }
      function kop(t) { return '<h3 class="kmv-h">' + t + '</h3>'; }
      // Voor wie een besloten activiteit was: de partnerlogo's (zonder "Logo "), anders de locatie.
      // Zonder partnerlogo's alleen de plek bij een voorstelling: "voor de kinderen van Jokidé Kinderopvang" klopt,
      // "voor de kinderen van Dorpshuis De Tysker" bij een knutselcafé niet (2-10-2026).
      function voorWieTekst() {
        var voorWie = (loc.partners || []).map(function (pl) { return String(pl.alt || '').replace(/^logo\s+/i, '').trim(); }).filter(Boolean);
        if (voorWie.length) return voorWie.length > 1 ? voorWie.slice(0, -1).join(', ') + ' en ' + voorWie[voorWie.length - 1] : voorWie[0];
        return (ev.type || []).indexOf('voorstelling') >= 0 ? (loc.host_naam || loc.naam || '') : '';
      }
      // Het woord bij een besloten activiteit: voorstelling, knutselcafé of toernee (Carolien, 2-10-2026: Easterwierrum
      // was een besloten knutselcafé, geen voorstelling).
      function beslotenWoord(isToernee) {
        var tp = ev.type || [];
        if (isToernee) return { woord: 'toernee', was: 'Deze voorstellingen waren', is: 'Deze voorstellingen zijn' };
        if (tp.indexOf('voorstelling') >= 0) return { woord: 'voorstelling', was: 'Deze voorstelling was', is: 'Deze voorstelling is' };
        if (tp.indexOf('knutselcafe') >= 0) return { woord: 'knutselcafé', was: 'Dit knutselcafé was', is: 'Dit knutselcafé is' };
        return { woord: 'activiteit', was: 'Deze activiteit was', is: 'Deze activiteit is' };
      }
      var nu0 = nuNL();
      var eerstvolgende = events.filter(function (x) { var e2 = eventEnd(x); return !(e2 && e2 < nu0); })
        .sort(function (x, y) { return parseDate(x.datum) - parseDate(y.datum); })[0];
      var isToday0 = !past && ev.datum && parseDate(ev.datum) && parseDate(ev.datum).toDateString() === nu0.toDateString();
      var pils = reeksLabel(ev) +
        (isToday0 ? '<span class="kmpil kmpil--geel">Vandaag</span>' : (!past && eerstvolgende === ev ? '<span class="kmpil kmpil--geel">Binnenkort</span>' : '')) +
        soortPil(ev);
      var wanneer = kaartWanneer(ev);
      var media0 = ev.media || [];
      var poster = ev.foto
        // Vergroten zoals op de homepage: vergrootglas bij de muis, klikken opent groot (2-10-2026).
        ? '<button type="button" class="kmv-poster' + (media0.length ? ' km-vergroot' : '') + '"' + (media0.length ? ' data-lb="0" aria-label="Poster vergroten"' : '') + '><img src="' + esc(ev.foto) + '" alt="' + escAttr(ev.titel) + '"></button>'
        : '<div class="kmv-poster kmv-poster--leeg">' + ((ev.type || []).indexOf('voorstelling') >= 0 ? IC.masks : IC.palette) + '</div>';
      var html = (soloMode ? '' : '<button class="kmclose" data-km-close aria-label="Sluiten">' + IC.x + '</button>') + grootKlein +
        '<div class="kmv-kop"><div class="kmv-links">' + poster + '</div>' +
        '<div class="kmv-info"><div class="kmv-pils">' + pils + '</div><div class="kmv-midden">' +
        '<h2 class="kmmt">' + esc(ev.titel) + '</h2>' +
        (wanneer ? '<p class="kmmrow">' + IC.cal + '<span>' + esc(wanneer) + '</span></p>' : '') +
        ((cardPlace(ev) || loc.naam) ? '<p class="kmmrow">' + IC.pin + '<span>' + esc(cardPlace(ev) || loc.naam) + '</span></p>' : '') +
        '<p class="kmmrow">' + IC.ticket + '<span>' + esc(typeLabel(ev)) + '</span></p>' +
        // De partnerlogo's ook bovenaan op de banner, niet alleen onderaan bij Samen met (14-10-2026,
        // Carolien: "die 3 andere logo's ook op de banner van de voorstelling zetten"). Bij de
        // Kinderboekenweek zijn dat OBS De Wyken, Kinderwoud en CBS de Vuurvlinder. Ze staan iets kleiner
        // dan onderaan, zodat ze de titel niet overstemmen.
        partnerRijHtml(loc.partners, 'km-partners--banner', '') +
        '</div></div></div>' +
        '<div class="kmv-golf" aria-hidden="true">&nbsp;</div><div class="kmv-body">';

      // Op welke dag kom je? (een reeks zoals FJ08: elke datum een eigen pagina en eigen kaartjes)
      var leden = reeksLeden(ev);
      if (leden.length >= 2) {
        html += kaart(kop('Op welke dag kom je?') + '<div class="kmv-dagen">' + leden.map(function (x, i) {
          var dx = parseDate(x.datum), geweest = (function () { var e3 = eventEnd(x); return e3 && e3 < nu0; })();
          var t = dx ? (DAG_KORT[dx.getDay()].charAt(0).toUpperCase() + DAG_KORT[dx.getDay()].slice(1)) + ' ' + dx.getDate() + ' ' + MAAND[dx.getMonth()] : x.datum;
          var sub = (dagdeel(x) || '') + (fmtTime(x) ? ' · ' + fmtTime(x) : '');
          var cls = 'kmv-dag' + (x === ev ? ' on' : '') + (geweest && x !== ev && !past ? ' geweest' : '');
          return soloMode
            ? '<a class="' + cls + '" href="' + escAttr(x.url || '#') + '">' + esc(t) + '<small>' + esc(sub) + '</small></a>'
            : '<button type="button" class="' + cls + '" data-km-dag="' + i + '">' + esc(t) + '<small>' + esc(sub) + '</small></button>';
        }).join('') + '</div>');
      }

      if (past) {
        // Een afgelopen activiteit: rustig, met een uitnodiging voor de volgende keer.
        if (ev.toegang === 'besloten') {
          // Geen reclame voor mezelf bij een besloten activiteit (Carolien, 2-10-2026): alleen voor wie het was.
          var isToernee = toerneeDagen(ev) >= 2;
          var wieG = voorWieTekst();
          var bw = beslotenWoord(isToernee);
          html += kaart('<b class="kmv-eilk">' + IC.lock + ' Besloten ' + bw.woord + '</b>' +
            '<span>' + bw.was + (wieG ? ' speciaal voor de kinderen van ' + esc(wieG) + '.' : ' niet vrij te bezoeken.') + '</span>', 'kmv-eiland');
        } else {
          html += kaart('<b class="kmv-eilk">Dit was een mooie ' + esc(dagdeel(ev) || 'dag') + '</b>' +
            '<span>Wil je er de volgende keer bij zijn? Dan hoor je het als eerste.</span>' +
            '<button type="button" class="kmknop kmknop--vol" data-newsletter>' + IC.mail + ' Hou me op de hoogte</button>', 'kmv-eiland');
        }
      } else if (ev.toegang === 'besloten') {
        var wie = voorWieTekst();
        html += kaart('<b class="kmv-eilk">' + IC.lock + ' Besloten</b><span>' + (wie ? 'Speciaal voor de kinderen van ' + esc(wie) + '.' : beslotenWoord(toerneeDagen(ev) >= 2).is + ' niet vrij te bezoeken.') + '</span>', 'kmv-eiland');
      } else if (ev.toegang !== 'kaartverkoop' || ev.externe_ticketlink) {
        // Gratis, gratis met aanmelden of kaartverkoop via een andere partij.
        html += kaart(accessBox(ev, null) + (ev.externe_ticketlink ? '<div style="text-align:center;margin:12px 0 0"><a class="kmknop kmknop--vol" href="' + esc(ev.externe_ticketlink) + '" target="_blank" rel="noopener">' + IC.ext + ' Naar de kaartverkoop</a></div>' : ''), 'kmv-eiland');
      } else {
        // Kaartverkoop in de eigen webshop: prijzen en timer bovenin het kaartje Kaartjes.
        var prijzen = priceBlock(ev, cfg) + consumptieLine(ev);
        var picker = ticketPicker(ev, prijzen);
        if (picker) html += picker;
        else {
          var nogNiet = isTicket(ev) && !ev.ticket
            ? '<div class="kmnogniet">' + IC.clock + '<span><strong>De kaartverkoop begint binnenkort.</strong> Voor deze voorstelling zijn de kaartjes nog niet te bestellen. Houd de agenda in de gaten of schrijf je onderaan in voor de nieuwsbrief.</span></div>' : '';
          html += kaart(kop('Kaartjes') + prijzen + stockBig(ev) + nogNiet);
        }
        if (isUitverkocht(ev)) html += kaart(wachtlijst(ev));
      }

      // Hier spelen we / Hier speelden we (toernee)
      var toer = toerneeBlok(ev, past);
      if (toer) html += kaart(toer.replace('<div class="kmsec-h">', '<h3 class="kmv-h">').replace(/<\/div>(<ul class="kmtoer">)/, '</h3>$1'));

      // Zo ziet de ochtend eruit: het programma als tijdlijn
      if (ev.programma && ev.programma.length) {
        html += kaart(kop('Zo ziet de ' + esc(dagdeel(ev) || 'dag') + ' eruit') + '<ul class="kmv-tl">' + ev.programma.map(function (p, i) {
          var t = String(p.tijd || '').replace(/\s*[-–]\s*/g, ' – ');
          return '<li' + (/voorstelling/i.test(p.activiteit || '') ? ' class="hl"' : '') + '><b>' + esc(t) + '</b><span>' + esc(p.activiteit) + '</span></li>';
        }).join('') + '</ul>');
      }

      var beschrHtml = richText(ev.beschrijving);
      if (beschrHtml) html += kaart(kop('Over deze ' + esc(dagdeel(ev) || 'activiteit')) + readMore(beschrHtml));

      // Foto's & filmpjes staat even uit tot Carolien ze invult (2-10-2026); de poster blijft te vergroten.
      if (media0.length && cfg.toon_fotos) {
        var mh = '<div class="kmstrip">';
        media0.forEach(function (m, i) {
          var play = m.type === 'video' ? '<span class="kmstrip-play">' + IC.play + '</span>' : '';
          mh += '<button type="button" class="kmstrip-item' + (m.type === 'video' ? ' is-video' : '') + '" data-lb="' + i + '"><img src="' + esc(m.thumb) + '" alt="" loading="lazy">' + play + '</button>';
        });
        html += kaart(kop('Foto’s &amp; filmpjes') + mh + '</div>');
      }

      var tp = ev.type || [];
      var ovHtml = richText(ev.over_voorstelling), okHtml = richText(ev.over_knutselcafe);
      var ovK = (ovHtml && tp.indexOf('voorstelling') > -1) ? kaart(kop('Over de voorstelling') + readMore(ovHtml)) : '';
      var okK = (okHtml && tp.indexOf('knutselcafe') > -1) ? kaart(kop('Over het knutselcafé') + readMore(okHtml)) : '';
      if (ovK && okK) html += '<div class="kmv-twee">' + ovK + okK + '</div>'; else html += ovK + okK;

      function kraamKaart(k) { return k ? kaart(k.replace('<div class="kmsec-h">', '<h3 class="kmv-h">').replace(/<\/div>/, '</h3>'), 'kmv-kraamkaart') : ''; }
      // De kraam met dezelfde tegels als op de homepage (snippets/km-soortkaarten.liquid), in een schuifrij (2-10-2026).
      var kraamTegels = root.querySelector('[data-km-kraam-tegels]');
      if (ev.kraam && kraamTegels && kraamTegels.innerHTML.trim()) {
        html += kaart('<h3 class="kmv-h">' + esc(past ? 'Deze producten hadden we bij ons' : (cfg.kraam_heading || 'We nemen onze eigen Kaatje&Mup producten mee')) + '</h3>' +
          (!past && cfg.kraam_tekst ? '<p class="kmkraam-p">' + esc(cfg.kraam_tekst) + '</p>' : '') +
          '<div class="km-producten km-winkelsoorten kmv-tegels"><ul class="km-producten__rij list-unstyled">' + kraamTegels.innerHTML + '</ul></div>', 'kmv-kraamkaart');
      } else {
        html += kraamKaart(kraamBlok(ev.kraam, kraamData, past ? 'Deze producten hadden we bij ons' : (cfg.kraam_heading || 'We nemen onze eigen Kaatje&Mup producten mee'), past ? '' : cfg.kraam_tekst, '', 'Kaatje&Mup'));
      }
      html += kraamKaart(kraamBlok(ev.knutselkraam, knutselData, cfg.knutsel_heading || 'We nemen deze knutselspullen mee', cfg.knutsel_tekst, cfg.knutsel_webshop, 'Cutiepix'));

      // Waar: de plek één keer, met adres, contact, logo, de partners en de kaart.
      if (loc.naam) {
        var olHtml = richText(loc.over_locatie);
        // Staat de plaats al in het adres ("8911 DH Leeuwarden"), dan niet nog een keer: met "Leeuwarden, Leeuwarden"
        // vond Google niets en toonde de kaart de hele wereld (2-10-2026). De naam van de plek ervoor geeft een speld.
        var plaatsErbij = loc.plaats && !(loc.adres && loc.adres.toLowerCase().indexOf(loc.plaats.toLowerCase()) >= 0);
        // Geen straat bekend, wel een plaats: dan de plaats zelf op de kaart, iets verder uitgezoomd. Ook geen plaats:
        // geen kaart, want op alleen een naam toont Google al snel de hele wereld (Carolien, 2-10-2026: "Als er geen
        // straat bekend is dan wel een plaatsnaam en die dan gebruiken op de kaart").
        // Alleen het adres, zonder de naam ervoor (14-10-2026, Carolien: "de kaart bij dit evenement klopt
        // niet zie nu de hele wereld"). Een naam die Google niet als plek kent maakt de hele zoekterm
        // onbruikbaar en dan toont hij de wereld; dat gebeurde bij "IKC Duinterpen, Keizersmantel 1, 8607 GM
        // Sneek". Een adres met postcode is eenduidig, dus de naam voegt niets toe en kan alleen storen.
        var mapQuery = loc.adres ? [loc.adres, plaatsErbij ? loc.plaats : ''].filter(Boolean).join(', ') : (loc.plaats || '');
        var mapZoom = loc.adres ? 15 : 13;
        var wh = kop('Waar') + '<div class="kmv-waar"><div>' +
          '<p class="kmmrow">' + IC.pin + '<span><b>' + esc(loc.naam) + '</b>' + (loc.adres ? '<br>' + esc(loc.adres) : (loc.plaats ? '<br>' + esc(loc.plaats) : '')) + '</span></p>' +
          (loc.host_telefoon ? '<p class="kmmrow">' + IC.phone + '<a href="tel:' + esc(loc.host_telefoon) + '">' + esc(loc.host_telefoon) + '</a></p>' : '') +
          (loc.host_website ? '<p class="kmmrow">' + IC.globe + '<a href="' + esc(loc.host_website) + '" target="_blank" rel="noopener">' + esc(loc.host_website.replace(/^https?:\/\//, '')) + '</a></p>' : '') +
          (loc.facebook || loc.instagram ? '<div class="kmsocials">' +
            (loc.facebook ? '<a href="' + esc(loc.facebook) + '" target="_blank" rel="noopener">' + IC.fb + 'Facebook</a>' : '') +
            (loc.instagram ? '<a href="' + esc(loc.instagram) + '" target="_blank" rel="noopener">' + IC.ig + 'Instagram</a>' : '') + '</div>' : '') +
          '</div>' + (loc.logo ? '<img class="kmv-waarlogo" src="' + esc(loc.logo) + '" alt="' + escAttr(loc.host_naam || loc.naam) + '">' : '<div class="kmv-waarlogo kmv-waarlogo--tekst">' + tekstLogo(loc.naam || loc.host_naam) + '</div>') + '</div>' +
          (olHtml ? '<div class="kmv-overloc">' + readMore(olHtml) + '</div>' : '') +
          partnerRijHtml(loc.partners, 'km-partners--waar', 'Samen met');
        if (mapQuery && (ev._plaatsen || []).length <= 1) {
          var q = encodeURIComponent(mapQuery);
          var mapLink = loc.maps_link || ('https://www.google.com/maps/search/?api=1&query=' + q);
          wh += '<div class="kmmap"><iframe class="kmmap-frame" src="https://maps.google.com/maps?q=' + q + '&z=' + mapZoom + '&output=embed" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Kaart: ' + esc(mapQuery) + '"></iframe></div>' +
            '<a class="kmmaplink" href="' + esc(mapLink) + '" target="_blank" rel="noopener">' + IC.pin + ' Bekijk op de kaart</a>';
        }
        html += kaart(wh);
      }

      // Goed om te weten: alleen als het nog komt en niet besloten is.
      if (!past && ev.toegang !== 'besloten') html += kaart(faqSection(ev).replace('<div class="kmsec-h">Veelgestelde vragen</div>', kop('Goed om te weten')));
      html += footerButtons(ev, past);
      html += '</div>';

      modalContent.innerHTML = html;
      // In solo-stand staat dezelfde inhoud gewoon in de pagina: geen venster dat
      // opengaat, geen vergrendelde achtergrond en geen kruisje om te sluiten.
      if (!soloMode) {
        modal.classList.add('open'); document.body.style.overflow = 'hidden';
        var sluit = modalContent.querySelector('[data-km-close]');
        if (sluit) sluit.addEventListener('click', closeModal);
      }
      modalContent.querySelectorAll('.kmtk').forEach(updateTicketTotals);
      // Op welke dag kom je: een andere dag van de reeks opent in hetzelfde venster.
      modalContent.querySelectorAll('[data-km-dag]').forEach(function (b) {
        b.addEventListener('click', function () { var x = reeksLeden(ev)[+b.getAttribute('data-km-dag')]; if (x && x !== ev) { modalContent.scrollTop = 0; openModal(x); } });
      });
      startCountdowns();
    }
    function closeModal() { modal.classList.remove('open'); document.body.style.overflow = ''; countdownTimers.forEach(clearInterval); countdownTimers = []; }
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      // Escape sluit steeds het bovenste venster, zodat je stap voor stap
      // terugkomt bij je kaartje in plaats van in één keer alles kwijt te zijn.
      if (e.key === 'Escape') {
        if (lightbox.classList.contains('open')) closeLb();
        else if (window.kmKraamVenster.isOpen()) sluitKraam();
        else if (drawer.classList.contains('open')) closeDrawer();
        else closeModal();
      }
      else if (lightbox.classList.contains('open')) {
        if (e.key === 'ArrowLeft') { lbIndex = (lbIndex - 1 + lbMedia.length) % lbMedia.length; showLb(); }
        else if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % lbMedia.length; showLb(); }
      }
    });

    function startCountdowns() {
      modalContent.querySelectorAll('.kmcountdown[data-target]').forEach(function (el) {
        var target = +el.getAttribute('data-target');
        function tick() {
          var diff = target - nuNL().getTime();
          if (diff <= 0) { el.textContent = 'bijna'; return; }
          var d = Math.floor(diff / DAG_MS), h = Math.floor((diff % DAG_MS) / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
          // Zelfde opmaak als in Carolien's ontwerp: 6d 23u 59m 04s
          el.textContent = (d > 0 ? d + 'd ' : '') + ('0' + h).slice(-2) + 'u ' + ('0' + m).slice(-2) + 'm ' + ('0' + s).slice(-2) + 's';
        }
        tick(); countdownTimers.push(setInterval(tick, 1000));
      });
    }

    render();

    // ---- Controlepaneel (alleen voor Carolien) -------------------------------
    // Zet ?check=1 achter de link naar de agenda, of open de pagina in de
    // themabewerker. Dan verschijnt bovenaan een kadertje dat de drie dingen
    // nakijkt die stilletjes mis kunnen gaan en waar een bezoeker niets van ziet:
    // evenementen die op concept staan (die komen hier namelijk helemaal niet
    // binnen), twee evenementen die hetzelfde kaartjesproduct delen, en een
    // kaartprijs die niet klopt met de prijstrap.
    function controlePaneel() {
      var aan = /[?&]check=1/.test(location.search) || document.documentElement.classList.contains('shopify-design-mode') || window.Shopify && window.Shopify.designMode;
      if (!aan) return;
      var m = [];

      if (!events.length) {
        m.push({ k: 'fout', t: 'De pagina heeft nul evenementen binnengekregen.',
          u: 'Staan ze in Shopify wel op <strong>Actief</strong>? Een nieuw evenement krijgt automatisch de stand Concept en dan is het hier onzichtbaar, zonder melding.' });
      }

      // Twee evenementen op hetzelfde kaartjesproduct: gedeelde voorraad, en de
      // prijs-sync zet ze om beurten op een ander bedrag.
      var perProduct = {};
      events.forEach(function (ev) {
        var id = ev.ticket && ev.ticket.id; if (!id) return;
        (perProduct[id] = perProduct[id] || []).push(ev.titel);
      });
      Object.keys(perProduct).forEach(function (id) {
        if (perProduct[id].length > 1) {
          m.push({ k: 'fout', t: 'Twee of meer evenementen delen hetzelfde kaartjesproduct.',
            u: perProduct[id].map(esc).join(' &middot; ') + ': ze delen dan de voorraad en overschrijven elkaars prijs. Geef elk evenement zijn eigen kaartjesproduct.' });
        }
      });

      events.forEach(function (ev) {
        if (!isTicket(ev)) return;
        var end = eventEnd(ev); if (end && end < nuNL()) return;
        if (!ev.ticket) {
          m.push({ k: 'let', t: 'Kaartverkoop zonder kaartjesproduct: ' + esc(ev.titel),
            u: 'Er staat wel kaartverkoop ingesteld maar er hangt geen kaartjesproduct aan. Bezoekers kunnen dus niets bestellen.' });
          return;
        }
        var opDatum = priceTier(ev, cfg), echt = variantPrijs(ev);
        if (opDatum && echt !== null && Math.abs(echt - opDatum.prijs) > 0.005) {
          m.push({ k: 'let', t: 'Kaartprijs wijkt af van de prijstrap: ' + esc(ev.titel),
            u: 'Volgens de datum hoort het ' + esc(opDatum.label.toLowerCase()) + ' te zijn (' + euro(opDatum.prijs) + ') maar op het kaartje staat ' + euro(echt) + '. De pagina toont ' + euro(echt) + ' want dat is wat de kassa rekent. De prijs-sync zet dit vanzelf recht bij de volgende ronde.' });
        }
      });

      // ---- Drie controles voor wie zelf een voorstelling aanmaakt ------------
      // Dit zijn precies de stappen die stil kunnen mislukken: je ziet niets
      // vreemds op de pagina, maar er klopt iets niet.

      // 1. Het kaartjesproduct staat niet in de webshop. Dan kan er niets besteld
      //    worden, terwijl de kaartjeskiezer er gewoon staat.
      events.forEach(function (ev) {
        if (ev.ticket && ev.ticket.gepubliceerd === false) {
          m.push({ k: 'fout', t: 'Het kaartjesproduct staat niet in de webshop: ' + esc(ev.titel),
            u: 'Het product <strong>' + esc(ev.ticket.titel || '') + '</strong> is niet gepubliceerd naar het verkoopkanaal Webshop. Bezoekers zien wel kaartjes staan maar kunnen niets afrekenen. Zet het bij het product onder <em>Publicatie</em> aan.' });
        }
      });

      // 2. De voorraad van het kinderkaartje mag nooit HOGER zijn dan het aantal
      //    plekken plus de speelruimte - dan passen er meer mensen in de zaal dan
      //    erin kunnen. Bewust niet 'moet er precies gelijk aan zijn': zodra er
      //    kaartjes verkocht zijn is de voorraad lager, en dat is juist goed. Die
      //    eerdere versie sloeg alarm op elke voorstelling die liep.
      events.forEach(function (ev) {
        var k = kindVariant(ev); if (!k) return;
        var plekken = +ev.plekken; if (!isFinite(plekken) || plekken <= 0) return;
        var max = plekken + speelruimte(ev);
        var staat = (typeof k.voorraad === 'number') ? k.voorraad : 0;
        if (staat > max) {
          m.push({ k: 'fout', t: 'Er kunnen meer kaartjes verkocht worden dan er plekken zijn: ' + esc(ev.titel),
            u: 'Bij de voorstelling staat <strong>' + plekken + ' plekken</strong> en <strong>speelruimte ' + speelruimte(ev) + '</strong>, dus er mogen er hoogstens <strong>' + max + '</strong> weg. Het kinderkaartje staat op <strong>' + staat + '</strong>. Zet de voorraad terug naar ' + max + ' of lager.' });
        }
      });

      // 3. Twee kaartjes met hetzelfde artikelnummer. Dat geeft rommel in de
      //    boekhouding en bij de barcodes op de kaartjes.
      var perNummer = {};
      events.forEach(function (ev) {
        if (!ev.ticket || !ev.ticket.varianten) return;
        ev.ticket.varianten.forEach(function (v) {
          if (!v.nummer) return;
          (perNummer[v.nummer] = perNummer[v.nummer] || []).push(ev.titel + ' (' + v.type + ')');
        });
      });
      Object.keys(perNummer).forEach(function (nr) {
        var lijst = perNummer[nr];
        if (lijst.length > 1) {
          m.push({ k: 'fout', t: 'Twee kaartjes met hetzelfde artikelnummer: ' + esc(nr),
            u: 'Gebruikt bij ' + esc(lijst.join(' en ')) + '. Elk kaartje hoort een eigen nummer te hebben, anders lopen je voorraad en je boekhouding door elkaar.' });
        }
      });

      if (!m.length) m.push({ k: 'goed', t: 'Alles ziet er goed uit.', u: events.length + ' evenementen binnengekregen, elk met een eigen kaartjesproduct dat in de webshop staat, voorraden die kloppen met het aantal plekken, eigen artikelnummers en prijzen die kloppen met de prijstrap.' });

      // De opmaak staat hier in het element zelf en niet in het stijlblad. Dit
      // kadertje moet er ook goed uitzien als een andere regel uit het thema
      // ertussen komt; het is een controlemiddel en geen sierstuk.
      var RAND = { fout: '#C4453C', let: '#D9A441', goed: '#5E8C61' };
      var box = document.createElement('div');
      box.setAttribute('style', 'display:block;width:100%;box-sizing:border-box;border:2px dashed #B4846C;border-radius:12px;background:#FBF3EE;padding:14px 16px;margin:0 0 20px');
      box.innerHTML =
        '<p style="display:block;font-size:11.5px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#8A5A3E;margin:0 0 10px">Controle &mdash; dit ziet alleen jij</p>' +
        m.map(function (x) {
          return '<div style="display:block;width:100%;box-sizing:border-box;padding:9px 12px;border-radius:8px;margin:0 0 7px;background:#fff;border-left:4px solid ' + (RAND[x.k] || '#CFE0E8') + '">' +
            '<strong style="display:block;font-size:13.5px;color:#16384A;margin:0 0 2px;line-height:1.35">' + x.t + '</strong>' +
            '<span style="display:block;font-size:12.5px;color:#5A6B62;line-height:1.5">' + x.u + '</span></div>';
        }).join('') +
        '<p style="display:block;font-size:11.5px;color:#8A7A6E;margin:10px 0 0">Dit kadertje verschijnt door <code style="background:#fff;padding:1px 5px;border-radius:4px">?check=1</code> achter het webadres te zetten. Bezoekers zien het nooit.</p>';
      var site = root.querySelector('.kmsite');
      if (site) site.insertBefore(box, site.firstChild);
    }
    controlePaneel();

    // Deep-link: open de pop-up direct bij ?event=handle
    if (soloMode) {
      var solo = events.filter(function (e) { return e.id === soloHandle; })[0];
      if (solo) {
        openModal(solo);
      } else {
        // De voorstelling staat niet (meer) in de lijst - bijvoorbeeld omdat hij
        // op concept staat. Dan liever een duidelijke regel dan een lege pagina.
        modalContent.innerHTML = '<p class="kmsolo-weg">Deze voorstelling staat niet meer in de agenda. ' +
          '<a href="/pages/agenda">Bekijk wat er nu op de planning staat</a>.</p>';
      }
    } else {
      var dl = location.search.match(/[?&]event=([^&]+)/);
      if (dl) { var target = events.filter(function (e) { return e.id === decodeURIComponent(dl[1]); })[0]; if (target) openModal(target); }
    }
  }

  // ── de uitleg over je gegevens als venster ──────────────────────────────────
  // Carolien, 14 september: de link onder het wachtlijstformulier opende een nieuw tabblad,
  // en dan ben je het formulier kwijt dat je net aan het invullen was. Nu komt de uitleg in
  // een venster over de pagina heen, zodat je blijft waar je bent.
  //
  // De pagina wordt in een venstertje geladen en niet uit elkaar geplukt: welke opmaak een
  // Shopify-pagina heeft verschilt per thema, en dan sta je elke themawijziging weer iets
  // te repareren. Zo werkt hij ook als de tekst op die pagina verandert.
  //
  // Kan de browser geen venster (heel oud), dan gebeurt er gewoon wat er eerst gebeurde:
  // de link opent zelf. Nooit stilstaan bij zo'n knop.
  function uitlegVenster(adres) {
    if (!window.HTMLDialogElement) return false;
    var oud = document.getElementById('kmwl-uitleg');
    if (oud) oud.remove();
    var d = document.createElement('dialog');
    d.id = 'kmwl-uitleg';
    d.className = 'kmwl-dialoog';
    d.innerHTML =
      '<div class="kmwl-dialoog__kop">' +
      '<span>Wat we met je gegevens doen</span>' +
      '<button type="button" class="kmwl-dialoog__sluit" aria-label="Sluiten">&times;</button>' +
      '</div><iframe title="Wat we met je gegevens doen"></iframe>';
    d.querySelector('iframe').src = adres;
    d.querySelector('.kmwl-dialoog__sluit').addEventListener('click', function () { d.close(); });
    // Buiten het venster klikken sluit het ook. Een dialog vangt die klik zelf op, dus je
    // moet kijken of de klik buiten het vlak van het venster viel.
    d.addEventListener('click', function (e) {
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
        d.close();
      }
    });
    d.addEventListener('close', function () { d.remove(); });
    document.body.appendChild(d);
    d.showModal();
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wl-uitleg]');
    if (!a) return;
    if (uitlegVenster(a.getAttribute('href'))) e.preventDefault();
  });

  function boot() { document.querySelectorAll('[data-km-agenda]').forEach(initAgenda); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

// Brede logo's (zoals het Papagenohuis, 4 keer zo breed als hoog) worden in een vak op maat piepklein.
// Ze krijgen de klasse km-logo-breed, zodat de stylesheet ze meer ruimte kan geven (2-10-2026).
(function () {
  var PLEKKEN = '.kmkleinlogo img, .kmmuur-tegel img, .kmv-waarlogo, .kmklogos img';
  function check(img) {
    if (!img.matches || !img.matches(PLEKKEN) || !img.naturalWidth) return;
    var breed = img.naturalWidth / img.naturalHeight >= 2.6;
    img.classList.toggle('km-logo-breed', breed);
    img.classList.toggle('km-logo-rond', img.naturalWidth / img.naturalHeight <= 1.3);
    if (img.parentElement) img.parentElement.classList.toggle('km-logo-breed-vak', breed);
  }
  document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') check(e.target); }, true);
  new MutationObserver(function () {
    document.querySelectorAll(PLEKKEN).forEach(function (img) { if (img.complete) check(img); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
